import React, { useState, useEffect } from 'react';
import './App.scss';

import { HashRouter as Router, Switch, Route, Link, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { History } from 'history'

import { Card, Divider,Elevation, FormGroup, AnchorButton, Button, Navbar, Alignment, Popover, Menu, MenuDivider, MenuItem, type MenuItemProps, Position, Intent, Spinner, Switch as BPSwitch, Tooltip} from "@blueprintjs/core";
import { Suggest, type ItemRenderer, type ItemPredicate } from '@blueprintjs/select';
import Draggable from 'react-draggable';

import './gsbx.scss';
import Login, { LoginCredential } from './Login';
import ClMastMain from './ClMast';
import ClACListMain from './ClACList';
import ContractRenewListMain from './ContractRenewList';
import ChangeRunnerCodeMain from './ChangeRunnerCode';
import ChangeCommIntCodeMain from './ChangeCommIntCode';
import ClSBtoFinMain from './ClSBtoFin';
import StkSBtoFinMain from './StkSBtoFin';

import ClACListSfcMain from './ClACListSfc';
import ClACBalXlsMain from './ClACBalXls';

import ClDocSetMain from './ClDocSet';

import ClLogMain from './ClLog';
import ImportClMast2Main from './ImportClMast2';
import ImportClMast3Main from './ImportClMast3';    // 20230814
import ImportClMast1Main from './ImportClMast1';  //20240312

import ImportHKIDRMast1Main from './ImportHKIDRMast1';  //20260820


import SmMastMain from './SmMast';
import SmListMain from './SmList';
import SmLogMain from './SmLog';
import ImportStkMastMain from './ImportStkMast';    // 20230814
import ImportStkMast2Main from './ImportStkMast2';  // 20230828
import ImportStkMast3Main from './ImportStkMast3';
import ImportStkMastNilMain from './ImportStkMastNil';  // 20230829
import ImportStkMastMarginRatioMain from './ImportStkMastMarginRatio';  // 20230829
import ImportStkMastGroupMain from './ImportStkMastGroup';  // 20230829
import ImportNewlyWarrantCBBCMain from './ImportNewlyWarrantCBBC';
import ImportExpiringWarrantCBBCMain from './ImportExpiringWarrantCBBC';
import ImportStkMcd_mbMain from './ImportStkMcd_mb';
import StkTradingStatisicsMain from './StkTradingStatisics';
import StkTradingStatisicsRptMain from './StkTradingStatisicsRpt';
import BkMastMain from './BkMast';
import BkLogMain from './BkLog';
import IntRMastMain from './IntRMast';
import PrimeRateMastMain from './PrimeRateMast';
import IntRMastListMain from './IntRMastList';
import IntRLogMain from './IntRLog';
import CCASSRptMain from './CCASSRpt';
import ImportCCASSxRptMain from './ImportCCASSxRpt';
 
import HolidayMastMain from './holidayMast';
import HolidayMastListMain from './HolidayMastList';
import ImportMHolidayMain from './ImportMholiday';
//import HolidayHkToCnyMain from './HolidayHkToCny';


import CommMastMain from './CommMast';
import CommLogMain from './CommLog';
import MktMastMain from './MktMast';
import MktLogMain from './MktLog';
import MktFeeMastMain from './MktFeeMast';
import MktFeeLogMain from './MktFeeLog';

import MultiBankMastMain from './MultiBankMast';
import MultiBankMastListMain from './MultiBankMastList';
import MultiBankLogMain from './MultiBankLog';

import ExchangeRateMain from './ExchangeRate';
import ExchangeRateListMain from './ExchangeRateList';

import StdInstSetupMain from './StdInstSetup';
import StdMastMain from './StdMast';
import StdMastListMain from './StdMastList';
import StdMastLogMain from './StdMastLog';
import ConfirmRenewStdInstMain from './ConfirmRenewStdInst';

import AcStatusMain from './AcStatus';
import ChannelMain from './Channel';
import CategoryMain from './Category';

import DayStartProcMain from './DayStartProc';
import ClientTranEntryMain from './ClientTranEntry';
import ClientTranCheckListMain from './ClientTranCheckList';
import ClientTranCheckList2Main from './ClientTranCheckList2';
import CalTradeMain from './CalTrade';
import CalculateTradeRegisterMain from './CalculateTradeRegister';
import ClientTranLogMain from './ClientTranLog';
import ClientInterestAccruedMain from './ClientInterestAccrued';    // 20230823
import ClientInterestAccruedRptMain from './ClientInterestAccruedRpt';  // 20230823
import ClientTranClearMain from './ClientTranClear';
import BrokerTranEntryMain from './BrokerTranEntry';
import BrokerTranCheckListMain from './BrokerTranCheckList';
import BrokerTranLogMain from './BrokerTranLog';
import BrokerInterestAccruedMain from './BrokerInterestAccrued';    // 20230823
import BrokerInterestAccruedRptMain from './BrokerInterestAccruedRpt';    // 20230823
import BrokerTranClearMain from './BrokerTranClear';
import PayRecTranEntryMain from './PayRecTranEntry';
import PayRecTranCheckListMain from './PayRecTranCheckList';
import PayRecCheqMain from './PayRecCheq';
import PayRecTranLogMain from './PayRecTranLog';
import ChrgPortfolioFeeMain from './ChrgPortfolioFee';
import ChrgCCASSPortfolioFeeMain from './ChrgCCASSPortfolioFee';
import ChrgCCASSMembershipFeeMain from './ChrgCCASSMembershipFee';
import Conv_Int2BalMain from './Conv_Int2Bal';
import PayRecTranClearMain from './PayRecTranClear';
import StkDepWithTranEntryMain from './StkDepWithTranEntry';
import StkDepWithTranCheckListMain from './StkDepWithTranCheckList';
import StkDepWithTranLogMain from './StkDepWithTranLog';
import StkDepWithClearMain from './StkDepWithClear';
import StkGlobalWithdrawalMain from './StkGlobalWithdrawal';
import ClientTranSettlementEntryMain from './ClientTranSettlementEntry';
import ClientTranSettlementCheckListMain from './ClientTranSettlementCheckList';
import ClientTranSettlementLogMain from './ClientTranSettlementLog';
import StockAllocationEntryMain from './StockAllocationEntry';
import StockAllocationRptMain from './StockAllocationStatusRpt';
import MatchingMain from './Matching';
//import ShareTransGenErMain from './ShareTransGenEr'
import MatchingReportMain from './MatchingReport';
import CancelPrevTradeMain from './CancelPrevTrade';
import CorrectTradeMain from './CorrectTrade'; 

import CancelCorrectTradeRegisterMain from './CancelCorrectTradeRegister';
import CancelCorrectTradeLogMain from './CancelCorrectTradeLog';

import Sas_Rpt1Main from './Sas_Rpt1';
import Sas_Rpt2Main from './Sas_Rpt2';
import Sas_Rpt3Main from './Sas_Rpt3';
import Sas_Rpt4Main from './Sas_Rpt4';
import Sas_Rpt5Main from './Sas_Rpt5';

import Ati_Rpt1Main from './Ati_Rpt1';
import Ati_Rpt2Main from './Ati_Rpt2';
import Ati_Rpt3Main from './Ati_Rpt3';
import Ati_Rpt4Main from './Ati_Rpt4';
import Ati_Adj1Main from './Ati_Adj1';

import Eps_Rpt1Main from './Eps_Rpt1';
import Eps_Rpt2Main from './Eps_Rpt2';

import ImportMain from './Import';

import PreDayEndProcMain from './PreDayEndProc';
import Cheque2ClientMain from './Cheque2Client';
import PrintClientChqRegisterMain from './PrintClientChqRegister';
import DayEndProcMain from './DayEndProc';
import DayEndProc2Main from './DayEndProc2';


import StkOverdrawnRptMain from './StkOverdrawnRpt';
import StkHoldListMain from './StkHoldList';
import StkHoldList_StressTestMain from './StkHoldList_StressTest';
import StkHoldListSfcMain from './StkHoldListSfc';
import StkHoldListSfc2Main from './StkHoldListSfc2';
import StkHoldXlsMain from './StkHoldXls';        //20231107 Bug4387 Quot11532
import StkHaircutXlsMain from './StkHaircutXls';  //20231128 Bug4387 Quot11532
import PortfolioEvaluationMain from './PortfolioEvaluation';
import PortfolioEvaluation2Main from './PortfolioEvaluation2';
import AcBalListMain from './AcBalList';
import MgnPositionMain from './MgnPosition';
import MgnPosition_StressTestMain from './MgnPosition_StressTest';
import ApprovedStockAssetsReportMain from './ApprovedStockAssetsReport';
import ApprovedStockAssetsReport_StressTestMain from './ApprovedStockAssetsReport_StressTest';
import TradingLimitRptMain from './TradingLimitRpt';
import RollingBalanceReportMain from './RollingBalanceReport';
import CashAgingAnalysisMain from './CashAgingAnalysis';
import UnsettleTranAcceptValueMain from './UnsettleTranAcceptValue';
import CashContraSummaryMain from './CashContraSummary';

import TopmostBalanceListMain from './TopmostBalanceList';
import TopmostBalanceList_StressTestMain from './TopmostBalanceList_StressTest';
import TopmostBalanceList2Main from './TopmostBalanceList2';
import MarginCallRpt1Main from './MarginCallRpt1';
import MarginCallRpt2Main from './MarginCallRpt2';
import MarginCallRpt2LogMain from './MarginCallRpt2Log';
import MarginCallRpt3Main from './MarginCallRpt3';
import MarginCallRpt4Main from './MarginCallRpt4';
import MktValueStressTestMain from './MktValueStressTest';
import RelatedClBankGuarRptMain from './RelatedClBankGuarRpt';

import ClHistoryMain from './ClHistory';
import ClHistory2Main from './ClHistory2';
import ClHistorySfcMain from './ClHistorySfc';

import MthRebateRptMain from './MthRebateRpt';
import MthContractStmpRptMain from './MthContractStmpRpt'; //(85)
import MthStmpReturnRptMain from './MthStmpReturnRpt';
import MthInterestRptMain from './MthInterestRpt';
import MthLevyCCassFeeRptMain from './MthLevyCcassFeeRpt';

import ClientPosEnquiryMain from './ClientPosEnquiry';

import MthSummaryRptMain from './MthSummaryRpt';
import MthCCassCustodyFeeRptMain from './MthCCassCustodyFeeRpt';

import ClientTurnOverRptMain from './ClientTurnOverRpt';

import AccInfoMain from './AccInfo';
import DviewMain from './Dview';    // AD VIEW1 show addr 
import Dview2Main from './Dview2';  // AD VIEW no show addr
 
import DviewTransDateMain from './DviewTransDate';

import DviewDownMain from './DviewDown';
//import DviewOutMain from './DviewOut';

import DvStkHolderListMain from './DvStkHolderList';
import DvStkHolderList2Main from './DvStkHolderList2';

import DvDividendMain from './DvDividend';
 
import DvStkAllocStatusMain from './DvStkAllocStatus';  //AD8 Dview

import DstatementMain from './Dstatement';
import DstatementPrePrintMain from './DstatementPrePrint';
import MstatementMain from './Mstatement';
import Mstatement2Main from './Mstatement2';
import StatementAEMain from './StatementAE';
import SentStatementMain from './SentStatement';
import SendBroadcastEmailMain from './SendBroadcastEmail';
import LevyRptMain from './levyRpt';

 
import CBBCProcessMain from './CBBCProcess';
import CBBCCallMgnt from './CBBCCallMgnt';
import CBBCStkWithDrawalMain from './CBBCStkWithDrawal';
import CBBCDepositResidualMan from './CBBCDepositResidual';
import CBBCClearHistoryMain from './CBBCClearHistory';
import CBBCConfigMain from './CBBCConfig';

import StockAnnouncementEntryMain from './StockAnnouncementEntry';
import StockAnnouncementLogMain from './StockAnnouncementLog';
import BookCloseReminderMain from './BookCloseReminder';
import MktDividendChargeMain from './MktDividendCharge';
import DividendProcessMain from './DividendProcess';
import DividendProcess02Main from './DividendProcess02';
import DividendProcess03Main from './DividendProcess03';
import DividendProcess04Main from './DividendProcess04';
import WarrantRightsProcessMain from './WarrantRightsProcess';
import WarrantRightsProcess02Main from './WarrantRightsProcess02';
import WarrantRightsProcess03Main from './WarrantRightsProcess03';
import BookClosedQtyMain from './BookClosedQty';
import ImportAnnouncementMain from './ImportAnnouncement';

import SLSetupMain from './SLSetup';
import SLMastMain from './SLMast';
import SLMastLogMain from './SLMastLog';
import SLTranMain from './SLTran';
import SLTranListMain from './SLTranList';
import SLTranLogMain from './SLTranLog';

import SLStkStatusReportMain from './SLStkStatusReport';


import IPOMastMain from './IPOMast'
//import IPOMastImportMain from './IPOMastImport';
//import FiniMast from './IPOEntry';
import IPOEntryMain from './IPOEntry';
import IPOLogMain from './IPOLog';
//import IPOPurgeMain from './IPOPurgeIPO';
import IPORefundChqMain from './IPORefundChq';
import IPOPurgeMain from './IPOPurge';
import ExportWebStmt1Main from './ExportWebStmt';

import SBReindexMain from './SBReindex';
import ReUpdateTrnMain from './ReUpdateTrn';
import DataIntegrityCheckMain from './DataIntegrityCheck';
import SBBackupMain from './SBBackup';
import SBBatchMain from './SBBatch';
import SBBatch2Main from './SBBatch2';
import SBBatch3Main from './SBBatch3';
import SBBatch4Main from './SBBatch4';
import SBBatch10Main from './SBBatch10';
import SBBatch5Main from './SBBatch5';
import SBBatch11Main from './SBBatch11';
import SBBatch12Main from './SBBatch12';
import LoginLogMain from './LoginLog';
import ResetprocessMain from './Resetprocess';
import SBstatusMain from './SBstatus';
import {SBstatusMini} from './SBstatus';
import SBModuleMain from './SBModule';
import UserMastMain from './UserMast';
import UserMastListMain from './UserMastList';
import UserMastLogMain from './UserMastLog';
import UserchgPasswdMain from './UserchgPasswd';
import UserchgPasswd2Main from './UserchgPasswd2';
import UserchgPasswd3Main from './UserchgPasswd3';
import UserAccessGroupMain from './UserAccessGroup';
import UserPgmAccessMain from './UserPgmAccess';
import UserPgmAccessListMain from './UserPgmAccessList';
import UserPgmAccessLogMain from './UserPgmAccessLog';
import GroupAccessMain from './GroupAccess';
import GroupAccessListMain from './GroupAccessList';
import GroupAccessLogMain from './GroupAccessLog';
import GroupAccess02Main from './GroupAccess02';
import ReqAuthListMain from './ReqAuthList';
import AboutMain from './About';
import TempChgFieldMain from './TempChgField';
import PurgeOutDatedDataMain from './PurgeOutDatedData';



import HkCrsImpAccountMain from './HkCrsImpAccount';
import HkCrsMastMain from './HkCrsMast';
import HkCrsMastListMain from './HkCrsMastList';
import HkCRSLogMain from './HkCRSLog';

import HkCRSDLogMain from './HkCRSDLog';

import HkCrsDataMastMain from './HkCrsDataMast';
import HkCrsDataImpAccountMain from './HkCrsDataImpAccount';
import HkCrsExportMain from './HkCrsExport';
import HkCrsEnquiryMain from './HkCrsEnquiry';

//Fatca
import FatcaNilExportMain from './FatcaNilExport';
//Hkidr
import HkidrImpAccountMain from './HkidrImpAccount';
import HkidrMastMain from './HkidrMast';
import HkidrMastListMain from './HkidrMastList';
import HkidrLogMain from './HkidrLog';
import GsbNameChangeLogMain from './GsbNameChangeLog';
import CNBcanGenMain from './CNBcanGen';
import ExportHkConsentMain from './HkidrMastExport';
import ImportHkConsentCsvMain from './ImportHkConsentCsv';

import HkidrHkConsentMain from './HkidrHkConsent';
import HkidrBcanMappingMain from './HkidrBcanMapping';
import HkidrResponseFileMain from './HkidrResponseFile';

//CNINA CONNECT
import CNBcanMappingMain from './CNBcanMapping';

import CNBcanResponseFileMain from './CNBcanResponseFile';
import CNBcanAurpResponseFileMain from './CNBcanAurpResponseFile';
import CNBcanFimgFileMain from './CNBcanFimgFile';
import CNBcanRsltResultFileMain from './CNBcanRsltResultFile';

//CCR
import CCRConfigMain from './CCRConfig';      //CCR Configuration 
import CCRMailListMain from './CCRMailList';  //MAINTAIN SPECIAL MAILING LIST
import ClientUploadEntryMain from './CCRClientUploadEntry';
 
import StkRecordDateMain from './CCRStkRecord';

import CCRGenRecDateMain from './CCRGenRecDate';
import CCRGenStkOnHandMain from './CCRGenStkOnHand';

import CCRAuditLogMain from './CCRAuditLog';

//OTCR
import HkidrOtcrMain from './HkidrOtcr';
import HkidrOtcr2Main from './HkidrOtcr2';

/*
---- IPO Application Period ---- 
*/

import IPOApplicationRptMain from './IPOApplicationRpt';

// EXPORT FINI IPO  to upload 
import IPOExportFINIMain from './IPOExportFINI';
// Export IBOND FILE TO CCASS

import IPOExportIBONDMain from './IPOExportIBOND';
//IPO Pre-Payment
import IPOPrePayMain from './IPOPrePay';

//FINI PO AllotmentResultFile
import IPOImportAllotmentMain from './IPOImportAllotment';
import IPOInputAllotmentResultMain from './IPOInputAllotmentResult';

//FINI read  AuthorisedMain
import IPOFINIAuthorisedFileMain from './IPOFINIAuthorisedFile' ;
 

//IPO Listing Report   
import IPOListingRptMain from './IPOListingRpt';

//1 Generate IPO Stock Transactions to SB
//2 & Cash Transaction  & CHQ Transactions to SB
import IPOStkTransactionsToSBMain from './IPOStkTransactionsToSB';
import IPOStkCashChqToSBMain from './IPOStkCashChqToSB';
//import HkidrOtcrResponseFileMain from './HkidrOtcrResponseFile';

/*
Placing 
*/
import PlacingMastMain from './PlacingMast';
import PlacingMastLogMain from './PlacingMastLog';

import HkidrProcessResultFileMain from './HkidrProcesssResultFile';
import HkidrFullImageFileMain from './HkidrFullImageFile';
 
import HkidrETTradeListMain from './HkidrETTradeList';
import HkidreBrokerListMain from './HkidreBrokerList';
import HkidrAyersListMain from './HkidrAyersList';
import HkidrInfocastListMain from './HkidrInfocastList';

import GsbxConfigMain from './GsbxConfig';
import GLConfigMain from './GLConfig';
import SiConfigMain from './SiConfig';
import BcanConfigMain from './BcanConfig';
import CrsConfigMain from './CrsConfig';



//for FBSx user
import FBSMarketMastMain from './fbs/MarketMast';
import FBSComdyMastMain from './fbs/ComdyMast';
import FBSComdyListMain from './fbs/ComdyList';
import FBSExpiryMastMain from './fbs/ExpiryMast';
import FBSClMastMain from './fbs/ClMast';
import FBSClListMain from './fbs/ClList';
import FBSClLogMain from './fbs/ClLog';
import FBSCbMastMain from './fbs/CbMast';
import FBSOpenPosMain from './fbs/OpenPos';
import FBSCommMastMain from './fbs/CommMast';
import FBSCommListMain from './fbs/CommList';
import FBSCommLogMain from './fbs/CommLog';
import FBSCCYMastMain from './fbs/CCYMast';
import FBSDayStartProcMain from './fbs/DayStartProc';
import FBSDayEndProcMain from './fbs/DayEndProc';
import FBSPositionMakeupMain from './fbs/PositionMakeup';
import FBSRecalcMarginProcMain from './fbs/RecalcMarginProc';
import FBSCCYParamUpdateMain from './fbs/CCYParamUpdate';
import FBSClosingUpdateMain from './fbs/ClosingUpdate';
import FBSClientTranEntryMain from './fbs/ClientTranEntry';
import FBSClientTranCheckListMain from './fbs/ClientTranCheckList';
import FBSClientTranLogMain from './fbs/ClientTranLog';
import FBSFundMoveTranEntryMain from './fbs/FundMoveTranEntry';
import FBSFundMoveTranCheckListMain from './fbs/FundMoveTranCheckList';
import FBSFundMoveTranLogMain from './fbs/FundMoveTranLog';

import OptionTradeEntryMain from './fbs/OptionTradeEntry';

import Fbs_DstatementMain from './fbs/Dstatement';
import Fbs_MstatementMain from './fbs/Mstatement';
import Fbs_SentStatementMain from './fbs/SentStatement';
import Fbs_SendBroadcastEmailMain from './fbs/SendBroadcastEmail';

import Fbs_DailyTradingRptMain from './fbs/DailyTradingRpt';
import Fbs_CashSettleRptMain from './fbs/CashSettleRpt';
import Fbs_ClosePositionRptMain from './fbs/ClosePositionRpt';
import Fbs_FundMoveRptMain from './fbs/FundMoveRpt';
import Fbs_OpenPositionRptMain from './fbs/OpenPositionRpt';
import Fbs_CommRebateRptMain from './fbs/CommRebateRpt';
import Fbs_CommRebateRpt2Main from './fbs/CommRebateRpt2';
import Fbs_ExceptMgnRptMain from './fbs/ExceptMgnRpt';
import Fbs_AcctEqMgnRptMain from './fbs/AcctEqMgnRpt';
import Fbs_AcctSumRptMain from './fbs/AcctSumRpt';
import Fbs_MgnCallRptMain from './fbs/MgnCallRpt';
import Fbs_MthTradingRptMain from './fbs/MthTradingRpt';

import Fbs_SettleSummaryRptMain from './fbs/SettleSummaryRpt';
import Fbs_FormIVEntryMain from './fbs/FormIVEntry';


import FbsxConfigMain from './fbs/FbsxConfig';
import Fbs_ReindexMain from './fbs/Reindex_Fbs';
import Fbs_BackupMain from './fbs/FbsBackup';
import FBSBatchMain from './fbs/FBSBatch';
import FBSBatch60Main from './fbs/FBSBatch60';

import Fbs_ReqAuthListMain from './fbs/ReqAuthList';
import Fbs_PurgeOutDatedDataMain from './fbs/PurgeOutDatedData';
import {FBSStatusMini} from './fbs/FBSStatus';


//for OBx_USER
import FBSSmMastMain from './fbs/SmMast';


import TaskMain from './Task';
import WIPMain from './WIP';
import ClMast2Main from './ClMast2';
import * as utils from "./utils";

import md5 from './md5'

import axios from 'axios';

import svgLogo from './svg/logo.svg'
//import svgLogo from './svg/plogo.gif'
import svgAccount from './svg/client.svg'
import svgMaster from './svg/Master.svg'
//import svgDocument from './svg/document.svg'
import svgDocument from './svg/Circle-icons-document.svg'
import svgFileBox from './svg/file-box.svg'
import svgProfit from './svg/profit.svg'
import svgMoney from './svg/money.svg'
import svgFinancialreport from './svg/financial-report.svg'

//import svgDownload from './svg/download.svg'
import svgDownload from './svg/download1.svg'
import svgZip from './svg/zip.svg'
import zipDocument from './svg/zip.svg'
import svgImport from './svg/import.svg'
import svgUser from './svg/user.svg'
import svgInput from './svg/input.svg'
import svgTask from './svg/task.svg'
import svgChecklist from './svg/checklist.svg'
import svgbuild from './svg/build.svg'
import svgsort_asc from './svg/sort-asc.svg'
import tick_circle from './svg/checked.svg'
import svgFilingOK from './svg/filing-ok.svg'
import svgStart from './svg/start.svg'
import svgCalculating from './svg/calculating.svg'

import i18next from 'i18next';
import { PgmAccessList } from './Types'
import { SystemHeader, MenuSuggest } from './CommonUI';

var GsbFlag: any;

const gsb = axios.create({
    //baseURL: 'http://localhost:8000',
    //baseURL: process.env.NODE_ENV === "development" ? 'http://localhost:8000/api' : '/api',
    baseURL: process.env.NODE_ENV === "development" ? `http://${window.location.hostname}:8000/api` : '/api',
})

//const hostId = process.env.NODE_ENV === "development" ? md5('localhost:8000').slice(-8) : md5(window.location.host).slice(-8)
const hostId = process.env.NODE_ENV === "development" ? md5(`${window.location.hostname}:8000`).slice(-8) : md5(window.location.host).slice(-8)

// try load config from server, can be a real file or a config in web server
/*
axios.get("config.json").then((res) => {
    //console.log("load config.json from server", res.data)
    gsb.defaults.baseURL = res.data.baseUrl
}).catch(() => {
    // do nothing, use default
})
*/

var GSB_Sys_VerNo = "";

function App() {

 

    const pingServer = () => {
        (async () => {
            try {
                //console.log("app GSB_Sys_VerNo", GSB_Sys_VerNo)
                const res =await gsb.post('/ping',
                    {});
                //console.log("app pingServer", res.data, res.data.Sys_VerNo)
                if ( GSB_Sys_VerNo == "" ) {
                    GSB_Sys_VerNo = res.data.Sys_VerNo
                } else if ( GSB_Sys_VerNo == res.data.Sys_VerNo ) {

                } else {
                    //console.log("app pingServer reloaded")
                    window.location.reload()
                }

            } catch (error) {
                //utils.showError(error)
                //console.log(error)
            }
        })()
    }

    useEffect(() => {
        pingServer()
        const worker = new Worker('worker.js')
        worker.onmessage = () => {
            pingServer()
        }
        return () => worker.terminate()
    }, [])


    window.onkeydown = (e: KeyboardEvent) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // disable ctrl + s to prevent save page when user trying to submit form while lost focus
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
        }
    }
    const [IPAddr, setIPAddr] = useState("")
    const [userId, setuserId] = useState("")

/*
    useEffect(() => {
        (async () => {
            try {
                const response = await fetch('http://api.ipify.org/?format=json')
                const dataIP = await response.json();
                setIPAddr(dataIP["ip"])
                //console.log("App  IPAddr: ", data["ip"])    
            } catch (error) {
                utils.showError(error)
            }
        })() 
    }, [gsb])
*/

    const handleLogin = (credential: LoginCredential, history: History) => {
        (async () => {
            try {
                const res = await gsb.post('/login',
                    {
                        userId: credential.login,
                        password: credential.password,
                        cIPAddr: IPAddr,
                    });
                if (res.data.ok) {
                    if (! res.data.chg_passwd) {
                        //console.log('Bearer '+res.data.token)
                        gsb.defaults.headers.common["Authorization"] = 'Bearer ' + res.data.token
                        localStorage.setItem('token', res.data.token)
                        document.cookie = `token_${hostId}=${res.data.token}`
                        setisLoggedIn(true)
                        // if ( GSBx_USER ) {
                        //     setShowStatus(true) ;
                        // } else if ( isFBSx ) {
                        //     setFBSshowStatus(true) ;
                        // }
                        setuserId(credential.login)
                        if (res.data.message.trim().length > 0 ) {
                            utils.showError(res.data.message)
                        }
                        history.push("/")
                    } else {
                        setisLoggedIn(false)
                        setuserId(credential.login)
                        if (res.data.message.trim().length > 0 ) {
                            utils.showError(res.data.message)
                        }
                        history.push("/UserchgPasswd3?UserId="+credential.login+"&PassId="+res.data.PassId)
                    }
                } else {
                    //console.log(res.data)
                    utils.showError(res.data.message)
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }

    const handleLogout = () => {
        (async () => {
            try {
                const res = await gsb.post('/logout',
                {
                    cIPAddr: IPAddr,
                });
            } catch (error) {
                utils.showError(error)
            }
        })()

        delete gsb.defaults.headers.common["Authorization"]
        localStorage.removeItem('token')
        document.cookie = `token_${hostId}=; expires=Thu, 01 Jan 1970 00:00:00 UTC;`
        setisLoggedIn(false)
    }

/*    
    const token = localStorage.getItem('token')
    let initIsLoggedIn = false
    if (token) {
        gsb.defaults.headers = {
            'Authorization': 'Bearer ' + token
        }
        document.cookie = `token=${token}`
        initIsLoggedIn = true
    }
*/

    let initIsLoggedIn = false

    useEffect(() => {
        //console.log("useEffect []");
        const token = localStorage.getItem('token')
        if (token) {
            /*
            svc.defaults.headers = {
                'Authorization': 'Bearer ' + token
            }
            */
            gsb.defaults.headers.common["Authorization"] = 'Bearer ' + token
            document.cookie = `token_${hostId}=${token}`
            setisLoggedIn(true);
            initIsLoggedIn = true
        }
    }, [])


    const [isLoggedIn, setisLoggedIn] = useState(initIsLoggedIn)
    const [showStatus, setShowStatus] = useState(false)
    const [FBSshowStatus, setFBSshowStatus] = useState(false)

    const [PgmLists, setPgmLists] = useState([] as PgmAccessList[])
    const [RecordPgmName, setRecordPgmName] = useState("")

    const [CO_NAME, setCO_NAME] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [GSBx_USER, setGSBx_USER] = useState(false)
    const [GSBce_USER, setGSBce_USER] = useState(true)
    const [HKIDR_USER, setHKIDR_USER] = useState(false)
    const [RAP_VIEWER_USER, setRAP_VIEWER_USER] = useState(false)
    const [isFBSx, setIsFBSx] = useState(false)
    const [FBSx_USER, setFBSx_USER] = useState(false)

    const [ATI_USER, setATI_USER] = useState(false)
    const [CM2K_USER, setCM2K_USER] = useState(false)
    
    const [CCOMM_UPL,setCCOMM_UPL] = useState(false)
    const { t, i18n } = useTranslation();    

    const [stmtEncode, setstmtEncode] = useState("N")
 
    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag0');
                //console.log("App disp user_key: ", res.data.Flag.user_key)
                GsbFlag = res.data.Flag;
                //console.log("App disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                setGSBx_USER(GsbFlag.GSBx_USER) ;
                setGSBce_USER(GsbFlag.GSBce_USER) ;
                setHKIDR_USER(GsbFlag.HKIDR_USER) ;
                setRAP_VIEWER_USER(GsbFlag.RAP_VIEWER_USER) ;
                setIsFBSx(GsbFlag.isFBSx);
                setFBSx_USER(GsbFlag.FBSx_USER);
                setCM2K_USER(GsbFlag.CM2K_USER);
                setCCOMM_UPL(GsbFlag.CCOMM_UPL);
            
                setATI_USER(GsbFlag.ATI_USER);
                setstmtEncode(GsbFlag.stmtEncode);

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])


    useEffect(() => {
        if ( isLoggedIn ) {
            (async () => {
                try {
                    // get GsbFlag from SB.XBS
                    const res = await gsb.post('/GsbFlag');
                    setPgmLists(res.data.UserPgmListData)
                    //console.log("App PgmLists", PgmLists)
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, isLoggedIn])


    useEffect(() => {
        //console.log("App RecordPgmName ", RecordPgmName)
        if ( isLoggedIn && RecordPgmName.length > 0 ) {
            (async () => {
                try {
                    // get GsbFlag from SB.XBS
                    const res = await gsb.post('/PgmEntry', {
                        cPgmName: RecordPgmName,
                        cIPAddr: "",
                    });
                    setRecordPgmName("")
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, RecordPgmName, isLoggedIn])


    function CheckPgmAccess(PgmName: string): boolean{
        var canAccess = false;
        //console.log("App CheckPgmAccess PgmLists", PgmName, PgmLists)
        //if (PgmName[0] == "F") return true; // TODO - for development purpose, remove when program code list is done

        if ( GSBce_USER || HKIDR_USER ) {
            canAccess = true;
        } else {
            if ( isLoggedIn && PgmLists.length > 0 ) {
                for (let i = 0; i < PgmLists.length; i++) {
                    //console.log("App CheckPgmAccess PgmLists", PgmName, PgmLists[i].d_PgmCode, PgmLists[i].d_PgmAccess)
                    if (PgmLists[i].d_PgmCode === PgmName ) {
                        //console.log("func CheckPgmAccess PgmLists", PgmName, PgmLists[i].d_PgmCode, PgmLists[i].d_PgmAccess)
                        if (PgmLists[i].d_PgmAccess === "Y" ) {
                            canAccess = true;
                        }
                        break ;
                    }
                }
            }
        }
        return canAccess;
    }
    
    let menuBar, menuMain
    if (isFBSx) {
        menuBar = <MenuBar_FBS isLoggedIn={isLoggedIn} onSystemStatusClick={() => setFBSshowStatus(! FBSshowStatus)} />
        menuMain = <SideMenu_FBS isLoggedIn={isLoggedIn} />
    } else if (HKIDR_USER) {
        menuBar = <MenuBar_HKIDR isLoggedIn={isLoggedIn} />
        menuMain = <SideMenu_HKIDR isLoggedIn={isLoggedIn} />
    } else if (GSBce_USER && !GSBx_USER) {
        menuBar = <MenuBar_ce isLoggedIn={isLoggedIn} />
        menuMain = <SideMenu_ce isLoggedIn={isLoggedIn} />
    } else if (GSBx_USER) {
        menuBar = <MenuBar isLoggedIn={isLoggedIn} onSystemStatusClick={() => setShowStatus(!showStatus)} />
        menuMain = <SideMenu isLoggedIn={isLoggedIn} />
    } else if (RAP_VIEWER_USER) {
        menuBar = <MenuBar_CCASS isLoggedIn={isLoggedIn} />
        menuMain = <></>
    }

    return (
        <React.Suspense fallback={<Spinner></Spinner>}>
        <div id="app" className="App">
            <Router>
                {menuBar}
                {/* { HKIDR_USER && <MenuBar_HKIDR isLoggedIn={isLoggedIn} /> }
                { GSBce_USER && GSBx_USER && ! HKIDR_USER && <MenuBar isLoggedIn={isLoggedIn} /> }
                { GSBce_USER && ! GSBx_USER && ! HKIDR_USER && <MenuBar_ce isLoggedIn={isLoggedIn} /> }
                { ! GSBce_USER && GSBx_USER && ! HKIDR_USER && <MenuBar isLoggedIn={isLoggedIn} onSystemStatusClick={() => setShowStatus(!showStatus)} /> }
                { RAP_VIEWER_USER && ! GSBx_USER && <MenuBar_CCASS isLoggedIn={isLoggedIn} /> }
                { FBSx_USER && ! GSBx_USER && <MenuBar_FBS isLoggedIn={isLoggedIn} /> } */}
                <div className="AppBody">
                    <Switch>
                        <Route exact path="/">
                            {isLoggedIn ? menuMain : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        {/* { HKIDR_USER && <Route exact path="/">
                            {isLoggedIn ? <SideMenu_HKIDR isLoggedIn={isLoggedIn} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        }
                        { GSBce_USER && GSBx_USER && ! HKIDR_USER && <Route exact path="/">
                            {isLoggedIn ? <SideMenu isLoggedIn={isLoggedIn} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        }
                        { GSBce_USER && ! GSBx_USER && ! HKIDR_USER && <Route exact path="/">
                            {isLoggedIn ? <SideMenu_ce isLoggedIn={isLoggedIn} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        }
                        { ! GSBce_USER && GSBx_USER && ! HKIDR_USER && <Route exact path="/">
                            {isLoggedIn ? <SideMenu isLoggedIn={isLoggedIn} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        }
                        { RAP_VIEWER_USER && ! GSBx_USER && <Route exact path="/">
                            {isLoggedIn ? " " : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        }
                        { FBSx_USER && ! GSBx_USER && <Route exact path="/">
                            {isLoggedIn ? " " : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        } */}

                        <Route exact path="/login">
                            <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />
                        </Route>
                        <Route path="/accounts/:acCode?">
                            {isLoggedIn && CheckPgmAccess("M0001") ? <ClMastMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/accounts_DocSet/:acCode?">
                            {isLoggedIn && CheckPgmAccess("M0033") ? <ClDocSetMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/ClACList">
                            {isLoggedIn && CheckPgmAccess("M0002") ? <ClACListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ContractRenewList">
                            {isLoggedIn && CheckPgmAccess("M0044") ? <ContractRenewListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ChangeRunnerCode">
                            {isLoggedIn && CheckPgmAccess("M0047") ? <ChangeRunnerCodeMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ChangeCommIntCode">
                            {isLoggedIn && CheckPgmAccess("M0048") ? <ChangeCommIntCodeMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ClSBtoFin">
                            {isLoggedIn && CheckPgmAccess("M0050") ? <ClSBtoFinMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/StkSBtoFin">
                            {isLoggedIn && CheckPgmAccess("M0051") ? <StkSBtoFinMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/ClACListSfc">
                            {isLoggedIn && CheckPgmAccess("M0003") ? <ClACListSfcMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ClLog">
                            {isLoggedIn && CheckPgmAccess("M0004") ? <ClLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ImportClMast2">
                            {isLoggedIn && CheckPgmAccess("M0023") ? <ImportClMast2Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        {/* 20230814 */}
                        <Route path="/ImportClMast3">
                            {isLoggedIn && CheckPgmAccess("M0026") ? <ImportClMast3Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/ImportClMast1">
                            {isLoggedIn && CheckPgmAccess("M0034") ? <ImportClMast1Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        {<Route path="/ImportHKIDRMast1">
                            {isLoggedIn && CheckPgmAccess("M0055") ? <ImportHKIDRMast1Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>}


                        <Route path="/SmMast">
                            {isLoggedIn && CheckPgmAccess("M0007") ? <SmMastMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/SmList">
                            {isLoggedIn && CheckPgmAccess("M0022") ? <SmListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/SmLog">
                            {isLoggedIn && CheckPgmAccess("M0008") ? <SmLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        {/* 20230814 */}
                        <Route path="/ImportStkMast">
                            {isLoggedIn && CheckPgmAccess("M0027") ? <ImportStkMastMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        {/* 20230828 */}
                        <Route path="/ImportStkMast2">
                            {isLoggedIn && CheckPgmAccess("M0028") ? <ImportStkMast2Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ImportStkMast3">
                            {isLoggedIn && CheckPgmAccess("M0049") ? <ImportStkMast3Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        {/* 20230829 */}
                        <Route path="/ImportStkMastNil">
                            {isLoggedIn && CheckPgmAccess("M0029") ? <ImportStkMastNilMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ImportStkMastMarginRatio">
                            {isLoggedIn && CheckPgmAccess("M0030") ? <ImportStkMastMarginRatioMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ImportStkMastGroup">
                            {isLoggedIn && CheckPgmAccess("M0031") ? <ImportStkMastGroupMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ImportNewlyWarrantCBBC">
                            {isLoggedIn && CheckPgmAccess("M0045") ? <ImportNewlyWarrantCBBCMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ImportExpiringWarrantCBBC">
                            {isLoggedIn && CheckPgmAccess("M0046") ? <ImportExpiringWarrantCBBCMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ImportStkMcd_mb">
                            {isLoggedIn && CheckPgmAccess("M0038") ? <ImportStkMcd_mbMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/StkTradingStatisics">
                            {isLoggedIn && CheckPgmAccess("M0038") ? <StkTradingStatisicsMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/StkTradingStatisicsRpt">
                            {isLoggedIn && CheckPgmAccess("M0038") ? <StkTradingStatisicsRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/BkMast">
                            {isLoggedIn && CheckPgmAccess("M0005") ? <BkMastMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/BkLog">
                            {isLoggedIn && CheckPgmAccess("M0006") ? <BkLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/HolidayMast">
                            {isLoggedIn && CheckPgmAccess("M0032") ? <HolidayMastMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/HolidayMastList">
                            {isLoggedIn && CheckPgmAccess("M0032") ? <HolidayMastListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
 
                        <Route path="/ImportMHoliday">
                            {isLoggedIn && CheckPgmAccess("M0032") ? <ImportMHolidayMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        {/*<Route path="/HolidayHkToCny">
                            {isLoggedIn && CheckPgmAccess("M0032") ? <HolidayHkToCnyMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>*/}

                        <Route path="/IntRMast">
                            {isLoggedIn && CheckPgmAccess("M0009") ? <IntRMastMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/IntRMastList">
                            {isLoggedIn && CheckPgmAccess("M0018") ? <IntRMastListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/IntRLog">
                            {isLoggedIn && CheckPgmAccess("M0010") ? <IntRLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/PrimeRateMast">
                            {isLoggedIn && CheckPgmAccess("M0052") ? <PrimeRateMastMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/CommMast">
                            {isLoggedIn && CheckPgmAccess("M0011") ? <CommMastMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/CommLog">
                            {isLoggedIn && CheckPgmAccess("M0012") ? <CommLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/MktMast">
                            {isLoggedIn && ( CheckPgmAccess("M0013") || CheckPgmAccess("OM0013") ) ? <MktMastMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/MktLog">
                            {isLoggedIn && ( CheckPgmAccess("M0014") || CheckPgmAccess("OM0014") ) ? <MktLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/MktFeeMast">
                            {isLoggedIn && ( CheckPgmAccess("M0015") || CheckPgmAccess("OM0015") ) ? <MktFeeMastMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/MktFeeLog">
                            {isLoggedIn && ( CheckPgmAccess("M0016") || CheckPgmAccess("OM0016") ) ? <MktFeeLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/MultiBankMast">
                            {isLoggedIn && CheckPgmAccess("M0019") ? <MultiBankMastMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/MultiBankMastList">
                            {isLoggedIn && CheckPgmAccess("M0020") ? <MultiBankMastListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        {<Route path="/MultiBankLog">
                            {isLoggedIn && CheckPgmAccess("M0021") ? <MultiBankLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>}
                        <Route path="/ExchangeRate">
                            {isLoggedIn && CheckPgmAccess("M0024") ? <ExchangeRateMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ExchangeRateList">
                            {isLoggedIn && CheckPgmAccess("M0025") ? <ExchangeRateListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/StdInstSetup">
                            {isLoggedIn && ( CheckPgmAccess("M0039") || CheckPgmAccess("FM0039") ) ? <StdInstSetupMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/StdMast">
                            {isLoggedIn && ( CheckPgmAccess("M0040") || CheckPgmAccess("FM0040") ) ? <StdMastMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/StdMastList">
                            {isLoggedIn && ( CheckPgmAccess("M0041") || CheckPgmAccess("FM0041") ) ? <StdMastListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/StdMastLog">
                            {isLoggedIn && ( CheckPgmAccess("M0042") || CheckPgmAccess("FM0042") ) ? <StdMastLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ConfirmRenewStdInst">
                            {isLoggedIn && ( CheckPgmAccess("M0043") || CheckPgmAccess("FM0043") ) ? <ConfirmRenewStdInstMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/AcStatus">
                            {isLoggedIn && CheckPgmAccess("M0035") ? <AcStatusMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/Channel">
                            {isLoggedIn && CheckPgmAccess("M0036") ? <ChannelMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/Category">
                            {isLoggedIn && CheckPgmAccess("M0037") ? <CategoryMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/DayStartProc">
                            {isLoggedIn && CheckPgmAccess("T0018") ? <DayStartProcMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ClientTranEntry">
                            {isLoggedIn && CheckPgmAccess("T0001") ? <ClientTranEntryMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ClientTranCheckList">
                            {isLoggedIn && CheckPgmAccess("T0002") ? <ClientTranCheckListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ClientTranCheckList2">
                            {isLoggedIn && CheckPgmAccess("T0002") ? <ClientTranCheckList2Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>


                        <Route path="/CalculateTranRegister">
                            {isLoggedIn && CheckPgmAccess("T0002") ? <CalculateTradeRegisterMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/ClientTranLog">
                            {isLoggedIn && CheckPgmAccess("T0003") ? <ClientTranLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        {/* 20230823 */}
                        <Route path="/ClientInterestAccrued">
                            {isLoggedIn && CheckPgmAccess("T0001") ? <ClientInterestAccruedMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        {/* 20230823 */}
                        <Route path="/ClientInterestAccruedRpt">
                            {isLoggedIn && CheckPgmAccess("T0001") ? <ClientInterestAccruedRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ClientTranClear">
                            {isLoggedIn && CheckPgmAccess("T0001") ? <ClientTranClearMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/CalTrade">
                                {isLoggedIn && CheckPgmAccess("T0001") ? <CalTradeMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>         

               

                        <Route path="/BrokerTranEntry">
                            {isLoggedIn && CheckPgmAccess("T0004") ? <BrokerTranEntryMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/BrokerTranCheckList">
                            {isLoggedIn && CheckPgmAccess("T0005") ? <BrokerTranCheckListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/BrokerTranLog">
                            {isLoggedIn && CheckPgmAccess("T0006") ? <BrokerTranLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        {/* 20230823 */}
                        <Route path="/BrokerInterestAccrued">
                            {isLoggedIn && CheckPgmAccess("T0004") ? <BrokerInterestAccruedMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/BrokerInterestAccruedRpt">
                            {isLoggedIn && CheckPgmAccess("T0004") ? <BrokerInterestAccruedRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/BrokerTranClear">
                            {isLoggedIn && CheckPgmAccess("T0004") ? <BrokerTranClearMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/PayRecTranEntry">
                            {isLoggedIn && CheckPgmAccess("T0007") ? <PayRecTranEntryMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/PayRecTranCheckList">
                            {isLoggedIn && CheckPgmAccess("T0008") ? <PayRecTranCheckListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/PayRecCheq">
                            {isLoggedIn && CheckPgmAccess("T0024") ? <PayRecCheqMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/PayRecTranLog">
                            {isLoggedIn && CheckPgmAccess("T0009") ? <PayRecTranLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ChrgPortfolioFee">
                            {isLoggedIn && CheckPgmAccess("T0025") ? <ChrgPortfolioFeeMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ChrgCCASSPortfolioFee">
                            {isLoggedIn && CheckPgmAccess("T0027") ? <ChrgCCASSPortfolioFeeMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ChrgCCASSMembershipFee">
                            {isLoggedIn && CheckPgmAccess("T0028") ? <ChrgCCASSMembershipFeeMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/Conv_Int2Bal">
                            {isLoggedIn && CheckPgmAccess("T0026") ? <Conv_Int2BalMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/PayRecTranClear">
                            {isLoggedIn && CheckPgmAccess("T0007") ? <PayRecTranClearMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/StkDepWithTranEntry">
                            {isLoggedIn && CheckPgmAccess("T0010") ? <StkDepWithTranEntryMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        {/*
                        <Route path="/ShareTransGenEr">
                            {isLoggedIn && CheckPgmAccess("T0023") ? <ShareTransGenErMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        */}
                        <Route path="/StkDepWithTranCheckList">
                            {isLoggedIn && CheckPgmAccess("T0011") ? <StkDepWithTranCheckListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/StkDepWithTranLog">
                            {isLoggedIn && CheckPgmAccess("T0012") ? <StkDepWithTranLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/StkDepWithClear">
                            {isLoggedIn && CheckPgmAccess("T0010") ? <StkDepWithClearMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/StkGlobalWithdrawal">
                            {isLoggedIn && CheckPgmAccess("T0013") ? <StkGlobalWithdrawalMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ClientTranSettlementEntry">
                            {isLoggedIn && CheckPgmAccess("T0017") ? <ClientTranSettlementEntryMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ClientTranSettlementCheckList">
                            {isLoggedIn && CheckPgmAccess("T0020") ? <ClientTranSettlementCheckListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ClientTranSettlementLog">
                            {isLoggedIn && CheckPgmAccess("T0021") ? <ClientTranSettlementLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/Matching">
                            {isLoggedIn && CheckPgmAccess("T0014") ? 
                            <> 
                                <MatchingMain gsb={gsb} /> 
                                <Draggable><Card elevation={Elevation.TWO} style={{width: "240px", position: "fixed", top: "96px", right: "24px"}}><SBstatusMini gsb={gsb} /></Card></Draggable>
                            </> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/MatchingReport">
                             {isLoggedIn && CheckPgmAccess("T0014") ? 
                             <> 
                                 <MatchingReportMain gsb={gsb} /> 
                                <Draggable><Card elevation={Elevation.TWO} style={{width: "240px", position: "fixed", top: "96px", right: "24px"}}><SBstatusMini gsb={gsb} /></Card></Draggable>
                             </> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/CancelPrevTrade">
                             {isLoggedIn && CheckPgmAccess("T0022") ? <CancelPrevTradeMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/CorrectTrade">
                             {isLoggedIn && CheckPgmAccess("T0022") ? <CorrectTradeMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/CancelCorrectTradeRegister">
                             {isLoggedIn && CheckPgmAccess("T0022") ? <CancelCorrectTradeRegisterMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/CancelCorrectTradeLog">
                             {isLoggedIn && CheckPgmAccess("T0022") ? <CancelCorrectTradeLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/StockAllocationEntry">
                            {isLoggedIn && CheckPgmAccess("T0019") ? <StockAllocationEntryMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/StockAllocationStatusRpt">
                            {isLoggedIn && CheckPgmAccess("T0019") ? <StockAllocationRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/Sas_Rpt1">
                            {isLoggedIn && CheckPgmAccess("SA001") ? <Sas_Rpt1Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/Sas_Rpt2">
                            {isLoggedIn && CheckPgmAccess("SA002") ? <Sas_Rpt2Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/Sas_Rpt3">
                            {isLoggedIn && CheckPgmAccess("SA003") ? <Sas_Rpt3Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/Sas_Rpt4">
                            {isLoggedIn && CheckPgmAccess("SA004") ? <Sas_Rpt4Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/Sas_Rpt5">
                            {isLoggedIn && CheckPgmAccess("SA005") ? <Sas_Rpt5Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/Ati_Rpt1">
                            {isLoggedIn && CheckPgmAccess("AT001") ? <Ati_Rpt1Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/Ati_Rpt2">
                            {isLoggedIn && CheckPgmAccess("AT002") ? <Ati_Rpt2Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/Ati_Rpt3">
                            {isLoggedIn && CheckPgmAccess("AT003") ? <Ati_Rpt3Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/Ati_Rpt4">
                            {isLoggedIn && CheckPgmAccess("AT004") ? <Ati_Rpt4Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/Ati_Adj1">
                            {isLoggedIn && CheckPgmAccess("AT005") ? <Ati_Adj1Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/Eps_Rpt1">
                            {isLoggedIn && CheckPgmAccess("EP001") ? <Eps_Rpt1Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/Eps_Rpt2">
                            {isLoggedIn && CheckPgmAccess("EP002") ? <Eps_Rpt2Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/import">
                            {isLoggedIn && ( CheckPgmAccess("T0015") || CheckPgmAccess("FT0003")) ? <ImportMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/PreDayEndProc">
                            {isLoggedIn && CheckPgmAccess("T0016") ? 
                            <> 
                                <PreDayEndProcMain gsb={gsb} /> 
                                <Draggable><Card elevation={Elevation.TWO} style={{width: "240px", position: "fixed", top: "96px", right: "24px"}}><SBstatusMini gsb={gsb} /></Card></Draggable>
                            </> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/Cheque2Client">
                            {isLoggedIn && CheckPgmAccess("T0016") ? 
                            <> 
                                <Cheque2ClientMain gsb={gsb} /> 
                                <Draggable><Card elevation={Elevation.TWO} style={{width: "240px", position: "fixed", top: "96px", right: "24px"}}><SBstatusMini gsb={gsb} /></Card></Draggable>
                            </> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/PrintClientChqRegister">
                            {isLoggedIn && CheckPgmAccess("T0016") ? 
                            <> 
                                <PrintClientChqRegisterMain gsb={gsb} /> 
                                <Draggable><Card elevation={Elevation.TWO} style={{width: "240px", position: "fixed", top: "96px", right: "24px"}}><SBstatusMini gsb={gsb} /></Card></Draggable>
                             </> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/DayEndProc">
                            {isLoggedIn && CheckPgmAccess("T0016") ? 
                            <> 
                                <DayEndProcMain gsb={gsb} /> 
                                <Draggable><Card elevation={Elevation.TWO} style={{width: "240px", position: "fixed", top: "96px", right: "24px"}}><SBstatusMini gsb={gsb} /></Card></Draggable>
                            </> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/DayEndProc2">
                            {isLoggedIn && CheckPgmAccess("T0016") ? 
                            <> 
                                <DayEndProc2Main gsb={gsb} /> 
                                <Draggable><Card elevation={Elevation.TWO} style={{width: "240px", position: "fixed", top: "96px", right: "24px"}}><SBstatusMini gsb={gsb} /></Card></Draggable>
                            </> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />} 
                        </Route>
                        
                        <Route path="/StkOverdrawnRpt">
                            {isLoggedIn && CheckPgmAccess("R0001") ? <StkOverdrawnRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/StkHoldList">
                            {isLoggedIn && CheckPgmAccess("R0002") ? <StkHoldListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/StkHoldList_StressTest">
                            {isLoggedIn && CheckPgmAccess("R0002") ? <StkHoldList_StressTestMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/StkHoldListSfc">
                            {isLoggedIn && CheckPgmAccess("R0020") ? <StkHoldListSfcMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/StkHoldListSfc2">
                            {isLoggedIn && CheckPgmAccess("R0020") ? <StkHoldListSfc2Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/StkHoldXls">
                            {isLoggedIn && CheckPgmAccess("R0036") ? <StkHoldXlsMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/StkHaircutXls">
                            {isLoggedIn && CheckPgmAccess("R0037") ? <StkHaircutXlsMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/PortfolioEvaluation">
                            {isLoggedIn && CheckPgmAccess("R0003") ? <PortfolioEvaluationMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/PortfolioEvaluation2">
                            {isLoggedIn && CheckPgmAccess("R0015") ? <PortfolioEvaluation2Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/AcBalList">
                            {isLoggedIn && CheckPgmAccess("R0004") ? <AcBalListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ClACBalXls">
                            {isLoggedIn && CheckPgmAccess("R0034") ? <ClACBalXlsMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/MgnPosition">
                            {isLoggedIn && CheckPgmAccess("R0005") ? <MgnPositionMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/MgnPosition_StressTest">
                            {isLoggedIn && CheckPgmAccess("R0005") ? <MgnPosition_StressTestMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ApprovedStockAssetsReport">
                            {isLoggedIn && CheckPgmAccess("R0033") ? <ApprovedStockAssetsReportMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ApprovedStockAssetsReport_StressTest">
                            {isLoggedIn && CheckPgmAccess("R0033") ? <ApprovedStockAssetsReport_StressTestMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/TradingLimitRpt">
                            {isLoggedIn && CheckPgmAccess("R0045") ? <TradingLimitRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/RollingBalanceReport">
                            {isLoggedIn && CheckPgmAccess("R0035") ? <RollingBalanceReportMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        
                        <Route path="/RelatedClBankGuarRpt">
                            {isLoggedIn && CheckPgmAccess("R0051") ? <RelatedClBankGuarRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/CashAgingAnalysis">
                            {isLoggedIn && CheckPgmAccess("R0038") ? <CashAgingAnalysisMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/UnsettleTranAcceptValue">
                            {isLoggedIn && CheckPgmAccess("R0039") ? <UnsettleTranAcceptValueMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/CashContraSummary">
                            {isLoggedIn && CheckPgmAccess("R0047") ? <CashContraSummaryMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/TopmostBalanceList">
                            {isLoggedIn && CheckPgmAccess("R0032") ? <TopmostBalanceListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/TopmostBalanceList_StressTest">
                            {isLoggedIn && CheckPgmAccess("R0032") ? <TopmostBalanceList_StressTestMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/TopmostBalanceList2">
                            {isLoggedIn && CheckPgmAccess("R0040") ? <TopmostBalanceList2Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/MarginCallRpt1">
                            {isLoggedIn && CheckPgmAccess("R0041") ? <MarginCallRpt1Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/MarginCallRpt2">
                            {isLoggedIn && CheckPgmAccess("R0042") ? <MarginCallRpt2Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/MarginCallRpt2Log">
                            {isLoggedIn && CheckPgmAccess("R0042") ? <MarginCallRpt2LogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/MarginCallRpt3">
                            {isLoggedIn && CheckPgmAccess("R0043") ? <MarginCallRpt3Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/MarginCallRpt4">
                            {isLoggedIn && CheckPgmAccess("R0044") ? <MarginCallRpt4Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/MktValueStressTest">
                            {isLoggedIn && CheckPgmAccess("R0046") ? <MktValueStressTestMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ClHistory">
                            {isLoggedIn && CheckPgmAccess("R0006") ? <ClHistoryMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ClHistory2">
                            {isLoggedIn && CheckPgmAccess("R0006") ? <ClHistory2Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ClHistorySfc">
                            {isLoggedIn && CheckPgmAccess("R0006") ? <ClHistorySfcMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/MthRebateRpt">
                            {isLoggedIn && CheckPgmAccess("R0007") ? <MthRebateRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/MthContractStmpRpt">
                            {isLoggedIn && CheckPgmAccess("R0011") ? <MthContractStmpRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/MthStmpReturnRpt">
                            {isLoggedIn && CheckPgmAccess("R0011") ? <MthStmpReturnRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>  
                        <Route path="/MthInterestRpt">
                            {isLoggedIn && CheckPgmAccess("R0012") ? <MthInterestRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        
                        </Route>
                        <Route path="/MthLevyCCassFeeRpt">
                            {isLoggedIn && CheckPgmAccess("R0013") ? <MthLevyCCassFeeRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/MthSummaryRpt">
                            {isLoggedIn && CheckPgmAccess("R0014") ? <MthSummaryRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ClientPosEnquiry">
                            {isLoggedIn && CheckPgmAccess("R0016") ? <ClientPosEnquiryMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/MthCCassCustodyFeeRpt">
                            {isLoggedIn && CheckPgmAccess("R0019") ? <MthCCassCustodyFeeRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>   
						
                        <Route path="/ClientTurnOverRpt">
                            {isLoggedIn && CheckPgmAccess("R0026") ? <ClientTurnOverRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route> 
					

                        <Route path="/AccInfo">
                            {isLoggedIn && CheckPgmAccess("R0003") ? <AccInfoMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/Dstatement">
                            {isLoggedIn && CheckPgmAccess("R0009") ? <DstatementMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/DstatementPrePrint">
                            {isLoggedIn && CheckPgmAccess("R0009") ? <DstatementPrePrintMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                       
                        <Route path="/Dv1Stmt">
                            {isLoggedIn && CheckPgmAccess("R0021") ? <DviewMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>    
                       
                        <Route path="/Dv2Stmt">
                            {isLoggedIn && CheckPgmAccess("R0022") ? <Dview2Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>   

                        <Route path="/ImportCCASSxRpt">
                            {isLoggedIn && ( CheckPgmAccess("R0048") || RAP_VIEWER_USER) ? <ImportCCASSxRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>  

                        <Route path="/CCASSRpt">
                            {isLoggedIn && ( CheckPgmAccess("R0049") || RAP_VIEWER_USER) ? <CCASSRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>  

 

                        <Route path="/DvTransDate">
                            {isLoggedIn && CheckPgmAccess("R0023") ? <DviewTransDateMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>     

                        <Route path="/DvsDowntatement">
                            {isLoggedIn && CheckPgmAccess("R0024") ? <DviewDownMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>    
                      
                        <Route path="/DvStkHolderList">
                            {isLoggedIn && CheckPgmAccess("R0027") ? <DvStkHolderListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>   
                        { 
                        <Route path="/DvStkHolderList2">
                            {isLoggedIn && CheckPgmAccess("R0028") ? <DvStkHolderList2Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>    
                        }

                        <Route path="/DvDividend">
                            {isLoggedIn && CheckPgmAccess("R0029") ? <DvDividendMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>             

                        <Route path="/DvStkAllocStatus">
                            {isLoggedIn && CheckPgmAccess("R0030") ? <DvStkAllocStatusMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>    

                        {/* 
                        <Route path="/DviewOut">
                            {isLoggedIn && CheckPgmAccess("R0010") ? <DviewOutMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>                                            
                        */}
                        <Route path="/Mstatement">
                            {isLoggedIn && CheckPgmAccess("R0010") ? <MstatementMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/Mstatement2">
                            {isLoggedIn && CheckPgmAccess("R0031") ? <Mstatement2Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/ExportWebStmt">
                            {isLoggedIn && CheckPgmAccess("R0025") ? <ExportWebStmt1Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/StatementAE">
                            {isLoggedIn && CheckPgmAccess("R0009") ? <StatementAEMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/SentStatement">
                            {isLoggedIn && CheckPgmAccess("R0017") ? <SentStatementMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/SendBroadcastEmail">
                            {isLoggedIn && CheckPgmAccess("R0050") ? <SendBroadcastEmailMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/StockAnnouncementEntry">
                            {isLoggedIn && CheckPgmAccess("D0001") ? <StockAnnouncementEntryMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/StockAnnouncementLog">
                            {isLoggedIn && CheckPgmAccess("D0002") ? <StockAnnouncementLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/BookCloseReminder">
                            {isLoggedIn && CheckPgmAccess("D0003") ? <BookCloseReminderMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/MktDividendCharge">
                            {isLoggedIn && CheckPgmAccess("D0004") ? <MktDividendChargeMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/DividendProcess">
                            {isLoggedIn && CheckPgmAccess("D0001") ? <DividendProcessMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/DividendProcess02">
                            {isLoggedIn && CheckPgmAccess("D0001") ? <DividendProcess02Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/DividendProcess03">
                            {isLoggedIn && CheckPgmAccess("D0001") ? <DividendProcess03Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/DividendProcess04">
                            {isLoggedIn && CheckPgmAccess("D0001") ? <DividendProcess04Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/WarrantRightsProcess">
                            {isLoggedIn && CheckPgmAccess("D0001") ? <WarrantRightsProcessMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/WarrantRightsProcess02">
                            {isLoggedIn && CheckPgmAccess("D0001") ? <WarrantRightsProcess02Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/WarrantRightsProcess03">
                            {isLoggedIn && CheckPgmAccess("D0001") ? <WarrantRightsProcess03Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/BookClosedQty">
                            {isLoggedIn && CheckPgmAccess("D0001") ? <BookClosedQtyMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ImportAnnouncement">
                            {isLoggedIn && CheckPgmAccess("D0005") ? <ImportAnnouncementMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/SLSetup">
                            {isLoggedIn && CheckPgmAccess("SL001") ? <SLSetupMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/SLMast">
                            {isLoggedIn && CheckPgmAccess("SL002") ? <SLMastMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/SLMastLog">
                            {isLoggedIn && CheckPgmAccess("SL003") ? <SLMastLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/SLTran">
                            {isLoggedIn && CheckPgmAccess("SL004") ? <SLTranMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/SLTranList">
                            {isLoggedIn && CheckPgmAccess("SL005") ? <SLTranListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/SLTranLog">
                            {isLoggedIn && CheckPgmAccess("SL006") ? <SLTranLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/SLStkStatusReport">
                            {isLoggedIn && CheckPgmAccess("SL010") ? <SLStkStatusReportMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        {/*<Route path="/CBBCCallMgnt">
                            {isLoggedIn && CheckPgmAccess("D0006") ? <CBBCCallMgntMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>*/}
                        {<Route path="/CBBCProcess">
                            {isLoggedIn && CheckPgmAccess("D0006") ? <CBBCProcessMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>}

                        {<Route path="/CBBCCallMgnt">
                            {isLoggedIn && CheckPgmAccess("D0007") ? <CBBCCallMgnt gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>}

                        {<Route path="/CBBCStkWithDrawal">
                            {isLoggedIn && CheckPgmAccess("D0008") ? <CBBCStkWithDrawalMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>}

                        {<Route path="/CBBCDepositResidual">
                            {isLoggedIn && CheckPgmAccess("D0009") ? <CBBCDepositResidualMan gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>}

                        {<Route path="/CBBCClearHistory">
                            {isLoggedIn && CheckPgmAccess("D0010") ? <CBBCClearHistoryMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>}
                            

                        {<Route path="/CBBCConfig">
                                {isLoggedIn && CheckPgmAccess("D0011") ? <CBBCConfigMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>}



                        <Route path="/SBReindex">
                            {isLoggedIn && ( CheckPgmAccess("S0003") || CheckPgmAccess("FS0002") ) ? <SBReindexMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/Reindex">
                            {isLoggedIn && CheckPgmAccess("S0003") ? <SBReindexMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ReUpdateTrn">
                            {isLoggedIn && CheckPgmAccess("S0012") ? <ReUpdateTrnMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/DataIntegrityCheck">
                            {isLoggedIn && CheckPgmAccess("S0014") ? <DataIntegrityCheckMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/SBBackup">
                            {isLoggedIn && CheckPgmAccess("S0004") ? <SBBackupMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/SBBatch">
                            {isLoggedIn && CheckPgmAccess("R0008") ? <SBBatchMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/SBBatch2">
                            {isLoggedIn && CheckPgmAccess("R0008") ? <SBBatch2Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/SBBatch3">
                            {isLoggedIn && CheckPgmAccess("R0008") ? <SBBatch3Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/SBBatch4">
                            {isLoggedIn && CheckPgmAccess("R0008") ? <SBBatch4Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/SBBatch10">
                            {isLoggedIn && CheckPgmAccess("R0008") ? <SBBatch10Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/SBBatch5">
                            {isLoggedIn && CheckPgmAccess("R0008") ? <SBBatch5Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/SBBatch11">
                            {isLoggedIn && CheckPgmAccess("R0008") ? <SBBatch11Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/SBBatch12">
                            {isLoggedIn && CheckPgmAccess("R0008") ? <SBBatch12Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/LoginLog">
                            {isLoggedIn && ( CheckPgmAccess("S0005") || CheckPgmAccess("FS0004") ) ? <LoginLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/Resetprocess">
                            {isLoggedIn && ( CheckPgmAccess("S0010") || CheckPgmAccess("FS0009") ) ? <ResetprocessMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/SBstatus">
                            {isLoggedIn && CheckPgmAccess("S0006") ? <SBstatusMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/SBModule">
                            {isLoggedIn ? <SBModuleMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/UserMast">
                            {isLoggedIn && ( CheckPgmAccess("S0007") || CheckPgmAccess("FS0006") ) ? <UserMastMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/UserMastList">
                            {isLoggedIn && ( CheckPgmAccess("S0007") || CheckPgmAccess("FS0006") ) ? <UserMastListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/UserMastLog">
                            {isLoggedIn && ( CheckPgmAccess("S0007") || CheckPgmAccess("FS0006") ) ? <UserMastLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/UserchgPasswd">
                            {isLoggedIn ? <UserchgPasswdMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/UserchgPasswd2">
                            {isLoggedIn && ( CheckPgmAccess("S0007") || CheckPgmAccess("FS0006") ) ? <UserchgPasswd2Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/UserchgPasswd3">
                            <UserchgPasswd3Main gsb={gsb} />
                        </Route>
                        <Route path="/UserAccessGroup">
                            {isLoggedIn && ( CheckPgmAccess("S0008") || CheckPgmAccess("FS0007") ) ? <UserAccessGroupMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/UserPgmAccess">
                            {isLoggedIn && ( CheckPgmAccess("S0008") || CheckPgmAccess("FS0007") ) ? <UserPgmAccessMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/UserPgmAccessList">
                            {isLoggedIn && ( CheckPgmAccess("S0008") || CheckPgmAccess("FS0007") ) ? <UserPgmAccessListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/UserPgmAccessLog">
                            {isLoggedIn && ( CheckPgmAccess("S0008") || CheckPgmAccess("FS0007") ) ? <UserPgmAccessLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/GroupAccess">
                            {isLoggedIn && ( CheckPgmAccess("S0008") || CheckPgmAccess("FS0007") ) ? <GroupAccessMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/GroupAccessList">
                            {isLoggedIn && ( CheckPgmAccess("S0008") || CheckPgmAccess("FS0007") ) ? <GroupAccessListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/GroupAccessLog">
                            {isLoggedIn && ( CheckPgmAccess("S0008") || CheckPgmAccess("FS0007") ) ? <GroupAccessLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/GroupAccess02">
                            {isLoggedIn && ( CheckPgmAccess("S0008") || CheckPgmAccess("FS0007") ) ? <GroupAccess02Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ReqAuthList">
                            {isLoggedIn && ( CheckPgmAccess("M0017") ) ? <ReqAuthListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/About">
                            {isLoggedIn && ( CheckPgmAccess("S0009") || CheckPgmAccess("FS0008") || RAP_VIEWER_USER )? <AboutMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/TempChgField">
                            {isLoggedIn && ( CheckPgmAccess("S0011") || CheckPgmAccess("FS0010") ) ? <TempChgFieldMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/PurgeOutDatedData">
                            {isLoggedIn && CheckPgmAccess("S0016") ? <PurgeOutDatedDataMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/HkidrImpAccount">
                            {isLoggedIn && CheckPgmAccess("H0001") ? <HkidrImpAccountMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/HkidrMast">
                            {isLoggedIn && CheckPgmAccess("H0002") ? <HkidrMastMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/HkCrsImpAccount">
                            {isLoggedIn && CheckPgmAccess("H0013") ? <HkCrsImpAccountMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route> 
                    
                        <Route path="/HkCrsDataImpAccount">
                            {isLoggedIn && CheckPgmAccess("H0014") ? <HkCrsDataImpAccountMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                       
                        <Route path="/HkCrsMast">
                            {isLoggedIn && CheckPgmAccess("H0015") ? <HkCrsMastMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/HkCrsMastList">
                            {isLoggedIn && CheckPgmAccess("H0016") ? <HkCrsMastListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                     
                        <Route path="/HkCrsLog">
                            {isLoggedIn && CheckPgmAccess("H0017") ? <HkCRSLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                     

                        <Route path="/HkCrsDLog">
                            {isLoggedIn && CheckPgmAccess("H0017") ? <HkCRSDLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                     
                         
                        <Route path="/HkCrsDataMast">
                            {isLoggedIn && CheckPgmAccess("H0018") ? <HkCrsDataMastMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                                        
                        <Route path="/HkCrsExport">
                            {isLoggedIn && CheckPgmAccess("H0019") ? <HkCrsExportMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        
					    <Route path="/FatcaNilExport">
                            {isLoggedIn && CheckPgmAccess("H0024") ? <FatcaNilExportMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
						

        
                        <Route path="/HkCrsEnquiry">
                            {isLoggedIn && CheckPgmAccess("H0021") ? <HkCrsEnquiryMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/HkidrMastList">
                            {isLoggedIn && CheckPgmAccess("H0003") ? <HkidrMastListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/HkidrLog">
                            {isLoggedIn && CheckPgmAccess("H0004") ? <HkidrLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/GsbNameChangeLog">
                            {isLoggedIn && CheckPgmAccess("H0005") ? <GsbNameChangeLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/HkidrHkConsent">
                            {isLoggedIn && CheckPgmAccess("H0008") ? <HkidrHkConsentMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/CNBcanGen">
                            {isLoggedIn && CheckPgmAccess("H0007") ? <CNBcanGenMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>                        
                        <Route path="/HkidrBcanMapping">
                            {isLoggedIn && CheckPgmAccess("H0010") ? <HkidrBcanMappingMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/HkidrResponseFile">
                            {isLoggedIn && CheckPgmAccess("H0010") ? <HkidrResponseFileMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/CNBcanMapping">
                            {isLoggedIn && CheckPgmAccess("H0022") ? <CNBcanMappingMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/CNBcanResponseFile">
                            {isLoggedIn && CheckPgmAccess("H0023") ? <CNBcanResponseFileMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/CNBcanAurpResponseFile">
                            {isLoggedIn && CheckPgmAccess("H0023") ? <CNBcanAurpResponseFileMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/CNBcanRsltResultFile">
                            {isLoggedIn && CheckPgmAccess("H0023") ? <CNBcanRsltResultFileMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route> 


                        <Route path="/CCRConfig">
                            {isLoggedIn && CheckPgmAccess("CCR001") ? <CCRConfigMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/CCRMailList">
                            {isLoggedIn && CheckPgmAccess("CCR002") ? <CCRMailListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ClientUploadEntry">
                            {isLoggedIn && CheckPgmAccess("CCR003") ? <ClientUploadEntryMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/StkRecordDate">
                            {isLoggedIn && CheckPgmAccess("CCR004") ? <StkRecordDateMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>          


                        <Route path="/CCRGenRecDate">
                            {isLoggedIn && CheckPgmAccess("CCR005") ? <CCRGenRecDateMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>               

                        <Route path="/CCRGenStkOnHand">
                            {isLoggedIn && CheckPgmAccess("CCR006") ? <CCRGenStkOnHandMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>       

                        <Route path="/CCRAuditLog">
                            {isLoggedIn && CheckPgmAccess("CCR007") ? <CCRAuditLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>



                        <Route path="/CNBcanFimgFile">
                            {isLoggedIn && CheckPgmAccess("H0023") ? <CNBcanFimgFileMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/importHkconsentCSV">
                            {isLoggedIn && CheckPgmAccess("H0006") ? <ImportHkConsentCsvMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/ExportHkConsent">
                            {isLoggedIn && CheckPgmAccess("H0009") ? <ExportHkConsentMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        
                        <Route path="/HkidrOtcr">
                            {isLoggedIn && CheckPgmAccess("H0011") ? <HkidrOtcrMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
						
                        <Route path="/HkidrOtcr2">
                            {isLoggedIn && CheckPgmAccess("H0011") ? <HkidrOtcr2Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        


                    


                        <Route path="/IPOMast">
                            {isLoggedIn && CheckPgmAccess("I0001") ? <IPOMastMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

						<Route path="/IPOEntry">
                            {isLoggedIn && CheckPgmAccess("I0002") ? <IPOEntryMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/IPOApplicationRpt">
                            {isLoggedIn && CheckPgmAccess("I0003") ? <IPOApplicationRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>   
						<Route path="/IPOLog">
                            {isLoggedIn && CheckPgmAccess("I0004") ? <IPOLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                         <Route path="/IPOExportFINI">
                            {isLoggedIn && CheckPgmAccess("I0005") ? <IPOExportFINIMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>    

                        <Route path="/IPOExportIBOND">
                            {isLoggedIn && CheckPgmAccess("I0006") ? <IPOExportIBONDMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>                    

                        <Route path="/IPOFINIAuthorisedFile">
                            {isLoggedIn && CheckPgmAccess("I0007") ? <IPOFINIAuthorisedFileMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>  
                        <Route path="/IPOPrePayment">
                            {isLoggedIn && CheckPgmAccess("I0008") ? <IPOPrePayMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>     
 
                        <Route path="/IPOImportAllotment">
                            {isLoggedIn && CheckPgmAccess("I0009") ? <IPOImportAllotmentMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>       
                        <Route path="/IPOInputAllotmentResult">
                            {isLoggedIn && CheckPgmAccess("I0010") ? <IPOInputAllotmentResultMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>  
                        <Route path="/IPOListingRpt">
                            {isLoggedIn && CheckPgmAccess("I0012") ? <IPOListingRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>  
   
                        <Route path="/IPIPOStkTransactions">
                            {isLoggedIn && CheckPgmAccess("I0013") ? <IPOStkTransactionsToSBMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>   
                        <Route path="/IPOStkCashChq">
                            {isLoggedIn && CheckPgmAccess("I0014") ? <IPOStkCashChqToSBMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>   
                    
                        <Route path="/IPORefundChq">
                            {isLoggedIn && CheckPgmAccess("I0011") ? <IPORefundChqMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>   
                        
						<Route path="/IPOPurge">
                            {isLoggedIn && CheckPgmAccess("I0015") ? <IPOPurgeMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/PlacingMast">
                            {isLoggedIn && CheckPgmAccess("P0001") ? <PlacingMastMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/PlacingMastLog">
                            {isLoggedIn && CheckPgmAccess("P0002") ? <PlacingMastLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        {/*
                        <Route path="/ExportEIPOReset">
                            {isLoggedIn && CheckPgmAccess("H0040") ? <ExportEIPOMainReset gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>   
                        */}
                        <Route path="/HkidrProcessResultFile">
                            {isLoggedIn && CheckPgmAccess("H0010") ? <HkidrProcessResultFileMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/HkidrFullImageFile">
                            {isLoggedIn && CheckPgmAccess("H0010") ? <HkidrFullImageFileMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        
                        <Route path="/HkidrETTradeList">
                            {isLoggedIn ? <HkidrETTradeListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/HkidreBrokerList">
                            {isLoggedIn ? <HkidreBrokerListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/HkidrAyersList">
                            {isLoggedIn ? <HkidrAyersListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/HkidrInfocastList">
                            {isLoggedIn ? <HkidrInfocastListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/GsbxConfig">
                            {isLoggedIn && CheckPgmAccess("S0001") ? <GsbxConfigMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/GLConfig">
                            {isLoggedIn && CheckPgmAccess("S0015") ? <GLConfigMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/SiConfig">
                            {isLoggedIn && CheckPgmAccess("S0017") ? <SiConfigMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/BcanConfig">
                            {isLoggedIn && CheckPgmAccess("S0002") ? <BcanConfigMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/CrsConfig">
                            {isLoggedIn && CheckPgmAccess("S0013") ? <CrsConfigMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/tasks">
                            {isLoggedIn ? <TaskMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/WIP">
                            {isLoggedIn ? <WIPMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/ClMast2">
                            {isLoggedIn ? <ClMast2Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>


                        {/* for FBSx user */}
                        <Route path="/fbs/MarketMast">
                            {isLoggedIn && CheckPgmAccess("FM0001") ? <FBSMarketMastMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/ComdyMast">
                            {isLoggedIn && CheckPgmAccess("FM0004") ? <FBSComdyMastMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/ComdyList">
                            {isLoggedIn && CheckPgmAccess("FM0005") ? <FBSComdyListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/ExpiryMast">
                            {isLoggedIn && CheckPgmAccess("FM0007") ? <FBSExpiryMastMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/CommMast">
                            {isLoggedIn && CheckPgmAccess("FM0024") ? <FBSCommMastMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/CommList">
                            {isLoggedIn && CheckPgmAccess("FM0025") ? <FBSCommListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/CommLog">
                            {isLoggedIn && CheckPgmAccess("FM0026") ? <FBSCommLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/ClMast">
                            {isLoggedIn && CheckPgmAccess("FM0010") ? <FBSClMastMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/ClList">
                            {isLoggedIn && CheckPgmAccess("FM0012") ? <FBSClListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/ClLog">
                            {isLoggedIn && CheckPgmAccess("FM0012") ? <FBSClLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/CbMast">
                            {isLoggedIn && CheckPgmAccess("FM0013") ? <FBSCbMastMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/CbMastB">
                            {isLoggedIn && CheckPgmAccess("FM0014") ? <FBSCbMastMain gsb={gsb} type="B" /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/OpenPos">
                            {isLoggedIn && CheckPgmAccess("FM0015") ? <FBSOpenPosMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/CurrencyMast">
                            {isLoggedIn && CheckPgmAccess("FM0016") ? <FBSCCYMastMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/SystemStart">
                            {isLoggedIn && CheckPgmAccess("FT0001") ? <FBSDayStartProcMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/fbs/SystemEnd">
                            {isLoggedIn && CheckPgmAccess("FT0019") ? 
                            <>
                                <FBSDayEndProcMain gsb={gsb} /> 
                                <Draggable><Card elevation={Elevation.TWO} style={{width: "240px", position: "fixed", top: "96px", right: "24px"}}><FBSStatusMini gsb={gsb} /></Card></Draggable>
                            </> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/fbs/PositionMakeup">
                            {isLoggedIn && CheckPgmAccess("FT0017") ? <FBSPositionMakeupMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/RecalcMargin">
                            {isLoggedIn && CheckPgmAccess("FT0018") ? <FBSRecalcMarginProcMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/CurrencyParamUpdate">
                            {isLoggedIn && CheckPgmAccess("FT0002") ? <FBSCCYParamUpdateMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/ClosingUpdate">
                            {isLoggedIn && CheckPgmAccess("FT0016") ? <FBSClosingUpdateMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/ClientTranEntry">
                            {isLoggedIn && CheckPgmAccess("FT0007") ? <FBSClientTranEntryMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/ClientTranCheckList">
                            {isLoggedIn && CheckPgmAccess("FT0008") ? <FBSClientTranCheckListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/ClientTranLog">
                            {isLoggedIn && CheckPgmAccess("FT0009") ? <FBSClientTranLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/FundMoveTranEntry">
                            {isLoggedIn && CheckPgmAccess("FT0004") ? <FBSFundMoveTranEntryMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/FundMoveTranCheckList">
                            {isLoggedIn && CheckPgmAccess("FT0005") ? <FBSFundMoveTranCheckListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/FundMoveTranLog">
                            {isLoggedIn && CheckPgmAccess("FT0006") ? <FBSFundMoveTranLogMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/fbs/Dstatement">
                            {isLoggedIn && CheckPgmAccess("FR0001") ? <Fbs_DstatementMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/Mstatement">
                            {isLoggedIn && CheckPgmAccess("FR0002") ? <Fbs_MstatementMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/SentStatement">
                            {isLoggedIn && CheckPgmAccess("FR0021") ? <Fbs_SentStatementMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/SendBroadcastEmail">
                            {isLoggedIn && CheckPgmAccess("FR0023") ? <Fbs_SendBroadcastEmailMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/fbs/DailyTradingRpt">
                            {isLoggedIn && CheckPgmAccess("FR0003") ? <Fbs_DailyTradingRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/CashSettleRpt">
                            {isLoggedIn && CheckPgmAccess("FR0004") ? <Fbs_CashSettleRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/ClosePositionRpt">
                            {isLoggedIn && CheckPgmAccess("FR0005") ? <Fbs_ClosePositionRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/FundMoveRpt">
                            {isLoggedIn && CheckPgmAccess("FR0006") ? <Fbs_FundMoveRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/OpenPositionRpt">
                            {isLoggedIn && CheckPgmAccess("FR0007") ? <Fbs_OpenPositionRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/CommRebateRpt">
                            {isLoggedIn && CheckPgmAccess("FR0008") ? <Fbs_CommRebateRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/CommRebateRpt2">
                            {isLoggedIn && CheckPgmAccess("FR0008") ? <Fbs_CommRebateRpt2Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/ExceptMgnRpt">
                            {isLoggedIn && CheckPgmAccess("FR0009") ? <Fbs_ExceptMgnRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/AcctEqMgnRpt">
                            {isLoggedIn && CheckPgmAccess("FR0010") ? <Fbs_AcctEqMgnRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/AcctSumRpt">
                            {isLoggedIn && CheckPgmAccess("FR0011") ? <Fbs_AcctSumRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/MgnCallRpt">
                            {isLoggedIn && CheckPgmAccess("FR0012") ? <Fbs_MgnCallRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/MthTradingRpt">
                            {isLoggedIn && CheckPgmAccess("FR0014") ? <Fbs_MthTradingRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/fbs/SettleSummaryRpt">
                            {isLoggedIn && CheckPgmAccess("FR0033") ? <Fbs_SettleSummaryRptMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/FormIVEntry">
                            {isLoggedIn && CheckPgmAccess("FR0034") ? <Fbs_FormIVEntryMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        <Route path="/FbsxConfig">
                            {isLoggedIn && CheckPgmAccess("FS0001") ? <FbsxConfigMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/Reindex_Fbs">
                            {isLoggedIn && CheckPgmAccess("FS0002") ? <Fbs_ReindexMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/FbsBackup">
                            {isLoggedIn && CheckPgmAccess("FS0003") ? <Fbs_BackupMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/FBSBatch">
                            {isLoggedIn && CheckPgmAccess("FR0035") ? <FBSBatchMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/FBSBatch60">
                            {isLoggedIn && CheckPgmAccess("FR0035") ? <FBSBatch60Main gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/ReqAuthList">
                            {isLoggedIn && ( CheckPgmAccess("FM0051") ) ? <Fbs_ReqAuthListMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/PurgeOutDatedData">
                            {isLoggedIn && ( CheckPgmAccess("FS0011") ) ? <Fbs_PurgeOutDatedDataMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>

                        {/* for OBx_USER */}
                        <Route path="/fbs/SmMast">
                            {isLoggedIn && CheckPgmAccess("OM0001") ? <FBSSmMastMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                        <Route path="/fbs/OptionTradeEntry">
                            {isLoggedIn && CheckPgmAccess("OT0001") ? <OptionTradeEntryMain gsb={gsb} /> : <Login gsb={gsb} isLoggedIn={isLoggedIn} onLogin={handleLogin} onLogout={handleLogout} />}
                        </Route>
                    </Switch>
                    
                    {isLoggedIn && showStatus && <Draggable><Card elevation={Elevation.TWO} style={{width: "240px", position: "fixed", top: "96px", right: "24px"}}><SBstatusMini gsb={gsb} /></Card></Draggable>}
                    {isLoggedIn && FBSshowStatus && <Draggable><Card elevation={Elevation.TWO} style={{width: "240px", position: "fixed", top: "96px", right: "24px"}}><FBSStatusMini gsb={gsb} /></Card></Draggable>}
                </div>
            </Router>
        </div>
        </React.Suspense>
    );
}


function SideMenu({ isLoggedIn = false } : MenuBar_HKIDRProps) {
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />
    
    const [PgmLists, setPgmLists] = useState([] as PgmAccessList[])
    const [RecordPgmName, setRecordPgmName] = useState("")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [userKey, setuserKey] = useState("DEMO")
    const [userId, setuserId] = useState("")
    const [showHKIDR1, setshowHKIDR1] = useState(false)
    const [showFINI, setshowFINI] = useState(false)
    const [CM2K_USER, setCM2K_USER] = useState(false)
    const [GSBXHKCRS, setGSBXHKCRS] = useState(false)
    const [CNBCAN, setCNBCAN] = useState(false)
    const { t, i18n } = useTranslation();    

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("SideMenu disp user_key: ", res.data.Flag.user_key)
                GsbFlag = res.data.Flag;
                //console.log("SideMenu disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                //console.log("SideMenu companyLogoName: ", GsbFlag.companyLogoName)
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                setuserKey(GsbFlag.user_key)
                setuserId( GsbFlag.UserID)
                setshowHKIDR1(GsbFlag.HKIDR_USER1)
                setGSBXHKCRS(GsbFlag.GSBXHKCRS)
                setCNBCAN (GsbFlag.CNBCAN)
                setCM2K_USER( GsbFlag.CM2K_USER);
                
                setPgmLists(res.data.UserPgmListData)

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])


    useEffect(() => {
        //console.log("sidemenu RecordPgmName ", RecordPgmName)
        if ( isLoggedIn && RecordPgmName.length > 0 ) {
            (async () => {
                try {
                    // get GsbFlag from SB.XBS
                    const res = await gsb.post('/PgmEntry', {
                        cPgmName: RecordPgmName,
                        cIPAddr: "",
                    });
                    setRecordPgmName("")
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, RecordPgmName, isLoggedIn])


    function CheckPgmAccess(PgmName: string): boolean{
        var canAccess = false;

        for (let i = 0; i < PgmLists.length; i++) {
            //console.log("func CheckPgmAccess PgmLists", PgmName, PgmLists[i].d_PgmCode, PgmLists[i].d_PgmAccess)
            if (PgmLists[i].d_PgmCode === PgmName ) {
                //console.log("func CheckPgmAccess PgmLists", PgmName, PgmLists[i].d_PgmCode, PgmLists[i].d_PgmAccess)
                if (PgmLists[i].d_PgmAccess === "Y" ) {
                    canAccess = true;
                }
                break ;
            }
        }
        return canAccess;
    }


    /*
    let CoHead = <>
        <span id="DispCoName"> {coLogo} <b> { CO_NAME } </b> </span>
        <span id="DispTrnDate">Tran Date: {TRAN_DATE} </span>
        <div className="Spacing-V-8" />
        <span id="DispCoName2">Curr Path: {SBPath}</span>
        <span id="DispTrnDate">Setl Date: {SETL_DATE} </span>
    </>
    */
   
    //let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>

    return (
        <>
            <div className="Spacing-V-Menu"></div>
            <div className="Row">
                <FormGroup className="Col-1-12"  >
                    {CoHead}
                </FormGroup>
            </div>
            <div className="Row">
                {/* <Link to="/accounts">
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgAccount} alt="Account" />
                        <div>{t('Accounts')}</div>
                    </div>
                </Link> */}
                { CheckPgmAccess("M0001") && <a href="#/accounts" onClick={() => { setRecordPgmName("21 ClMast") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgAccount} alt="Client Master" />
                        <div>{t('Accounts')}</div>
                    </div>
                </a> }
                { CheckPgmAccess("M0007") && <a href="#/SmMast" onClick={() => { setRecordPgmName("23 SmMast") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgFileBox} alt="Stock Master" />
                        <div>{t('Stock Master')}</div>
                    </div>
                </a> }
                { CheckPgmAccess("M0009") && <a href="#/IntRMast" onClick={() => { setRecordPgmName("11 IntRMast") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgFileBox} alt="Interest Master" />
                        <div>{t('Interest Master')}</div>
                    </div>
                </a> }
                { CheckPgmAccess("M0011") && <a href="#/CommMast" onClick={() => { setRecordPgmName("12 CommMastt") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgFileBox} alt="Commission Master" />
                        <div>{t('Commission Master')}</div>
                    </div>
                </a> }

                {CheckPgmAccess("M0032") &&  <a href="#/HolidayMast" onClick={() => { setRecordPgmName("HolidayMast") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgFileBox} alt="Holiday Master" />
                        <div>{t('Holiday Master')}</div>
                    </div>
                </a> }


                { CheckPgmAccess("D0001") && <a href="#/StockAnnouncementEntry" onClick={() => { setRecordPgmName("91 StockAnnouncementEntry") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgFileBox} alt="91 Stock Announcement Entry" />
                        <div>Stock Announcement Entry</div>
                    </div>
                </a> }
            </div>


            <div className="Spacing-V-16"></div>

            <div className="Row">
                { CheckPgmAccess("T0001") && <a href="#/ClientTranEntry" onClick={() => { setRecordPgmName("31 ClientTranEntry") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgProfit} alt="31 ClientTranEntry" />
                        <div>Client Transaction Entry</div>
                    </div>
                </a> }
                { CheckPgmAccess("T0004") && <a href="#/BrokerTranEntry" onClick={() => { setRecordPgmName("32 BrokerTranEntry") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgAccount} alt="32 BrokerTranEntry" />
                        <div>Broker Transaction Entry</div>
                    </div>
                </a> }
                { CheckPgmAccess("T0007") && <a href="#/PayRecTranEntry" onClick={() => { setRecordPgmName("33 PayRecTranEntry") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgMoney} alt="33 PayRecTranEntry" />
                        <div>Payment / Receipt Transaction Entry</div>
                    </div>
                </a> }
                { CheckPgmAccess("T0010") && <a href="#/StkDepWithTranEntry" onClick={() => { setRecordPgmName("34 StkDepWithTranEntry") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgProfit} alt="34 StkDepWithTranEntry" />
                        <div>Stock Deposit/ Withdrawal Transaction Entry</div>
                    </div>
                </a> }

                {/*showHKIDR1 && CheckPgmAccess("T0023") && <a href="#/ShareTransGenEr" onClick={() => { setRecordPgmName("ShareTransGenEr") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgProfit} alt="ShareTransGenEr" />
                        <div>Gen Er ref in share transfer</div>
                    </div>
                </a>*/}
                
                { CheckPgmAccess("T0017") && <a href="#/ClientTranSettlementEntry" onClick={() => { setRecordPgmName("351 Settlement Entry") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgMoney} alt="351 Settlement Entry" />
                        <div>Client Transaction Settlement Entry</div>
                    </div>
                </a> }
                { CheckPgmAccess("T0014") && <a href="#/Matching" onClick={() => { setRecordPgmName("36 Start Matching") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDocument} alt="36 Start Matching" />
                        <div>Start Matching</div>
                    </div>
                </a> }
                {/* 20230330 */}
                { CheckPgmAccess("T0019") && <a href="#/StockAllocationEntry" onClick={() => { setRecordPgmName("791 Stock Allocation Entry") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgMoney} alt="791 Stock Allocation Entry" />
                        <div>Stock Allocation Entry</div>
                    </div>
                </a> }
                { CheckPgmAccess("T0015") && <a href="#/import" onClick={() => { setRecordPgmName("Import files") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgImport} alt="Import" />
                        <div>Import files</div>
                    </div>
                </a> }
            </div>

            <div className="Row">
                { CheckPgmAccess("R0009") && <a href="#/Dstatement" onClick={() => { setRecordPgmName("542 Daily Statement") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgFinancialreport} alt="542 Daily Statement" />
                        <div>Daily Statement</div>
                    </div>
                </a> }
                { CheckPgmAccess("R0002") && <a href="#/StkHoldList" onClick={() => { setRecordPgmName("74 StkHoldList") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDocument} alt="74 StkHoldList" />
                        <div>Stock Holder List</div>
                    </div>
                </a> }
                { CheckPgmAccess("R0003") && <a href="#/PortfolioEvaluation" onClick={() => { setRecordPgmName("751 Portfolio Evaluation") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDocument} alt="751 Portfolio Evaluation" />
                        <div>Portfolio Evaluation</div>
                    </div>
                </a> }
                { CheckPgmAccess("R0015") && <a href="#/PortfolioEvaluation2" onClick={() => { setRecordPgmName("752 Stock Asset Evaluation") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDocument} alt="752 Stock Asset Evaluation" />
                        <div>Stock Asset Evaluation</div>
                    </div>
                </a> }
                { CheckPgmAccess("R0016") && <a href="#/ClientPosEnquiry" onClick={() => { setRecordPgmName("754 Client Position Enquiry") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDocument} alt="754 Client Position Enquiry" />
                        <div>Client Position Enquiry</div>
                    </div>
                </a> }
                { CheckPgmAccess("R0004") && <a href="#/AcBalList" onClick={() => { setRecordPgmName("25B AcBalList") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDocument} alt="25B Ac Bal List" />
                        <div>Account Balance List</div>
                    </div>
                </a> }
                { CheckPgmAccess("R0010") && <a href="#/Mstatement" onClick={() => { setRecordPgmName("831 Monthly Statement") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgFinancialreport} alt="831 Monthly Statement" />
                        <div>Monthly Statement</div>
                    </div>
                </a> }
                { CheckPgmAccess("R0021") && <a href="#/Dv1Stmt" onClick={() => { setRecordPgmName("DVIEW Statement") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgFinancialreport} alt="DVIEW Statement" />
                        <div>DVIEW Statement (show Address)</div>
                    </div>
                </a> }
                { CheckPgmAccess("R0022") && <a href="#/Dv2Stmt" onClick={() => { setRecordPgmName("DVIEW Statement (NO Address)") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgFinancialreport} alt="DVIEW Statement (NO Address)" />
                        <div>DVIEW Statement (NO Address)</div>
                    </div>
                </a> }
            </div>

            { showHKIDR1 && <div className="Row">
                { CheckPgmAccess("H0001") && <a href="#/HkidrImpAccount" onClick={() => { setRecordPgmName("Import Client from GSB (New Client)") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgAccount} alt="Import Client from GSB (New Client)" />
                        <div>Import Client from GSB (New Client)</div>
                    </div>
                </a> }
                { CheckPgmAccess("H0002") && <a href="#/HkidrMast" onClick={() => { setRecordPgmName("HKIDR Master") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgAccount} alt="HKIDR Master" />
                        <div>{t('HKIDR Master')}</div>
                    </div>
                </a> }
           
                { CheckPgmAccess("H0010") && <a href="#/HkidrBcanMapping" onClick={() => { setRecordPgmName("Export HKBCAN Mapping File") }}>
                    <div className="MenuTile" >
                        <img className="MenuTileImage" src={svgDownload} alt="HKBCAN-CID Mapping File" />
                        <div>Export HKBCAN-CID Mapping File</div>
                    </div>
                </a> }
                { CheckPgmAccess("H0010") && <a href="#/HkidrResponseFile" onClick={() => { setRecordPgmName("Read HKBCAN Response File") }}>
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDocument} alt="Read HKBCAN-CID Response File" />
                        <div>Read HKBCAN-CID Response File</div>
                    </div>
                </a> }
                { CheckPgmAccess("H0010") && <a href="#/HkidrProcessResultFile" onClick={() => { setRecordPgmName("Read HKBCAN Result File") }}>
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDocument} alt="Read HKBCAN-CID Process Result File" />
                        <div>Read HKBCAN-CID Process Result File</div>
                    </div>
                </a> }
                { CheckPgmAccess("H0010") && <a href="#/HkidrFullImageFile" onClick={() => { setRecordPgmName("Read HKBCAN Full Image File") }}>
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDocument} alt="Read HKBCAN-CID BCAN Full Image Reconcile File" />
                        <div>Read HKBCAN-CID BCAN Full Image Reconcile File</div>
                    </div>
                </a> }


                { CheckPgmAccess("H0011") && <a href="#/HkidrOtcr" onClick={() => { setRecordPgmName("Export OTCR Report File (D/W)") }}>
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDownload} alt="Export OTCR Report File (D/W)" />
                        <div>Export OTCR Report File (D/W)</div>
                    </div>
                </a> }
               
			    { CheckPgmAccess("H0011") && <a href="#/HkidrOtcr2" onClick={() => { setRecordPgmName("Export OTCR Report File (D/W) in History") }}>
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDownload} alt="Export OTCR Report File (D/W) in History" />
                        <div>Export OTCR Report File (D/W) in History</div>
                    </div>
                </a> }

                { CM2K_USER && CheckPgmAccess("I0005") && (GsbFlag.user_key != "WINGHANG") && <a href="#/IPOExportFINI" onClick={() => { setRecordPgmName("Export Fini EIPO bulk upload file") }}>
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDownload} alt="IPO Mast" />
                        <div> Export EIPO Bulk list</div>
                    </div>                    
                </a> }
                
                { CM2K_USER && CheckPgmAccess("I0006") && (GsbFlag.user_key != "WINGHANG") && <a href="#/IPOExportIBOND" onClick={() => { setRecordPgmName("Export IBOND bulk upload file") }}>
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDownload} alt="IPO Mast" />
                        <div> Export IBOND Bulk list</div>
                    </div>                    
                </a> }
                

                {/* CM2K_USER && CheckPgmAccess("H0012") && (GsbFlag.user_key != "WINGHANG") && <a href="#/ExportEIPOReset" onClick={() => { setRecordPgmName("Export Fini EIPO Reset") }}>
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDocument} alt="Export EIPO Reset" />
                        <div> Export EIPO Reset</div>
                    </div>
                </a>*/ }

            </div> }

        </>
    )
}


function SideMenu_ce({ isLoggedIn = false } : MenuBar_HKIDRProps) {
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />
    
    const [PgmLists, setPgmLists] = useState([] as PgmAccessList[])
    const [RecordPgmName, setRecordPgmName] = useState("")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [userKey, setuserKey] = useState("DEMO")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("SmMastMain disp user_key: ", res.data.Flag.user_key)
                GsbFlag = res.data.Flag;
                //console.log("SmMastMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setuserKey(GsbFlag.user_key)
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        //console.log("sidemenu RecordPgmName ", RecordPgmName)
        if ( isLoggedIn && RecordPgmName.length > 0 ) {
            (async () => {
                try {
                    // get GsbFlag from SB.XBS
                    const res = await gsb.post('/PgmEntry', {
                        cPgmName: RecordPgmName,
                        cIPAddr: "",
                    });
                    setRecordPgmName("")
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, RecordPgmName, isLoggedIn])


    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>

    return (
        <>
            <div className="Spacing-V-Menu"></div>
            <div className="Row">
                <FormGroup className="Col-1-12"  >
                    {CoHead}
                </FormGroup>
            </div>
            <div className="Row">
                { userKey == "COMPSHARE" && <a href="#/ClACList" onClick={() => { setRecordPgmName("25 ClACList") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDocument} alt="25 ClACList" />
                        <div>Client Master List</div>
                    </div>
                </a> }
                <a href="#/ClACListSfc" onClick={() => { setRecordPgmName("ACListSfc") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDocument} alt="ACListSfc" />
                        <div>Account List SFC</div>
                    </div>
                </a>
            </div>
            <div className="Row">
                { userKey == "COMPSHARE" && <a href="#/ClientTranCheckList" onClick={() => { setRecordPgmName("312 ClientTranCheckList") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDocument} alt="312 ClientTranCheckList" />
                        <div>Client Transaction Check List</div>
                    </div>
                </a> }
                { userKey == "COMPSHARE" && <a href="#/StkHoldList" onClick={() => { setRecordPgmName("74 StkHoldList") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDocument} alt="74 StkHoldList" />
                        <div>Stock Holder List</div>
                    </div>
                </a> }
                { userKey !== "COMPSHARE" && <a href="#/ClHistory" onClick={() => { setRecordPgmName("29 ClHistory") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDocument} alt="ClHistory" />
                        <div>Client History Report</div>
                    </div>
                </a> }
            </div>
        </>
    )
}


function SideMenu_HKIDR({ isLoggedIn = false } : MenuBar_HKIDRProps) {
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />
    
    const [showSysAdmin, setshowSysAdmin] = useState(false)
    const [showHKIDRUser, setshowHKIDRUser] = useState(false)
   
    const [CNBCAN,setCNBCAN] = useState(false)
    const [RecordPgmName, setRecordPgmName] = useState("")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [userKey, setuserKey] = useState("DEMO")
    const [userId, setuserId] = useState("")
    const [CM2K_USER, setCM2K_USER] = useState(false)
 
    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("SmMastMain disp user_key: ", res.data.Flag.user_key)
                GsbFlag = res.data.Flag;
                //console.log("SmMastMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                setuserKey(GsbFlag.user_key)
                setuserId( GsbFlag.UserID)
                setCM2K_USER( GsbFlag.CM2K_USER);
                setCNBCAN(GsbFlag.CNBCAN);
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])


    useEffect(() => {
        setshowSysAdmin(false)
        setshowHKIDRUser(false)

        ;
        if ( isLoggedIn ) {
            
            (async () => {
                try {
                    // get UserAccessGroupInfo
                    const res = await gsb.post('/Master',
                    {   sb_data: {
                            cUserid2: userId,
                        },
                        cPgmId: "UserAccessGroup",
                        cAction: "GetUserAccessGroupInfo",
                        cUserid2: userId,
                    });
                    //console.log("GetUserAccessGroupInfo res.data.data", res.data.data)
                    if ( res.data.count > 0 ) {
                        setshowSysAdmin( res.data.data[0].d_User_Group1=="Y")
                        setshowHKIDRUser( res.data.data[0].d_User_Group2=="Y")
                    }


                } catch (error) {
                    utils.showError(error)
                }
            })()


            //setshowSysAdmin(true)
            //setshowHKIDRUser(true)

        }
    }, [gsb, isLoggedIn, userId, GsbFlag])


    useEffect(() => {
        //console.log("sidemenu RecordPgmName ", RecordPgmName)
        if ( isLoggedIn && RecordPgmName.length > 0 ) {
            (async () => {
                try {
                    // get GsbFlag from SB.XBS
                    const res = await gsb.post('/PgmEntry', {
                        cPgmName: RecordPgmName,
                        cIPAddr: "",
                    });
                    setRecordPgmName("")
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, RecordPgmName, isLoggedIn])

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>

    return (
        <>
            <div className="Spacing-V-Menu"></div>
            <div className="Row">
                <FormGroup className="Col-1-12"  >
                    {CoHead}
                </FormGroup>
            </div>
            { showHKIDRUser && <div className="Row">
                {/*} <Link to="/HkidrMast" >
                    <div className="MenuTile" >
                        <img className="MenuTileImage" src={svgAccount} alt="HkidrMast" />
                        <div>HKIDR Master</div>
                    </div>
                </Link> */}
                <a href="#/HkidrMast" onClick={() => { setRecordPgmName("HKIDR Master") }}>
                    <div className="MenuTile" >
                        <img className="MenuTileImage" src={svgAccount} alt="HkidrMast" />
                        <div>HKIDR Master</div>
                    </div>
                </a>
          
                <a href="#/HkidrBcanMapping" onClick={() => { setRecordPgmName("Export HKBCAN Mapping File") }}>
                    <div className="MenuTile" >
                        <img className="MenuTileImage" src={svgDownload} alt="HKBCAN-CID Mapping File" />
                        <div>Export HKBCAN-CID Mapping File</div>
                    </div>
                </a>
             
                <a href="#/HkidrOtcr" onClick={() => { setRecordPgmName("HKIDR Master") }}>
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDownload} alt="Export OTCR Report File (D/W)" />
                        <div>Export OTCR Report File (D/W)</div>
                    </div>
                </a>
               
			    <a href="#/HkidrOtcr2" onClick={() => { setRecordPgmName("HKIDR Master") }}>
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDownload} alt="Export OTCR Report File (D/W) in History" />
                        <div>Export OTCR Report File (D/W) in History</div>
                    </div>
                </a>
				

            </div> }
            {GsbFlag.user_key !== "WINGHANG" &&
            <div className="Row">
                { CM2K_USER && <a href="#/IPOExportFINI" onClick={() => { setRecordPgmName("Export Fini EIPO bulk upload file") }}>
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDownload} alt="IPO Mast" />
                        <div> Export Application For FINI</div>
                    </div>
                </a> }

                { CM2K_USER && <a href="#/IPOExportIBOND" onClick={() => { setRecordPgmName("Export IBOND bulk upload file") }}>
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDownload} alt="IBOND Bulk" />
                        <div> Export Application For Bond</div>
                    </div>
                </a> }


                { CM2K_USER && <a href="#/IPOFINIAuthorisedFile" onClick={() => { setRecordPgmName("Import FINI Authorised File") }}>
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDocument} alt="Read Fini EIPO Authorised" />
                        <div> Import FINI EIPO Authorised File</div>
                    </div>
                </a> }


                { CM2K_USER && <a href="#/IPOImportAllotment" onClick={() => { setRecordPgmName("Import FINI Allotment Result") }}>
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDocument} alt="Import FINI Allotment Result" />
                        <div> Import FINI EIPO Allotment File</div>
                    </div>
                </a> }

     

                {/* CM2K_USER && <a href="#/ExportEIPOReset" onClick={() => { setRecordPgmName("Fini Reset EIPO") }}>
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDocument} alt="FIni Reset EIPO" />
                        <div>FIni Reset EIPO</div>
                    </div>
                </a>*/ }
             </div>
            }

            { showHKIDRUser && <div className="Row">
                <a href="#/HkidrResponseFile" onClick={() => { setRecordPgmName("Read HKBCAN Response File") }}>
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDocument} alt="Read HKBCAN-CID Response File" />
                        <div>Read HKBCAN-CID Response File</div>
                    </div>
                </a>
                <a href="#/HkidrProcessResultFile" onClick={() => { setRecordPgmName("Read HKBCAN Result File") }}>
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDocument} alt="Read HKBCAN-CID Process Result File" />
                        <div>Read HKBCAN-CID Process Result File</div>
                    </div>
                </a>
                <a href="#/HkidrFullImageFile" onClick={() => { setRecordPgmName("Read HKBCAN Full Image File") }}>
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDocument} alt="Read HKBCAN-CID BCAN Full Image Reconcile File" />
                        <div>Read HKBCAN-CID BCAN Full Image Reconcile File</div>
                    </div>
                </a>


                {/* CM2K_USER && <a href="#/EIPO" onClick={() => { setRecordPgmName("Fini EIPO") }}>
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDocument} alt="Fini EIPO " />
                        <div> Read Fini EIPO Authorised</div>
                    </div>
                </a>*/ }

            </div> }           
            {CNBCAN &&  <Divider/>}
            {CNBCAN && <div className="Row"  >           
              
                <a href="#/CNBcanMapping" onClick={() => { setRecordPgmName("Export CNBCAN Mapping File") }}>
                    <div className="MenuTile" >
                        <img className="MenuTileImage" src={svgDownload} alt="CNBCAN-CID Mapping File" />
                        <div>Export CN BCAN-CID Mapping File</div>
                    </div>
                </a>    
                <a href="#/CNBcanResponseFile" onClick={() => { setRecordPgmName("Read CNBCAN-CID Response File") }}>
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDocument} alt="Read CNBCAN-CID Response File" />
                        <div>Read CNBCAN-CID Response File</div>
                    </div>
                </a>				
                 <a href="#/CNBcanAurpResponseFile" onClick={() => { setRecordPgmName("Read CNBCAN-CID Authorised TTEP List Response File") }}>
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDocument} alt="Read CNBCAN-CID Authorised TTEP List Response File" />
                        <div>Read CNBCAN-CID Authorised TTEP List Response File</div>
                    </div>
                </a>	
                <a href="#/CNBcanRsltResultFile" onClick={() => { setRecordPgmName("Read CNBCAN-CID Validation Result File") }}>
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDocument} alt="Read CNBCAN-CID Validation Result File" />
                        <div>Read CNBCAN-CID Validation Result File</div>
                    </div>
                </a>				


                <a href="#/CNBcanFimgFile" onClick={() => { setRecordPgmName("Read CNBCAN Full Image File") }}>
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDocument} alt="Read CNCAN-CID BCAN Full Image Reconcile File" />
                        <div>Read CNBCAN-CID BCAN Full Image Reconcile File</div>
                    </div>
                </a>
			</div>}
             
        </>
    )
}

function SideMenu_FBS({ isLoggedIn = false } : MenuBar_FBSProps) {
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />
    
    const [PgmLists, setPgmLists] = useState([] as PgmAccessList[])
    const [RecordPgmName, setRecordPgmName] = useState("")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [userKey, setuserKey] = useState("DEMO")
    const [userId, setuserId] = useState("")
    const { t, i18n } = useTranslation();    

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("SideMenu disp user_key: ", res.data.Flag.user_key)
                GsbFlag = res.data.Flag;
                //console.log("SideMenu disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                //console.log("SideMenu companyLogoName: ", GsbFlag.companyLogoName)
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                setuserKey(GsbFlag.user_key)
                setuserId( GsbFlag.UserID)
                
                setPgmLists(res.data.UserPgmListData)

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])


    useEffect(() => {
        //console.log("sidemenu RecordPgmName ", RecordPgmName)
        if ( isLoggedIn && RecordPgmName.length > 0 ) {
            (async () => {
                try {
                    // get GsbFlag from SB.XBS
                    const res = await gsb.post('/PgmEntry', {
                        cPgmName: RecordPgmName,
                        cIPAddr: "",
                    });
                    setRecordPgmName("")
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, RecordPgmName, isLoggedIn])


    function CheckPgmAccess(PgmName: string): boolean{
        var canAccess = false;

        //if (PgmName[0] == "F") return true; // TODO - for development purpose, remove when program code list is done

        for (let i = 0; i < PgmLists.length; i++) {
            //console.log("func CheckPgmAccess PgmLists", PgmName, PgmLists[i].d_PgmCode, PgmLists[i].d_PgmAccess)
            if (PgmLists[i].d_PgmCode === PgmName ) {
                //console.log("func CheckPgmAccess PgmLists", PgmName, PgmLists[i].d_PgmCode, PgmLists[i].d_PgmAccess)
                if (PgmLists[i].d_PgmAccess === "Y" ) {
                    canAccess = true;
                }
                break ;
            }
        }
        return canAccess;
    }

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>

    return (
        <>
            <div className="Spacing-V-Menu"></div>
            <div className="Row">
                <FormGroup className="Col-1-12"  >
                    {CoHead}
                </FormGroup>
            </div>
            <div className="Row">
                { CheckPgmAccess("FM0010") && <a href="#/fbs/ClMast" onClick={() => { setRecordPgmName("Account Information") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgAccount} alt="Account Information" />
                        <div>{t('Account Information')}</div>
                    </div>
                </a> }
                { CheckPgmAccess("FM0013") && <a href="#/fbs/CbMast" onClick={() => { setRecordPgmName("Account Balance") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgAccount} alt="Account Balance" />
                        <div>{t('Account Balance')}</div>
                    </div>
                </a> }
                { CheckPgmAccess("FM0015") && <a href="#/fbs/OpenPos" onClick={() => { setRecordPgmName("Position Enquiry") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgFileBox} alt="Position Enquiry" />
                        <div>{t('Position Enquiry')}</div>
                    </div>
                </a> }
                { CheckPgmAccess("FM0004") && <a href="#/fbs/ComdyMast" onClick={() => { setRecordPgmName("Commodity Information") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgFileBox} alt="Commodity Information" />
                        <div>{t('Commodity Information')}</div>
                    </div>
                </a> }
                { CheckPgmAccess("FM0007") && <a href="#/fbs/ExpiryMast" onClick={() => { setRecordPgmName("Futures Month & Expiry Date") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgFileBox} alt="Futures Month & Expiry Date" />
                        <div>{t('Futures Month & Expiry Date')}</div>
                    </div>
                </a> }
                { CheckPgmAccess("FM0024") && <a href="#/fbs/CommMast" onClick={() => { setRecordPgmName("Commission Class") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgFileBox} alt="Commission Class" />
                        <div>{t('Commission Class')}</div>
                    </div>
                </a> }

                {/* CheckPgmAccess("FM0019") &&  <a href="#/fbs/HolidayMast" onClick={() => { setRecordPgmName("Holiday Table") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgFileBox} alt="Holiday Table" />
                        <div>{t('Holiday Table')}</div>
                    </div>
                </a> */}
            </div>

            <div className="Spacing-V-16"></div>

            <div className="Row">
                { CheckPgmAccess("FT0007") && <a href="#/fbs/ClientTranEntry" onClick={() => { setRecordPgmName("Trade Entry") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgProfit} alt="Trade Entry" />
                        <div>Trade Entry</div>
                    </div>
                </a> }
                { CheckPgmAccess("FT0004") && <a href="#/fbs/FundMoveTranEntry" onClick={() => { setRecordPgmName("Fund Movement Entry") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgMoney} alt="Fund Movement Entry" />
                        <div>Fund Movement Entry</div>
                    </div>
                </a> }
                { CheckPgmAccess("FT0002") && <a href="#/fbs/CurrencyParamUpdate" onClick={() => { setRecordPgmName("Exchange Rate & Prime Rate") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgFileBox} alt="Exchange Rate & Prime Rate" />
                        <div>{t('Exchange Rate & Prime Rate')}</div>
                    </div>
                </a> }
                { CheckPgmAccess("FT0016") && <a href="#/fbs/ClosingUpdate" onClick={() => { setRecordPgmName("Closing Price") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgFileBox} alt="Closing Price" />
                        <div>{t('Closing Price')}</div>
                    </div>
                </a> }
                { CheckPgmAccess("FT0003") && <a href="#/import" onClick={() => { setRecordPgmName("Import files") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgImport} alt="Import" />
                        <div>Import files</div>
                    </div>
                </a> }
            </div>

            <div className="Spacing-V-16"></div>

            <div className="Row">
                { CheckPgmAccess("FR0001") && <a href="#/fbs/Dstatement" onClick={() => { setRecordPgmName("Daily Statement") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgFinancialreport} alt="Daily Statement" />
                        <div>Daily Statement</div>
                    </div>
                </a> }
                { CheckPgmAccess("FR0007") && <a href="#/fbs/OpenPositionRpt" onClick={() => { setRecordPgmName("Open Position Report") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDocument} alt="Open Position Report" />
                        <div>Open Position Report</div>
                    </div>
                </a> }
                { CheckPgmAccess("FR0010") && <a href="#/fbs/AcctEqMgnRpt" onClick={() => { setRecordPgmName("Account Equity & Margin Status Report") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDocument} alt="Account Equity & Margin Status Report" />
                        <div>Account Equity & Margin Status Report</div>
                    </div>
                </a> }
                { CheckPgmAccess("FR0011") && <a href="#/fbs/AcctSumRpt" onClick={() => { setRecordPgmName("Account Summary Report") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDocument} alt="Account Summary Report" />
                        <div>Account Summary Report</div>
                    </div>
                </a> }
                { CheckPgmAccess("FR0012") && <a href="#/fbs/MgnCallRpt" onClick={() => { setRecordPgmName("Margin Call Report") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgDocument} alt="Margin Call Report" />
                        <div>Margin Call Report</div>
                    </div>
                </a> }
                { CheckPgmAccess("FR0002") && <a href="#/fbs/Mstatement" onClick={() => { setRecordPgmName("Monthly Statement") }} >
                    <div className="MenuTile">
                        <img className="MenuTileImage" src={svgFinancialreport} alt="Monthly Statement" />
                        <div>Monthly Statement</div>
                    </div>
                </a> }
            </div>
        </>
    )
}

/*
interface MenuBarProps {
    isLoggedIn?: boolean,
}
*/



function MenuBar({ isLoggedIn = false, onSystemStatusClick = ()=>{}} : MenuBarProps) {
    const [showClMast, setshowClMast] = useState(true)
    const [showSmMast, setshowSmMast] = useState(true)
    const [showBkMast, setshowBkMast] = useState(true)
    const [showIntMast, setshowIntMast] = useState(true)
    const [showCommMast, setshowCommMast] = useState(true)
    const [showHolidayMast,setshowHolidayMast] = useState(true)
    const [showMktMast, setshowMktMast] = useState(true)
    const [showMktFeeMast, setshowMktFeeMast] = useState(true)
    const [showMultiBankMast, setshowMultiBankMast] = useState(true)
    const [showHKIDR2, setshowHKIDR2] = useState(true)
    const [showClientTranEntry, setshowClientTranEntry] = useState(true)
    const [showBrokerTranEntry, setshowBrokerTranEntry] = useState(true)
    const [showPayRecTranEntry, setshowPayRecTranEntry] = useState(true)
    const [showStkDepWithTranEntry, setshowStkDepWithTranEntry] = useState(true)
    const [showClientTranSettlementEntry, setshowClientTranSettlementEntry] = useState(true)
    const [showStockAllocationEntry, setshowStockAllocationEntry] = useState(true)  // 20230330
    const [showSASReport, setshowSASReport] = useState(false)
    const [showImport, setshowImport] = useState(true)


    const [showHKIDR1, setshowHKIDR1] = useState(false)
    const [GSBXHKCRS, setGSBXHKCRS] = useState(false) 
    const [CNBCAN,setCNBCAN] = useState(false)
    const [showDividendProcess, setshowDividendProcess] = useState(true)
    const [showCBBCProcess, setshowCBBCProcess] = useState(true)


    const [showStatement, setshowStatement] = useState(true)
    const [showSentEmailStatement, setshowSentEmailStatement] = useState(false)
    const [showDayEndOneProcess, setshowDayEndOneProcess] = useState(false)

    const [isDark, setIsDark] = useState(document.getElementById("body")?.classList.contains("bp4-dark"))


    const [PgmLists, setPgmLists] = useState([] as PgmAccessList[])
    const [ShowDisableItem, setShowDisableItem] = useState(true)

    const [warnSysMain, setwarnSysMain] = useState(false)
    const [warnAbout, setwarnAbout] = useState(false)
    const [isMatch, setisMatch] = useState(0)
    const [isPreDayEnd, setisPreDayEnd] = useState(0)
    const [isPrn43Chq, setisPrn43Chq] = useState(0)
    const [isSysEnd, setisSysEnd] = useState(0)


    const [Sys_VerNo, setSys_VerNo] = useState("")
    const [userKey, setuserKey] = useState("DEMO")
    const [userId, setuserId] = useState("")
    const [RecordPgmName, setRecordPgmName] = useState("")
    const [IPAddr, setIPAddr] = useState("")

    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")
    const [MULTI_MKT, setMULTI_MKT] = useState(false)
    const [SING_CURR, setSING_CURR] = useState(false)
    const [MULTI_BANK, setMULTI_BANK] = useState(false)
    const [CM2K_USER, setCM2K_USER] = useState(false)
    const [CCOMM_UPL, setCCOMM_UPL] = useState(false)
    const [ATI_USER, setATI_USER] = useState(false)
    const [EPS_USER, setEPS_USER] = useState(false)
    const { t, i18n } = useTranslation()
    const [stmtEncode, setstmtEncode] = useState("N")

    // 20230814
    const [IMPORTSTK, setIMPORTSTK] = useState(false)
    const [IMPORTCLN, setIMPORTCLN] = useState(false);    
    // 20240312
    const [IMP_CL_Mast1, setIMP_CL_Mast1] = useState(false);    
    
    // 20260821    
    const [IMP_HKIDR_Mast1, setIMP_HKIDR_Mast1] = useState(false);  

    // 20230828B
    const [SFC_EXCEL, setSFC_EXCEL] = useState(false);
    const [SFC_EXCEL2, setSFC_EXCEL2] = useState(false);

    const [MULTI_CHNL, setMULTI_CHNL] = useState(false);
    const [CL_CATEGY, setCL_CATEGY] = useState(false);
    const [FRR_TO_XLS, setFRR_TO_XLS] = useState(false);
    const [MULTI_LING,setMULTI_LING] = useState(0);
    const [SBF_USER, setSBF_USER] = useState(false);
    const [ChrgPortFee, setChrgPortFee] = useState(false);
    const [SL_USER, setSL_USER] = useState(false)
    const [SI_USER, setSI_USER] = useState(false)

    const [PgmListsLoaded, setPgmListsLoaded] = useState(false) 
   	const [items, setItems] = useState([] as MenuItemProps[])
    const [selectedItem, setSelectedItem] = useState({} as MenuItemProps)

    let allMenuItems = [] as MenuItemProps[]

    const addMenuItem = (PgmName: string, item: MenuItemProps): JSX.Element => {
//console.log("addMenuItem PgmLists", PgmLists)
//console.log("addMenuItem PgmName", PgmName, item)
        // check can show
        if ( CheckPgmAccess3(PgmName) ) {
            // setItems([...items, item])
            // check can access, disable
            if ( ! CheckPgmAccess(PgmName) ) {
                if ( ShowDisableItem ) {
                    item.disabled=true
                } else {
                    return <></>
                }
            }

            allMenuItems.push(item)
            // console.log("addMenuItem", item.text, allMenuItems.length)
            return <MenuItem {...item}></MenuItem>
        }
        return <></>
    }

    //for FBSx user
    const [FBSx_USER, setFBSx_USER] = useState(false);

    document.title = 'POP-GSBx' 

    useEffect(() => {
        if ( isLoggedIn ) {
            (async () => {
                try {
                    // get GsbFlag from SB.XBS
                    const res = await gsb.post('/GsbFlag');
                    //console.log("MenuBar disp user_key: ", res.data.Flag.user_key)
                    GsbFlag = res.data.Flag;
                    //console.log("MenuBar disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                    setSys_VerNo("v"+GsbFlag.Sys_VerNo)
                    setuserKey(GsbFlag.user_key)
                    setuserId( GsbFlag.UserID)
                    setMULTI_MKT(GsbFlag.MULTI_MKT)
                    setSING_CURR(GsbFlag.SING_CURR)
                    setMULTI_BANK(GsbFlag.MULTI_BANK)
                    setCM2K_USER( GsbFlag.CM2K_USER);
                    setCCOMM_UPL(GsbFlag.CCOMM_UPL);  
                    setATI_USER( GsbFlag.ATI_USER);
                    setEPS_USER( GsbFlag.EPS_USER);
                    setshowSentEmailStatement(GsbFlag.EMAIL_STMT)
                    setshowHKIDR1(GsbFlag.HKIDR_USER1)
                    setGSBXHKCRS(GsbFlag.GSBXHKCRS)
                    setCNBCAN(GsbFlag.CNBCAN)
                    setshowSASReport(GsbFlag.SAS_MKT)
                    setstmtEncode(GsbFlag.stmtEncode)
                    //console.log(GsbFlag.stmtEncode)

                    // 20230814 
                    setIMPORTCLN(GsbFlag.IMPORTCLN)
					// 20240312
					setIMP_CL_Mast1(GsbFlag.IMP_CL_Mast1)					
                    // 20260821 kk
					setIMP_HKIDR_Mast1(GsbFlag.IMP_HKIDR_Mast1)
                    //console.log("IMP_HKIDR_Mast1=",GsbFlag.IMP_HKIDR_Mast1)
                    setIMPORTSTK(GsbFlag.IMPORTSTK)
                    // 20230829
                    setSFC_EXCEL(GsbFlag.SFC_EXCEL)
                    setSFC_EXCEL2(GsbFlag.SFC_EXCEL2)

                    setMULTI_CHNL(GsbFlag.MULTI_CHNL)
                    setCL_CATEGY(GsbFlag.CL_CATEGY)
                    setFRR_TO_XLS(GsbFlag.FRR_TO_XLS)
                    setSBF_USER(GsbFlag.SBF_USER)
                    setChrgPortFee(GsbFlag.ChrgPortFee)
                    
                    if ( GsbFlag.isProduction == "Y" ) {
                        setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                    } else {
                        setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                    }

                    setMULTI_LING(GsbFlag.MULTI_LING)


                    setFBSx_USER(GsbFlag.FBSx_USER)
                    setSL_USER(GsbFlag.SL_USER)
                    setSI_USER(GsbFlag.SI_USER)


                    setPgmLists(res.data.UserPgmListData)
                    //console.log("MenuBar res.data.UserPgmListData", res.data.UserPgmListData)
                    //console.log("MenuBar PgmLists", PgmLists)

                    if ( GsbFlag.Show_Disabled_Menu_Item == "N" ) {
                        setShowDisableItem(false)
                    } else  {
                        setShowDisableItem(true)
                    }

                    //i18next.changeLanguage("zh-HK") ;
                    //i18next.changeLanguage("zh-CN") ;
                    i18next.changeLanguage("en") ;

                } catch (error) {
                    utils.showError(error)
                }
            })()
        } else {
            (async () => {
                try {
                    const res = await gsb.post('/GsbFlag0');
                    setSys_VerNo("v"+res.data.Flag.Sys_VerNo)
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, isLoggedIn])


    useEffect(() => {
        setwarnSysMain(false)
        setwarnAbout(false)

        ;
        if ( isLoggedIn ) {
            (async () => {
            try {
                const res = await gsb.post('/SysMaint',
                    {   sb_data: {
                        //
                   },
                    cPgmId: "GetIconWarnInfo",
                });
                if ( res.data.ok ) {
                    //"GetIconWarnInfo res.data.data", res.data.data)
                    setwarnSysMain(res.data.data[0].warnAbout) 
                    setwarnAbout(res.data.data[0].warnAbout) 
                    // setisMatch(res.data.data[0].isMatch) 
                    // setisPreDayEnd(res.data.data[0].isPreDayEnd) 
                    // setisPrn43Chq(res.data.data[0].isPrn43Chq) 
                    // setisSysEnd(res.data.data[0].isSysEnd) 
                }
            } catch (error) {
                utils.showError(error)
            }
        })()


        }
 
    }, [gsb, isLoggedIn, userId, GsbFlag, Sys_VerNo])


    useEffect(() => {
        //console.log("MenuBar cardOpen01", cardOpen01)        
        if ( cardOpen01.substr(0,17) === "cardOpen01-Theme8" ) {
            document.getElementById("body")?.classList.add("bp4-dark")
            setIsDark(true)
        } else {
            document.getElementById("body")?.classList.remove("bp4-dark")
            setIsDark(false)
        }


    }, [gsb, isLoggedIn, userId, GsbFlag, cardOpen01])


    useEffect(() => {
        //console.log("MenuBar_FBS useEffect() [PgmListsLoaded]", allMenuItems.length, PgmListsLoaded)
        setItems(allMenuItems)
    }, [PgmListsLoaded, ShowDisableItem])


    useEffect(() => {
        if (PgmLists.length > 0) {
            setPgmListsLoaded(true)
            
            if ( ! ShowDisableItem ) {
                if ( CheckPgmAccess("M0001") || CheckPgmAccess("M0002") || CheckPgmAccess("M0003") || CheckPgmAccess("M0004") || CheckPgmAccess("M0023") ) {
                    setshowClMast(true)
                } else {
                    setshowClMast(false)
                }

                if ( CheckPgmAccess("M0005") || CheckPgmAccess("M0006") ) {
                    setshowBkMast(true)
                } else {
                    setshowBkMast(false)
                }

                if ( CheckPgmAccess("M0007") || CheckPgmAccess("M0008") || CheckPgmAccess("M0022") ) {
                    setshowSmMast(true)
                } else {
                    setshowSmMast(false)
                }

                if ( CheckPgmAccess("M0009") || CheckPgmAccess("M0010") || CheckPgmAccess("M0018") ) {
                    setshowIntMast(true)
                } else {
                    setshowIntMast(false)
                }

                if ( CheckPgmAccess("M0011") || CheckPgmAccess("M0012") ) {
                    setshowCommMast(true)
                } else {
                    setshowCommMast(false)
                }
                if (CheckPgmAccess("M0032")){
                    setshowHolidayMast(true)
                } else {
                    setshowHolidayMast(false)
                }

                
                if ( CheckPgmAccess("M0013") || CheckPgmAccess("M0014") ) {
                    setshowMktMast(true)
                } else {
                    setshowMktMast(false)
                }

                if ( CheckPgmAccess("M0015") || CheckPgmAccess("M0016") ) {
                    setshowMktFeeMast(true)
                } else {
                    setshowMktFeeMast(false)
                }

                if ( MULTI_BANK ) {
                    if ( CheckPgmAccess("M0019") || CheckPgmAccess("M0020") || CheckPgmAccess("M0021") ) {
                        setshowMultiBankMast(true)
                    } else {
                        setshowMultiBankMast(false)
                    }
                } else {
                    setshowMultiBankMast(false)
                }

                if ( CheckPgmAccess("H0001") || CheckPgmAccess("H0002")  || CheckPgmAccess("H0003") || CheckPgmAccess("H0004") || CheckPgmAccess("H0005") || CheckPgmAccess("H0006") || CheckPgmAccess("H0007") || CheckPgmAccess("H0008") || CheckPgmAccess("H0009") || CheckPgmAccess("H0010") ) {
                    setshowHKIDR2(true)
                } else {
                    setshowHKIDR2(false)
                }
                

                if ( CheckPgmAccess("T0001") || CheckPgmAccess("T0002") || CheckPgmAccess("T0003") ) {
                    setshowClientTranEntry(true)
                } else {
                    setshowClientTranEntry(false)
                }
                
                if ( CheckPgmAccess("T0004") || CheckPgmAccess("T0005") || CheckPgmAccess("T0006") ) {
                    setshowBrokerTranEntry(true)
                } else {
                    setshowBrokerTranEntry(false)
                }
                
                if ( CheckPgmAccess("T0007") || CheckPgmAccess("T0008") || CheckPgmAccess("T0009") ) {
                    setshowPayRecTranEntry(true)
                } else {
                    setshowPayRecTranEntry(false)
                }

                if ( CheckPgmAccess("T0010") || CheckPgmAccess("T0011") || CheckPgmAccess("T0012") || CheckPgmAccess("T0013") ) {
                    setshowStkDepWithTranEntry(true)
                } else {
                    setshowStkDepWithTranEntry(false)
                }

                if ( CheckPgmAccess("T0017") || CheckPgmAccess("T0020") || CheckPgmAccess("T0021") ) {
                    setshowClientTranSettlementEntry(true)
                } else {
                    setshowClientTranSettlementEntry(false)
                }

                if ( CheckPgmAccess("T0019") ) {    // 20230330
                    setshowStockAllocationEntry(true)
                } else {
                    setshowStockAllocationEntry(false)
                }

            }

            if ( userKey == "FAIREAGLE" ) {
                setshowStatement(false)
            }

            if ( userKey == "DEMO" ) {
                //setShowEditUser(false)
            } else {
                //setShowEditUser(true)
            }

            if ( userKey == "DEMO" || userKey == "BENDURA" || userKey == "DJSEC" || userKey == "GEO") {
                setshowDayEndOneProcess(true)
            } else {
                setshowDayEndOneProcess(false)
            }

            if ( MULTI_MKT && SING_CURR)  {
                setshowMktMast(false)
                setshowMktFeeMast(false)
            }

        }
    }, [gsb, isLoggedIn, userId, GsbFlag, MULTI_BANK, PgmLists])

/*
    useEffect(() => {
        (async () => {
            try {
                const response = await fetch('http://api.ipify.org/?format=json')
                const data = await response.json();
                setIPAddr(data["ip"])
                //console.log("App  IPAddr: ", data["ip"])    
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb, isLoggedIn])
*/

    useEffect(() => {
        if ( isLoggedIn && RecordPgmName.length > 0 ) {
            (async () => {
                try {
                    // get GsbFlag from SB.XBS
                    const res = await gsb.post('/PgmEntry', {
                        cPgmName: RecordPgmName,
                        cIPAddr: IPAddr,
                    });
                    setRecordPgmName("")
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, RecordPgmName, isLoggedIn])
    

    // User can Access Pgm or disable
    function CheckPgmAccess(PgmName: string): boolean{
        var canAccess = false;

        for (let i = 0; i < PgmLists.length; i++) {
            //console.log("func CheckPgmAccess PgmLists", PgmName, PgmLists[i].d_PgmCode, PgmLists[i].d_PgmAccess)
            if (PgmLists[i].d_PgmCode === PgmName ) {
                //console.log("func CheckPgmAccess PgmLists", PgmName, PgmLists[i].d_PgmCode, PgmLists[i].d_PgmAccess)
                if (PgmLists[i].d_PgmAccess === "Y" ) {
                    canAccess = true;
                }
                break ;
            }
        }
        return canAccess;
    }

    //is isReadOnly
    function CheckPgmAccess2(PgmName: string): boolean{
        var canAccess = true;

        for (let i = 0; i < PgmLists.length; i++) {
            //console.log("func CheckPgmAccess PgmLists", PgmName, PgmLists[i].d_PgmCode, PgmLists[i].d_PgmAccess)
            if (PgmLists[i].d_PgmCode === PgmName ) {
                //console.log("func CheckPgmAccess PgmLists", PgmName, PgmLists[i].d_PgmCode, PgmLists[i].d_PgmAccess)
                if (PgmLists[i].d_PgmAction === "R" ) {
                    canAccess = false;
                }
                break ;
            }
        }
        return canAccess;
    }

    // User can Executive Pgm, paid module , buy ?
    function CheckPgmAccess3(PgmName: string): boolean{
        var canShow = true;

        for (let i = 0; i < PgmLists.length; i++) {
            //console.log("func CheckPgmAccess PgmLists", PgmName, PgmLists[i].d_PgmCode, PgmLists[i].d_PgmAccess)
            if (PgmLists[i].d_PgmCode === PgmName ) {
                //console.log("func CheckPgmAccess PgmLists", PgmName, PgmLists[i].d_PgmCode, PgmLists[i].d_PgmAccess)
                if  ( ! (PgmLists[i].d_PgmCanExec === "Y") ) {
                    canShow = false;
                }
                break ;
            }
        }
        return canShow;
    }
    

    const imgLogo = <img className="AppLogo" src={svgLogo} alt="Logo" />
    const imgAccount = <img className="MenuIcon" src={svgAccount} alt="Account" />
    const imgMaster = <img className="MenuIcon" src={svgMaster} alt="Master" />
    const imgDocument = <img className="MenuIcon" src={svgDocument} alt="Document" />
    const imgMoney = <img className="MenuIcon" src={svgMoney} alt="Money" />
    const imgFinancialreport = <img className="MenuIcon" src={svgFinancialreport} alt="Financialreport" />
    const imgzipDocument = <img className="MenuIcon" src={svgZip} alt="Zipdocument" />
    const imgTransaction = <img className="MenuIcon" src={svgInput} alt="Transaction" />
    const imgImport = <img className="MenuIcon" src={svgImport} alt="Import" />
    const imgUser = <img className="MenuIcon" src={svgUser} alt="Login" />
    const imgTask = <img className="MenuIcon" src={svgTask} alt="Task" />
    const imgChecklist = <img className="MenuIcon" src={svgChecklist} alt="Checklist" />
    const imgbuild = <img className="MenuIcon" src={svgbuild} alt="Utility" />
    const imgsort_asc = <img className="MenuIcon" src={svgsort_asc} alt="Sort" />
    const imgtick_circle = <img className="MenuIcon" src={tick_circle} alt="completed" />
    const history = useHistory()

        const menuMaster =
        <Popover minimal position={Position.BOTTOM_LEFT} content={
            <Menu>
                { showClMast && 
                    <MenuItem icon={imgAccount} text="Client Master">
                        {/* CheckPgmAccess("M0001") && <MenuItem icon={imgAccount} text="21 Client Account" onClick={() => { setRecordPgmName("21 ClMast") }} href="#/accounts" /> */}
                        {/* CheckPgmAccess("M0001") && addMenuItem({ icon:imgAccount, text:"21 Client Account", onClick:() => { setRecordPgmName("21 ClMast") }, href:"#/accounts" }) */}
                        { addMenuItem("M0001", { icon:imgAccount, disabled:(false), text:"21 Client Account", onClick:() => { setRecordPgmName("21 ClMast") }, href:"#/accounts" }) }
                        { CheckPgmAccess("M0033") && ( userKey == "CHEERFUL" )  && <MenuItem icon={imgAccount} text="Client Control Document Set" onClick={() => { setRecordPgmName("Client Control Document set") }} href="#/accounts_DocSet" /> }                 
                        { CheckPgmAccess("M0023") && ( userKey == "CHEERFUL" ) && <MenuItem icon={imgImport} text="Import Client Master 2 (Chinese Name)" onClick={() => { setRecordPgmName("Import Clmast 2(Chinese Name)") }} href="#/ImportClMast2" />  }
                        {/* 20230814 */}
                        {  ( IMPORTCLN ) && addMenuItem("M0026", { icon:imgImport, text:"21I Import Client Master from Text File", onClick:() => { setRecordPgmName("21I Import Client Master from Text File") }, href:"#/ImportClMast3" }) }
                        {/* 20240312 */}
						{ ( IMP_CL_Mast1 ) && addMenuItem("M0034", { icon:imgImport, text:"Import Client from Text File to HKIDR/Client ", onClick:() => { setRecordPgmName("21I Import Client Master from Text File") }, href:"#/ImportClMast1" }) }
                        { addMenuItem("M0004", { icon:imgDocument, text:"21L Client Master Audit Log", onClick:() => { setRecordPgmName("21L ClLog") }, href:"#/ClLog" }) }
                        <MenuDivider />
                        { addMenuItem("M0002", { icon:imgDocument, text:"25 Client Master List", onClick:() => { setRecordPgmName("25 ClACList") }, href:"#/ClACList" }) }
                        { ( CheckPgmAccess("M0044") || CheckPgmAccess("M0047") || CheckPgmAccess("M0048") ) &&  <MenuItem icon={imgAccount} text="Global Change Client Data">
                            { addMenuItem("M0047", { icon:imgDocument, text:"Change Runner Code", onClick:() => { setRecordPgmName("Change Runner Code") }, href:"#/ChangeRunnerCode" }) }
                            { addMenuItem("M0048", { icon:imgDocument, text:"Change Comm / Interest Code by Runner", onClick:() => { setRecordPgmName("Change Comm / Int Code by Runner") }, href:"#/ChangeCommIntCode" }) }
                            { addMenuItem("M0044", { icon:imgDocument, text:"Margin Contract Renewal List", onClick:() => { setRecordPgmName("Contract Renewal List") }, href:"#/ContractRenewList" }) }
                        </MenuItem> }
                        { SBF_USER && CheckPgmAccess("M0050") && <MenuDivider /> }
                        { SBF_USER && addMenuItem("M0050", { icon:imgDocument, text:"212 Post Client General Information to Finance System", onClick:() => { setRecordPgmName("212 Post Client Information to Finance System") }, href:"#/ClSBtoFin" }) }
                    </MenuItem>
                }
                { showHKIDR1 && showHKIDR2 &&
                    <MenuItem icon={imgAccount} text="HKIDR">
                        <MenuItem icon={imgAccount} text="HKIDR Master">
                            { addMenuItem("H0001", { icon:imgAccount, text:"Import Client from GSB (New Client)", onClick:() => { setRecordPgmName("Import Client from GSB (New Client)") }, href:"#/HkidrImpAccount" }) }
                            { ( IMP_CL_Mast1 ) && addMenuItem("M0034", { icon:imgImport, text:"Import Client from Text File to HKIDR/Client", onClick:() => { setRecordPgmName("21I Import Client Master from Text File") }, href:"#/ImportClMast1" }) }
                            { ( IMP_HKIDR_Mast1 ) && addMenuItem("M0035", { icon:imgImport, text:"Import HKIDR TAB from Text File", onClick:() => { setRecordPgmName("Import Client Master from Text File to HKIDR") }, href:"#/ImportHKIDRMast1" }) }
                
                            <MenuDivider />
                            { addMenuItem("H0002", { icon:imgAccount, text:"HKIDR Master", onClick:() => { setRecordPgmName("HKIDR Master") }, href:"#/HkidrMast" }) }
                            { addMenuItem("H0003", { icon:imgDocument, text:"HKIDR Master List", onClick:() => { setRecordPgmName("HKIDR Master List") }, href:"#/HkidrMastList" }) }
                            { addMenuItem("H0004", { icon:imgDocument, text:"HKIDR Master Audit Log", onClick:() => { setRecordPgmName("HKIDR Audit Log") }, href:"#/HkidrLog" }) }
                            { addMenuItem("H0005", { icon:imgDocument, text:"GSB Client Name Change Log", onClick:() => { setRecordPgmName("GSB Client Name Change Log") }, href:"#/GsbNameChangeLog" }) }
                            <MenuDivider />
                            { addMenuItem("H0006", { icon:imgAccount, text:"Import HK Consent Status (CSV)", onClick:() => { setRecordPgmName("Import HK Consent Status") }, href:"#/importHkconsentCSV" }) }

                            {/*<MenuDivider />*/}
                            {/* addMenuItem("H0007", { icon:imgAccount, text:"Generate CNBcan", onClick:() => { setRecordPgmName("Generate CNBcan") }, href:"#/CNBcanGen" }) */}
                        </MenuItem>
                        <MenuItem icon={imgAccount} text="Print/Export Consent">
                            { addMenuItem("H0008", { icon:imgAccount, text:"Print HK Consent", onClick:() => { setRecordPgmName("Print HK RConsent") }, href:"#/HkidrHkConsent" }) }
                            { addMenuItem("H0009", { icon:imgAccount, text:"Export HK Consent Status for Mail Merge (CSV)", onClick:() => { setRecordPgmName("Export HK Consent Status") }, href:"#/ExportHkConsent" }) }
                        </MenuItem>
                        <MenuItem icon={imgAccount} text="BCAN-CID Mapping/Result File">
                            { CheckPgmAccess("H0010") && <MenuItem icon={imgAccount} text="HKBCAN-CID">
                                { addMenuItem("H0010", { icon:imgDocument, text:"Export HKBCAN-CID Mapping File", onClick:() => { setRecordPgmName("Export HKBCAN Mapping File") }, href:"#/HkidrBcanMapping" }) }
                                <MenuDivider />
                                { addMenuItem("H0010", { icon:imgDocument, text:"Read HKBCAN-CID Response File", onClick:() => { setRecordPgmName("Read HKBCAN Response File") }, href:"#/HkidrResponseFile" }) }
                                { addMenuItem("H0010", { icon:imgDocument, text:"Read HKBCAN-CID Process Result File", onClick:() => { setRecordPgmName("Read HKBCAN Result File") }, href:"#/HkidrProcessResultFile" }) }
                                { addMenuItem("H0010", { icon:imgDocument, text:"Read HKBCAN-CID BCAN Full Image Reconcile File", onClick:() => { setRecordPgmName("Read HKBCAN Full Image File") }, href:"#/HkidrFullImageFile" }) }
                            </MenuItem> }

                            { CNBCAN &&  <MenuItem icon={imgAccount} text="CNBCAN"> 
                                { addMenuItem("H0022", { icon:imgDocument, text:"Export CNBCAN-CID Mapping File", onClick:() => { setRecordPgmName("Export CNBCAN-CID Mapping File") }, href:"#/CNBcanMapping" }) }
                                {/* addMenuItem("H0022", { icon:imgDocument, text:"Export CNBCAN-CID Authorised TTEP Firm List", onClick:() => { setRecordPgmName("Export CNBCAN-CID Authorised TTEP Firm List") }, href:"#/CNBcanAuFM" }) */}
                                <MenuDivider />
                                
                                { addMenuItem("H0023", { icon:imgDocument, text:"Read CNBCAN-CID Response File", onClick:() => { setRecordPgmName("Read CNBCAN-CID Response File") }, href:"#/CNBcanResponseFile" }) }
                                { addMenuItem("H0023", { icon:imgDocument, text:"Read CNBCAN-CID Authorised TTEP List Response File", onClick:() => { setRecordPgmName("Read CNBCAN-CID Result File") }, href:"#/CNBcanAurpResponseFile" }) }
                                { addMenuItem("H0023", { icon:imgDocument, text:"Read CNBCAN-CID validation result File", onClick:() => { setRecordPgmName("Read CNBCAN-CID Result File") }, href:"#/CNBcanRsltResultFile" }) }
                                { addMenuItem("H0023", { icon:imgDocument, text:"Read CNBCAN-CID BCAN Full Image Reconcile File", onClick:() => { setRecordPgmName("Read CNBCAN-CID Full Image File") }, href:"#/CNBcanFimgFile" }) }
                                </MenuItem>
                            }

                            { addMenuItem("H0011", { icon:imgDocument, text:"Export OTCR Report File (D/W)", onClick:() => { setRecordPgmName("Export OTCR Report File (D/W)") }, href:"#/HkidrOtcr" }) }
                            { addMenuItem("H0011", { icon:imgDocument, text:"Export OTCR Report File (D/W) in History", onClick:() => { setRecordPgmName("Export OTCR Report File (D/W) in History") }, href:"#/HkidrOtcr2" }) }
                        </MenuItem>
                        <MenuItem icon={imgAccount} text="Configuration">
                            { addMenuItem("S0002", { icon:imgDocument, text:"BCAN Configuration", onClick:() => { setRecordPgmName("BcanConfig") }, href:"#/BcanConfig" }) }
                        </MenuItem>
                    </MenuItem>
                }
                { GSBXHKCRS &&
                    <MenuItem icon={imgAccount} text="CRS">
                        { addMenuItem("H0013", { icon:imgAccount, text:"CRS Import Client from GSB", onClick:() => { setRecordPgmName("CRS Import Client from GSB") }, href:"#/HkCrsImpAccount" }) }
                        { addMenuItem("H0014", { icon:imgAccount, text:"CRS Data Import Client from GSB", onClick:() => { setRecordPgmName("CRS Data Import Client from GSB") }, href:"#/HkCrsDataImpAccount" }) }
                        {<MenuDivider />}
                        { addMenuItem("H0015", { icon:imgAccount, text:"CRS Master", onClick:() => { setRecordPgmName("CRS Master") }, href:"#/HkCrsMast" }) }
                        { addMenuItem("H0016", { icon:imgAccount, text:"CRS Master List", onClick:() => { setRecordPgmName("CRS Master List") }, href:"#/HkCrsMastList" }) }          
                        { addMenuItem("H0017", { icon:imgAccount, text:"CRS Master Audit Log", onClick:() => { setRecordPgmName("CRS Master Audit Log") }, href:"#/HkCrsLog" }) }
                        { addMenuItem("H0018", { icon:imgAccount, text:"CRS Data Master", onClick:() => { setRecordPgmName("Crs Data Master") }, href:"#/HkCrsDataMast" }) }
                        { addMenuItem("H0019", { icon:imgAccount, text:"CRS Data Master Audit Log", onClick:() => { setRecordPgmName("CRS Data Master Audit Log") }, href:"#/HkCrsDLog" }) }
                        { addMenuItem("H0020", { icon:imgAccount, text:"CRS Export", onClick:() => { setRecordPgmName("CrsExport") }, href:"#/HkCrsExport" }) }
                        {/* addMenuItem("H0024", { icon:imgAccount, text:"Fatca Nil Export", onClick:() => { setRecordPgmName("FatcaNilExport") }, href:"#/FatcaNilExport" }) */}
                   
                        <MenuDivider />
                        { addMenuItem("H0021", { icon:imgAccount, text:"GSB Data For CRS enquiry", onClick:() => { setRecordPgmName("CrsExport") }, href:"#/HkCrsEnquiry" }) }
                      
                        <MenuDivider />
                        { addMenuItem("S0013", { icon:imgAccount, text:"CRS Configuration", onClick:() => { setRecordPgmName("CrsConfig") }, href:"#/CrsConfig" }) }
                    </MenuItem>
                }
                { showBkMast &&
                    <MenuItem icon={imgAccount} text="Broker Master">
                        { addMenuItem("M0005", { icon:imgAccount, text:"22 Broker Master", onClick:() => { setRecordPgmName("22 BkMast") }, href:"#/BkMast" }) }
                        { addMenuItem("M0006", { icon:imgDocument, text:"22L Broker Master Audit Log", onClick:() => { setRecordPgmName("22L BkLog") }, href:"#/BkLog" }) }
                    </MenuItem>
                }
                { showSmMast &&
                    <MenuItem icon={imgAccount} text="Stock Master">
                        { addMenuItem("M0007", { icon:imgAccount, text:"23 Stock Master", onClick:() => { setRecordPgmName("23 SmMast") }, href:"#/SmMast" }) }
                        { addMenuItem("M0022", { icon:imgAccount, text:"27 Stock List", onClick:() => { setRecordPgmName("27 STock List") }, href:"#/SmList" }) }
                        {/* 20230828 */}
                        { ( MULTI_LING >= 1 ) && addMenuItem("M0028", { icon:imgImport, text:"Import Stock Master (Chinese Name)", onClick:() => { setRecordPgmName("Import Stock Master (Chinese Name)") }, href:"#/ImportStkMast2" }) }
                        {/* 20230814 */}
                        { ( IMPORTSTK ) && addMenuItem("M0027", { icon:imgImport, text:"23I Import Stock Master from Text File", onClick:() => { setRecordPgmName("23I Import Stock Master from Text File") }, href:"#/ImportStkMast" }) }
                        { addMenuItem("M0049", { icon:imgImport, text:"Import Stock Master from Xlsx File", onClick:() => { setRecordPgmName("Import Stock Master from Xlsx File") }, href:"#/ImportStkMast3" }) }
                        { addMenuItem("M0045", { icon:imgImport, text:"Import Newly Issued Warrant / CBBC From CSV File", onClick:() => { setRecordPgmName("Import Newly Warrant / CBBC") }, href:"#/ImportNewlyWarrantCBBC" }) }
                        { addMenuItem("M0046", { icon:imgImport, text:"Import Expiring Warrant / CBBC From CSV File", onClick:() => { setRecordPgmName("Import Expiring Warrant / CBBC") }, href:"#/ImportExpiringWarrantCBBC" }) }
                        {/* 20230829 */}
                        { addMenuItem("M0008", { icon:imgDocument, text:"23L Stock Master Audit Log", onClick:() => { setRecordPgmName("23L SmLog") }, href:"#/SmLog" }) }
                        { SBF_USER && CheckPgmAccess("M0051") && <MenuDivider /> }
                        { SBF_USER && addMenuItem("M0051", { icon:imgDocument, text:"Post Stock Information to Finance System", onClick:() => { setRecordPgmName("Post Stock Information to Finance System") }, href:"#/StkSBtoFin" }) }

                        <MenuItem icon={imgDocument} text="Others">
                            {/* M0029 not use , move to R0046 Stock Market Value Stress Test /*}
                            {/* CheckPgmAccess("M0029") && ( SFC_EXCEL ) && <MenuItem icon={imgImport} text="23O4 Import CSV File To Specific Stock As Zero Value" onClick={() => { setRecordPgmName("23O4 Import CSV File To Specific Stock As Zero Value") }} href="#/ImportStkMastNil" />  */}
                            { ( SFC_EXCEL ) && addMenuItem("M0030", { icon:imgImport, text:"23O5 Import 'MGN' & 'TIER' From CSV File", onClick:() => { setRecordPgmName("23O5 Import 'MGN' & 'TIER' From CSV File") }, href:"#/ImportStkMastMarginRatio" }) }
                            { ( userKey == "BENDURA" ) && addMenuItem("M0030", { icon:imgImport, text:"23O5 Import 'MGN' & 'Asset Grade' From CSV File", onClick:() => { setRecordPgmName("23O5 Import 'MGN' & 'TIER' From CSV File") }, href:"#/ImportStkMastMarginRatio" }) }
                            { ( SFC_EXCEL2 || userKey == "CHEERFUL") && addMenuItem("M0031", { icon:imgImport, text:"23O6 Import CSV File To Connected Stock Group", onClick:() => { setRecordPgmName("23O6 Import CSV File To Connected Stock Group") }, href:"#/ImportStkMastGroup" }) }                                          
                            { CheckPgmAccess("M0038") && <MenuDivider />}
                            { addMenuItem("M0038", { icon:imgAccount, text:"71I Import HKEX Month-End Closing Statistics (for FRR)", onClick:() => { setRecordPgmName("71I Import HKEX Month-End Closing Statistics (for FRR)") }, href:"#/ImportStkMcd_mb" }) }
                            { addMenuItem("M0038", { icon:imgAccount, text:"232 Stock Trading Statistics", onClick:() => { setRecordPgmName("232 Stock Trading Statistics") }, href:"#/StkTradingStatisics" }) }
                            { addMenuItem("M0038", { icon:imgAccount, text:"232 Stock Trading Statistics Report", onClick:() => { setRecordPgmName("232 Stock Trading Statistics Report") }, href:"#/StkTradingStatisicsRpt" }) }
                        </MenuItem>
                    </MenuItem>
                }
                <MenuDivider />
                { showIntMast &&
                    <MenuItem icon={imgAccount} text="Interest Master">
                        { addMenuItem("M0009", { icon:imgAccount, text:"11 Interest Master", onClick:() => { setRecordPgmName("11 IntRMast") }, href:"#/IntRMast" }) }
                        { addMenuItem("M0018", { icon:imgDocument, text:"Interest Rate Report", onClick:() => { setRecordPgmName("Interest Rate Report") }, href:"#/IntRMastList" }) }
                        { addMenuItem("M0010", { icon:imgDocument, text:"11L Interest Master Audit Log", onClick:() => { setRecordPgmName("11L IntRLog") }, href:"#/IntRLog" }) }
                        { addMenuItem("M0052", { icon:imgAccount, text:"Prime Interest Rate", onClick:() => { setRecordPgmName("PrimeRateMast") }, href:"#/PrimeRateMast" }) }
                    </MenuItem>
                }
                { showCommMast &&
                    <MenuItem icon={imgAccount} text="Commission Master">
                        { addMenuItem("M0011", { icon:imgAccount, text:"12 Commission Master", onClick:() => { setRecordPgmName("12 CommMast") }, href:"#/CommMast" }) }
                        { addMenuItem("M0012", { icon:imgDocument, text:"12L Commission Master Audit Log", onClick:() => { setRecordPgmName("12L CommLog") }, href:"#/CommLog" }) }
                    </MenuItem>
                }

               { showHolidayMast &&
                    <MenuItem icon={imgAccount} text="Holiday">
                       { addMenuItem("M0032", { icon:imgAccount, text:"1H Holiday Master", onClick:() => { setRecordPgmName("1H Holiday Master") }, href:"#/HolidayMast" }) }
                       { addMenuItem("M0032", { icon:imgDocument, text:"Holiday Table Report", onClick:() => { setRecordPgmName("Holiday Table Report") }, href:"#/HolidayMastList" }) }
                       {/*addMenuItem("M0032", { icon: imgDocument, text: "Holiday Hk to Cny", onClick: () => { setRecordPgmName("Holiday Hk to Cny") }, href: "#/HolidayHktoCny" })*/}


                        {addMenuItem("M0032", { icon: imgImport, text: "Import Holiday Table from Xlsx File", onClick: () => { setRecordPgmName("Import Mholiday from Xlsx File") }, href: "#/ImportMHoliday" })}

                    </MenuItem>
                }
                { showMultiBankMast && MULTI_BANK &&
                    <MenuItem disabled={SING_CURR} icon={imgAccount} text="Multiple Bank Master">
                        { addMenuItem("M0019", { icon:imgAccount, text:"1K Multiple Bank Master", onClick:() => { setRecordPgmName("1K MultiBankMast") }, href:"#/MultiBankMast" }) }
                        { addMenuItem("M0020", { icon:imgDocument, text:"Multiple Bank Table Report", onClick:() => { setRecordPgmName("Multi-Bank Master List") }, href:"#/MultiBankMastList" }) }
                        { addMenuItem("M0021", { icon:imgDocument, text:"1KL Multiple Bank Master Audit Log", onClick:() => { setRecordPgmName("1KL MultiBankLog") }, href:"#/MultiBankLog" }) }
                    </MenuItem>
                } 
                { showMktMast &&
                    <MenuItem disabled={SING_CURR} icon={imgAccount} text="Market Master">
                        { addMenuItem("M0013", { icon:imgAccount, text:"23M Market Master", onClick:() => { setRecordPgmName("23M MktMast") }, href:"#/MktMast" }) }
                        { addMenuItem("M0014", { icon:imgDocument, text:"23ML Market Master Audit Log", onClick:() => { setRecordPgmName("23ML MktLog") }, href:"#/MktLog" }) }
                    </MenuItem>
                }
                { showMktFeeMast &&
                    <MenuItem disabled={SING_CURR} icon={imgAccount} text="Market Fee Master">
                        { addMenuItem("M0015", { icon:imgAccount, text:"23F Market Fee Master", onClick:() => { setRecordPgmName("23F MktFeeMast") }, href:"#/MktFeeMast" }) }
                        { addMenuItem("M0016", { icon:imgDocument, text:"23FL Market Fee Master Audit Log", onClick:() => { setRecordPgmName("23FL MktFeeLog") }, href:"#/MktFeeLog" }) }
                    </MenuItem>
                }
                <MenuItem disabled={SING_CURR} icon={imgAccount} text="Exchange Rate">
                    { addMenuItem("M0024", { icon:imgAccount, text:"122 Exchange Rate Setup", onClick:() => { setRecordPgmName("122 Exchange Rate Setup") }, href:"#/ExchangeRate" }) }
                    { addMenuItem("M0025", { icon:imgDocument, text:"122 Exchange Rate Report", onClick:() => { setRecordPgmName("122 Exchange Rate Report") }, href:"#/ExchangeRateList" }) }
                </MenuItem>

                { GsbFlag.STD_INST && <MenuItem icon={imgAccount} text="Standing Instruction">
                    { addMenuItem("M0039", { icon:imgAccount, text:"Standing Instruction Code Setup", onClick:() => { setRecordPgmName("Standing Instruction Code Setup") }, href:"#/StdInstSetup" }) }
                    { addMenuItem("M0040", { icon:imgAccount, text:"Standing Instruction Entry", onClick:() => { setRecordPgmName("Standing Instruction Entry") }, href:"#/StdMast" }) }
                    { addMenuItem("M0041", { icon:imgAccount, text:"Standing Instruction Entry List", onClick:() => { setRecordPgmName("Standing Instruction Entry List") }, href:"#/StdMastList" }) }
                    { addMenuItem("M0042", { icon:imgAccount, text:"Standing Instruction Entry Audit Log", onClick:() => { setRecordPgmName("Instruction Entry Audit Log") }, href:"#/StdMastLog" }) }
                    { addMenuItem("M0043", { icon:imgAccount, text:"Confirmation of Renew Standing Instruction Report", onClick:() => { setRecordPgmName("Confirmation of Renew Std Inst Report") }, href:"#/ConfirmRenewStdInst" }) }
                </MenuItem> }

                <MenuItem icon={imgAccount} text="Other Code Setup">
                    { addMenuItem("M0035", { icon:imgAccount, text:"Account Status Code Setup", onClick:() => { setRecordPgmName("Account Status Code Setup") }, href:"#/AcStatus" }) }
                    { MULTI_CHNL && addMenuItem("M0036", { icon:imgAccount, text:"Channel Code Setup", onClick:() => { setRecordPgmName("Channel Code Setup") }, href:"#/Channel" }) }
                    { CL_CATEGY && addMenuItem("M0037", { icon:imgAccount, text:"Account Category Code Setup", onClick:() => { setRecordPgmName("Account Category Code Setup") }, href:"#/Category" }) }
                </MenuItem>
            </Menu>
        }>
            <Button minimal icon={imgMaster} text="Master" />
        </Popover>

        const menuHKIDR =
        <Popover minimal position={Position.BOTTOM_LEFT} content={
            <Menu>
                <MenuItem icon={imgAccount} text="HKIDR Master">
                    { CheckPgmAccess("H0001") && <MenuItem icon={imgAccount} text="Import Client from Client Master (New Client)" onClick={() => { setRecordPgmName("Import Client from Client Master (New Client)") }} href="#/HkidrImpAccount" /> }
                    { CheckPgmAccess("M0034") && ( IMP_CL_Mast1 ) && <MenuItem icon={imgImport} text="Import Client from Text File to HKIDR/Client" onClick={() => { setRecordPgmName("21I Import Client Master from Text File") }} href="#/ImportClMast1" />  }
                    { CheckPgmAccess("M0055") && ( IMP_HKIDR_Mast1 ) && <MenuItem icon={imgImport} text= "Import HKIDR TAB from Text File" onClick={() => { setRecordPgmName("Import HKIDR TAB from Text File") }} href="#/ImportClMast1" /> }
  
                    <MenuDivider />
                    { CheckPgmAccess("H0002") && <MenuItem icon={imgAccount} text="HKIDR Master" onClick={() => { setRecordPgmName("HKIDR Master") }} href="#/HkidrMast" /> }
                    { CheckPgmAccess("H0003") && <MenuItem icon={imgDocument} text="HKIDR Master List" onClick={() => { setRecordPgmName("HKIDR Master List") }} href="#/HkidrMastList" /> }
                    { CheckPgmAccess("H0004") && <MenuItem icon={imgDocument} text="HKIDR Master Audit Log" onClick={() => { setRecordPgmName("HKIDR Audit Log") }} href="#/HkidrLog" /> }
                    {/* CheckPgmAccess("H0005") && <MenuItem icon={imgDocument} text="GSB Client Name Change Log" onClick={() => { setRecordPgmName("GSB Client Name Change Log") }} href="#/GsbNameChangeLog" /> */}
                    <MenuDivider />
                    { CheckPgmAccess("H0006") && <MenuItem icon={imgAccount} text="Import HK Consent Status (CSV)" onClick={() => { setRecordPgmName("Import HK Consent Status") }} href="#/importHkconsentCSV" /> }

                    {/*<MenuDivider />*/}
                    {/* CheckPgmAccess("H0007") && <MenuItem icon={imgAccount} text="Generate CNBcan" onClick={() => { setRecordPgmName("Generate CNBcan") }} href="#/CNBcanGen" /> */}
                </MenuItem>
                <MenuItem icon={imgAccount} text="Print/Export Consent">
                    { CheckPgmAccess("H0008") && <MenuItem icon={imgDocument} text="Print HK Consent" onClick={() => { setRecordPgmName("Print HK RConsent") }} href="#/HkidrHkConsent" /> }
                    { CheckPgmAccess("H0009") && <MenuItem icon={imgAccount} text="Export HK Consent Status for Mail Merge (CSV)" onClick={() => { setRecordPgmName("Export HK Consent Status") }} href="#/ExportHkConsent" /> }
                </MenuItem>
                <MenuItem icon={imgAccount} text="BCAN-CID Mapping/Result File">
                    { CheckPgmAccess("H0010") && <MenuItem icon={imgAccount} text="HKBCAN-CID">
                        <MenuItem icon={imgDocument} text="Export HKBCAN-CID Mapping File" onClick={() => { setRecordPgmName("Export HKBCAN Mapping File") }} href="#/HkidrBcanMapping" />
                        <MenuDivider />
                        <MenuItem icon={imgDocument} text="Read HKBCAN-CID Response File" onClick={() => { setRecordPgmName("Import HKBCAN Response File") }} href="#/HkidrResponseFile" />
                        <MenuItem icon={imgDocument} text="Read HKBCAN-CID Process Result File" onClick={() => { setRecordPgmName("Import HKBCAN Result File") }} href="#/HkidrProcessResultFile" />
                        <MenuItem icon={imgDocument} text="Read HKBCAN-CID BCAN Full Image Reconcile File" onClick={() => { setRecordPgmName("Import HKBCAN Full Image File") }} href="#/HkidrFullImageFile" />
                    </MenuItem> }

                    { CNBCAN &&  <MenuItem icon={imgAccount} text="CNBCAN"> 
                        { CheckPgmAccess("H0022") &&  <MenuItem icon={imgDocument} text="Export CNBCAN-CID Mapping File" onClick={() => { setRecordPgmName("Export CNBCAN-CID Mapping File") }} href="#/CNBcanMapping" />}
                        {/* CheckPgmAccess("H0022") &&  <MenuItem icon={imgDocument} text="Export CNBCAN-CID Authorised TTEP Firm List" onClick={() => { setRecordPgmName("Export CNBCAN-CID Authorised TTEP Firm List") }} href="#/CNBcanAuFM" /> */}
                        <MenuDivider />
                        
                        { CheckPgmAccess("H0023") &&  <MenuItem icon={imgDocument} text="Read CNBCAN-CID Response File" onClick={() => { setRecordPgmName("Read CNBCAN-CID Response File") }} href="#/CNBcanResponseFile" />}
                        { CheckPgmAccess("H0023") && <MenuItem icon={imgDocument} text="Read CNBCAN-CID Authorised TTEP List Response File" onClick={() => { setRecordPgmName("Read CNBCAN-CID Result File") }} href="#/CNBcanAurpResponseFile" />}
                        { CheckPgmAccess("H0023") && <MenuItem icon={imgDocument} text="Read CNBCAN-CID validation result File" onClick={() => { setRecordPgmName("Read CNBCAN-CID Result File") }} href="#/CNBcanRsltResultFile" />}
                        { CheckPgmAccess("H0023") && <MenuItem icon={imgDocument} text="Read CNBCAN-CID BCAN Full Image Reconcile File" onClick={() => { setRecordPgmName("Read CNBCAN-CID Full Image File") }} href="#/CNBcanFimgFile" />}
                        </MenuItem>
                    }

                    { CheckPgmAccess("H0011") && <MenuItem icon={imgDocument} text="Export OTCR Report File (D/W)" onClick={() => { setRecordPgmName("Export OTCR Report File (D/W)") }} href="#/HkidrOtcr" /> }
                    { CheckPgmAccess("H0011") && <MenuItem icon={imgDocument} text="Export OTCR Report File (D/W) in History" onClick={() => { setRecordPgmName("Export OTCR Report File (D/W) in History") }} href="#/HkidrOtcr2" /> }
                    {/* CheckPgmAccess("I0003") && CM2K_USER && (GsbFlag.user_key != "WINGHANG") && <MenuItem icon={imgDocument} text="IPO Application Report" onClick={() => { setRecordPgmName("Export Application File for FINI") }} href="#/IPOApplicationRpt" />*/}
                    {CheckPgmAccess("I0005") && CM2K_USER && (GsbFlag.user_key != "WINGHANG") && <MenuItem icon={imgDocument} text="Export Application File for FINI" onClick={() => { setRecordPgmName("Export Application File for FINI") }} href="#/IPOExportFINI" />}
                    { CheckPgmAccess("I0006") && CM2K_USER && (GsbFlag.user_key != "WINGHANG") && <MenuItem icon={imgDocument} text="Export Application File for Bond" onClick={() => { setRecordPgmName("Export Application File for Bond") }} href="#/IPOExportIBOND" />}
                    { CheckPgmAccess("I0007") && CM2K_USER && (GsbFlag.user_key != "WINGHANG") && <MenuItem icon={imgDocument} text="Import FINI Authorised File" onClick={() => { setRecordPgmName("Import FINI Authorised File") }} href="#/IPOFINIAuthorisedFile" />}
                    {/* CheckPgmAccess("I0008") && CM2K_USER && (GsbFlag.user_key != "WINGHANG") && <MenuItem icon={imgDocument} text="IPO Application Pre-Payment" onClick={() => { setRecordPgmName("IPO Application Pre-Payment") }} href="#/IPOPrePayment" />*/}
                    {CheckPgmAccess("I0009") && CM2K_USER && (GsbFlag.user_key != "WINGHANG") && <MenuItem icon={imgDocument} text="Import FINI Allotment Result" onClick={() => { setRecordPgmName("Import FINI Allotment Result") }} href="#/IPOImportAllotment" />}
                    {/* CheckPgmAccess("I0012") && CM2K_USER && (GsbFlag.user_key != "WINGHANG") && <MenuItem icon={imgDocument} text="IPO Listing Report" onClick={() => { setRecordPgmName("IPO Listing Report") }} href="#/IPOListingRpt" />*/}
                    {/* CheckPgmAccess("I0013") && CM2K_USER && (GsbFlag.user_key != "WINGHANG") && <MenuItem icon={imgDocument} text="Generate Stock Transaction" onClick={() => { setRecordPgmName("Generate Stock Transactions") }} href="#/IPIPOStkTransactions" />*/}
                    {/* CheckPgmAccess("I0014") && CM2K_USER && (GsbFlag.user_key != "WINGHANG") && <MenuItem icon={imgDocument} text="IGenerate Cash & Chq Transcation" onClick={() => { setRecordPgmName("Generate Cash & Chq Transactions") }} href="#/IPOStkCashChq" />*/}


                    {/* CheckPgmAccess("H0033") && CM2K_USER && (GsbFlag.user_key != "WINGHANG") && <MenuItem icon={imgDocument} text="Import FINI Allotment Result" onClick={() => { setRecordPgmName("Import FINI Allotment Result") }} href="#/IPOImportAllotment" />*/}

                    {/* CheckPgmAccess("H0012") && CM2K_USER && (GsbFlag.user_key != "WINGHANG") && <MenuItem icon={imgDocument} text="Export Fini Reset" onClick={() => { setRecordPgmName("Export Fini Reset") }} href="#/ExportEIPOReset" />*/}
  
                </MenuItem>
                <MenuItem icon={imgAccount} text="Configuration">
                    { CheckPgmAccess("S0002") && 
                    
                        <MenuItem icon={imgDocument} text="BCAN Configuration" onClick={() => { setRecordPgmName("BcanConfig") }} href="#/BcanConfig" />
                    }
                </MenuItem>
            </Menu>
            }>
                <Button minimal icon={imgMaster} text="HKIDR" />
        </Popover>

        const menuHKCRS =
        <Popover minimal position={Position.BOTTOM_LEFT} content={
            <Menu>
                {CheckPgmAccess("H0013") && <MenuItem icon={imgAccount} text="CRS Import Client from GSB" onClick={() => { setRecordPgmName("CRS Import Client from GSB") }} href="#/HkCrsImpAccount" /> }
                {CheckPgmAccess("H0014") && <MenuItem icon={imgAccount} text="CRS Data Import Client from GSB" disabled={false} onClick={() => { setRecordPgmName("CRS Data Import Client from GSB") }} href="#/HkCrsDataImpAccount" />}
                {<MenuDivider />}
                { CheckPgmAccess("H0015") && <MenuItem icon={imgAccount} text="CRS Master" disabled={false} onClick={() => { setRecordPgmName("CRS Master") }} href="#/HkCrsMast" /> }
                {CheckPgmAccess("H0016") && <MenuItem icon={imgAccount} text="CRS Master List" disabled={false} onClick={() => { setRecordPgmName("CRS Master List") }} href="#/HkCrsMastList" /> }                
                {CheckPgmAccess("H0017") && <MenuItem icon={imgAccount} text="CRS Master Audit Log" disabled={false}  onClick={() => { setRecordPgmName("CRS Master Audit Log") }} href="#/HkCrsLog" /> }
                {<MenuItem icon={imgAccount} text="CRS Data Master" disabled={false} onClick={() => { setRecordPgmName("Crs Data Master") }} href="#/HkCrsDataMast" />}
                {CheckPgmAccess("H0019") && <MenuItem icon={imgAccount} text="CRS Data Master Audit Log" disabled={false} onClick={() => { setRecordPgmName("CRS Data Master Audit Log") }} href="#/HkCrsDLog" />}
                {CheckPgmAccess("H0020") &&<MenuItem icon={imgAccount} text="CRS Export"onClick={() => { setRecordPgmName("CrsExport") }} href="#/HkCrsExport" />}
                <MenuDivider />
                {CheckPgmAccess("H0020") &&<MenuItem icon={imgAccount} text="GSB Data For CRS enquiry"onClick={() => { setRecordPgmName("CrsExport") }} href="#/HkCrsEnquiry" />}
                <MenuDivider />
                { CheckPgmAccess("S0013") &&<MenuItem icon={imgAccount} text="CRS Configuration" onClick={() => { setRecordPgmName("CrsConfig") }} href="#/CrsConfig" />}
            </Menu>
            }>
                <Button minimal icon={imgMaster} text="CRS" />
        </Popover>
/*
 1. SYSTEM SETUP                                       
 2. MAINTAIN SPECIAL MAILING LIST                      
 3. CLIENT UPLOAD ENTRY                                
                                                       
 4. SETUP STOCK RECORD DATE                            
 5. GENERATE "CORP COMM RECIPIENT" BY RECORD DATE      
                                                       
 6. GENERATE "CORP COMM RECIPIENT" BY STOCK ON HAND    

*/
        const menuCCR =
        <Popover minimal position={Position.BOTTOM_LEFT} content={
            <Menu>
                {CheckPgmAccess("CCR001") && <MenuItem icon={imgAccount} text="CCR Configuration" onClick={() => { setRecordPgmName("CORP COMM RECIPIENT Setup GSB") }} href="#/CCRConfig" />}             
                {CheckPgmAccess("CCR002") && <MenuItem icon={imgAccount} text="Mailing List" onClick={() => { setRecordPgmName("Mailing List") }} href="#/CCRMailList" />}
                {CheckPgmAccess("CCR003") && <MenuItem icon={imgAccount} text="Client Upload Entry" onClick={() => { setRecordPgmName("Client Upload Entry") }} href="#/ClientUploadEntry" />}                
                {CheckPgmAccess("CCR004") && <MenuItem icon={imgAccount} text="Setup Stock Record Date" onClick={() => { setRecordPgmName("Setup Stock Record Date") }} href="#/StkRecordDate" />} 
                {CheckPgmAccess("CCR005") && <MenuItem icon={imgAccount} text="Generate CORP COMM Recipient By Record Date" onClick={() => { setRecordPgmName("Generate CORP CORP COMM Recipient") }} href="#/CCRGenRecDate" />}
                {CheckPgmAccess("CCR006") && <MenuItem icon={imgAccount} text="Generate CORP COMM Recipient By Stock On Hand " onClick={() => { setRecordPgmName("Generate CORP CORP COMM Recipient") }} href="#/CCRGenStkOnHand" />}
                {CheckPgmAccess("CCR007") && <MenuItem icon={imgDocument} text="CCR Audit Log" onClick={() => { setRecordPgmName("CCR Audit Log") }} href="#/CCRAuditLog" />}             
              

            </Menu>

            }>
            <Button minimal icon={imgDocument} text="CCR" />
        </Popover>


        const menuDividendProcess =
        <Popover minimal position={Position.BOTTOM_LEFT} content={
            <Menu>
                
                { showDividendProcess && 
                    addMenuItem("D0001", { icon:imgAccount, text:"91 Stock Announcement Entry", onClick:() => { setRecordPgmName("91 StockAnnouncementEntry") }, href:"#/StockAnnouncementEntry" }) 
                }
                { showDividendProcess && 
                    addMenuItem("D0002", { icon:imgDocument, text:"91L Stock Announcement Audit Log", onClick:() => { setRecordPgmName("91L StockAnnouncementLog") }, href:"#/StockAnnouncementLog" }) 
                }
                { showDividendProcess && 
                    addMenuItem("D0003", { icon:imgDocument, text:"96 Book Close Reminder Report", onClick:() => { setRecordPgmName("96 BookCloseReminder") }, href:"#/BookCloseReminder" }) 
                }
                { showDividendProcess && 
                    addMenuItem("D0004", { icon:imgAccount, text:"9M Foreign Market Dividend Charges Setup", onClick:() => { setRecordPgmName("9M MktDividendCharge") }, href:"#/MktDividendCharge" }) 
                }
                { showDividendProcess && 
                    addMenuItem("D0005", { icon:imgAccount, text:"Import CCNAN05 Corporate Announcement", onClick:() => { setRecordPgmName("Import CCNAN05 Announcement") }, href:"#/ImportAnnouncement" }) 
                }
                
                <MenuDivider />
                {showCBBCProcess  &&  <MenuItem icon={imgAccount} text="9C CBBC CALL MANAGEMENT">
                {showCBBCProcess &&
                    addMenuItem("D0006", { icon:imgAccount, text:"9C1 CBBC Process", onClick:() => { setRecordPgmName("91 CBBC Prcoess") }, href:"#/CBBCProcess" })
                }
                {showCBBCProcess &&
                            addMenuItem("D0007", { icon: imgDocument, text: "9C2 CBBC Report Print", onClick: () => { setRecordPgmName("9C2 CBBC Report Print") }, href:"#/CBBCCallMgnt" })
                }
                {showCBBCProcess &&
                        addMenuItem("D0008", { icon: imgAccount, text: "9C3 CBBC Stock Withdrawal", onClick: () => { setRecordPgmName("9C3 CBBC Stock Withdrawal") }, href:"#/CBBCStkWithDrawal" })
                }
                {showCBBCProcess &&
                        addMenuItem("D0009", { icon: imgAccount, text: "9C4 Deposit CBBC Residual value to Client", onClick: () => { setRecordPgmName("9C4 Deposit CBBC Residual value to Client") }, href:"#/CBBCDepositResidual" })
                }
                { showCBBCProcess &&
                        addMenuItem("D0010", { icon: imgAccount, text: "9C5 CLEAR Process CBBC History", onClick: () => { setRecordPgmName("9C5 CLEAR Process CBBC History") }, href:"#/CBBCClearHistory" })
                }
                {showCBBCProcess &&
                        addMenuItem("D0011", { icon: imgAccount, text: "9CS CBBC Configuration", onClick: () => { setRecordPgmName("9C5 CBBCConfig") }, href: "#/CBBCConfig" })
                }   
               </MenuItem>}
                <MenuDivider />
                    {CCOMM_UPL && <MenuItem icon={imgAccount} text="CCR">
                    {addMenuItem("CCR001", { icon: imgAccount, text: "9U1 CCR Configuration", onClick: () => { setRecordPgmName("9U1 CCR Configuration") }, href:"#/CCRConfig" }) }       
                    { addMenuItem("CCR002", { icon:imgAccount, text:"9U2 Mailing List", onClick:() => { setRecordPgmName("9U2 Mailing List") }, href:"#/CCRMailList" }) }
                    { addMenuItem("CCR003", { icon:imgAccount, text:"9U3 Client Upload Entry", onClick:() => { setRecordPgmName("9U3 Client Upload Entry") }, href:"#/ClientUploadEntry" }) }           
                    { addMenuItem("CCR004", { icon:imgAccount, text:"9U4 Setup Stock Record Date", onClick:() => { setRecordPgmName("9U4 Setup Stock Record Date") }, href:"#/StkRecordDate" }) }
                    { addMenuItem("CCR005", { icon:imgAccount, text:"9U5 Generate CORP COMM Recipient By Record Date", onClick:() => { setRecordPgmName("9U5 Generate CORP CORP COMM Recipient") }, href:"#/CCRGenRecDate" }) }
                    { addMenuItem("CCR006", { icon:imgAccount, text:"9U6 Generate CORP COMM Recipient By Stock On Hand ", onClick:() => { setRecordPgmName("9U6 Generate CORP CORP COMM Recipient") }, href:"#/CCRGenStkOnHand" }) }
                    { addMenuItem("CCR007", { icon:imgDocument, text:"CCR Audit Log ", onClick:() => { setRecordPgmName("CCR Audit Log") }, href:"#/CCRAuditLog" }) }
                
                
                </MenuItem>}
            </Menu>
            }>
                <Button minimal icon={imgMaster} text="Corporate Action" />
        </Popover>

        const menuTransaction =
        <Popover minimal position={Position.BOTTOM_LEFT} content={
            <Menu>
                { addMenuItem("T0018", { icon:imgDocument, text:"16 Day Start", onClick:() => { setRecordPgmName("16 Day Start") }, href:"#/DayStartProc" }) }
                
                { showImport && 
                    addMenuItem("T0015", { icon:imgImport, text:"Import File", onClick:() => { setRecordPgmName("Import file") }, href:"#/import" }) 
                }

                { showClientTranEntry &&
                    <MenuItem icon={imgAccount} text="Client Transaction">
                        { addMenuItem("T0001", { icon:imgAccount, text:"31 Client Transaction Entry", onClick:() => { setRecordPgmName("31 ClientTranEntry") }, href:"#/ClientTranEntry" }) }
                        { addMenuItem("T0002", { icon:imgDocument, text:"312 Client Transaction Check List", onClick:() => { setRecordPgmName("312 ClientTranCheckList") }, href:"#/ClientTranCheckList" }) }
                        { addMenuItem("T0002", { icon:imgDocument, text:"312 Client Transaction Check List - Summary", onClick:() => { setRecordPgmName("312 ClientTran Summary CheckList") }, href:"#/ClientTranCheckList2" }) }
                        { addMenuItem("T0003", { icon:imgDocument, text:"31L Client Transaction Audit Log", onClick:() => { setRecordPgmName("31L ClientTranLog") }, href:"#/ClientTranLog" }) }
                        { CheckPgmAccess2("T0001") && addMenuItem("T0001", { icon:imgAccount, text:"31C Clear Client Transaction", onClick:() => { setRecordPgmName("31C Clear ClientTran") }, href:"#/ClientTranClear" }) }
                        <MenuDivider />
                        {/* 20230823 */}
                        { CheckPgmAccess2("T0001") && addMenuItem("T0001", { icon:imgAccount, text:"31V1 Setup Interest Accrued For Client Trades", onClick:() => { setRecordPgmName("31V1 ClientInterestAccrued") }, href:"#/ClientInterestAccrued" }) }
                        { CheckPgmAccess2("T0001") && addMenuItem("T0001", { icon:imgDocument, text:"31V2 Interest Accrued Report For Client Trades", onClick:() => { setRecordPgmName("31V2 ClientInterestAccruedRport") }, href:"#/ClientInterestAccruedRpt" }) }
                        { CheckPgmAccess2("T0001") && addMenuItem("T0001", { icon: imgDocument, text: "Calculate Day Trade", onClick: () => { setRecordPgmName("Calculate Day Trade") }, href: "#/CalTrade" })}          

                    </MenuItem>
                }
                { showBrokerTranEntry &&
                    <MenuItem icon={imgAccount} text="Broker Transaction">
                        { addMenuItem("T0004", { icon:imgAccount, text:"32 Broker Transaction Entry", onClick:() => { setRecordPgmName("32 BrokerTranEntry") }, href:"#/BrokerTranEntry" }) }
                        { addMenuItem("T0005", { icon:imgDocument, text:"322 Broker Transaction Check List", onClick:() => { setRecordPgmName("322 BrokerTranCheckList") }, href:"#/BrokerTranCheckList" }) }
                        { addMenuItem("T0006", { icon:imgDocument, text:"32L Broker Transaction Audit Log", onClick:() => { setRecordPgmName("32L BrokerTranLog") }, href:"#/BrokerTranLog" }) }
                        { CheckPgmAccess2("T0004") && addMenuItem("T0004", { icon:imgAccount, text:"32C Clear Broker Transaction", onClick:() => { setRecordPgmName("32C Clear BrokerTran") }, href:"#/BrokerTranClear" }) }
                        <MenuDivider />
                        {/* 20230823 */}
                        { CheckPgmAccess2("T0004") && addMenuItem("T0004", { icon:imgAccount, text:"32V1 Setup Interest Accrued For Broker Trades", onClick:() => { setRecordPgmName("32V1 BrokerInterestAccrued") }, href:"#/BrokerInterestAccrued" }) }
                        { CheckPgmAccess2("T0004") && addMenuItem("T0004", { icon:imgDocument, text:"32V2 Interest Accrued Report For Broker Trades", onClick:() => { setRecordPgmName("32V2 BrokerInterestAccruedReport") }, href:"#/BrokerInterestAccruedRpt" }) }
                    </MenuItem>
                }
                { showPayRecTranEntry &&
                    <MenuItem icon={imgMoney} text="Payment / Receipt Transaction">
                        { addMenuItem("T0007", { icon:imgMoney, text:"33 Payment / Receipt Transaction Entry", onClick:() => { setRecordPgmName("33 PayRecTranEntry") }, href:"#/PayRecTranEntry" }) }
                        { addMenuItem("T0008", { icon:imgDocument, text:"332 Payment / Receipt Transaction Check List", onClick:() => { setRecordPgmName("332 PayRecTranCheckList") }, href:"#/PayRecTranCheckList" }) }
                        { addMenuItem("T0024", { icon:imgDocument, text:'335 Print Cheque / Autopay to Client', onClick:() => { setRecordPgmName("335 PayRec Print Cheque") }, href:"#/PayRecCheq" }) }
                        { addMenuItem("T0009", { icon:imgDocument, text:"33L Payment / Receipt Transaction Audit Log", onClick:() => { setRecordPgmName("33L PayRecTranLog") }, href:"#/PayRecTranLog" }) }
                        { addMenuItem("T0026", { icon:imgDocument, text:"Convert Interest to Balance", onClick:() => { setRecordPgmName("Convert Interest to Balance") }, href:"#/Conv_Int2Bal" }) }
                        { CheckPgmAccess2("T0007") && addMenuItem("T0007", { icon:imgMoney, text:"33C Clear Payment / Receipt Transaction", onClick:() => { setRecordPgmName("33C Clear PayRecTran") }, href:"#/PayRecTranClear" }) }
                        <MenuDivider />
                        { ChrgPortFee && addMenuItem("T0025", { icon:imgDocument, text:"Quarterly Custody Fee Report", onClick:() => { setRecordPgmName("Quarterly Custody Fee Report") }, href:"#/ChrgPortfolioFee" }) }
                        { addMenuItem("T0027", { icon:imgDocument, text:"Monthly CCASS Custody Fee Report", onClick:() => { setRecordPgmName("Monthly CCASS Custody Fee Report") }, href:"#/ChrgCCASSPortfolioFee" }) }
                        { addMenuItem("T0028", { icon:imgDocument, text:"CCASS Membership Fee Report", onClick:() => { setRecordPgmName("CCASS Membership Fee Report") }, href:"#/ChrgCCASSMembershipFee" }) }
                    </MenuItem>
                }
                { showStkDepWithTranEntry &&
                    <MenuItem icon={imgAccount} text="Stock Deposit/ Withdrawal Transaction">
                        { addMenuItem("T0010", { icon:imgAccount, text:"34 Stock Deposit / Withdrawal Transaction Entry", onClick:() => { setRecordPgmName("34 StkDepWithTranEntry") }, href:"#/StkDepWithTranEntry" }) }
                   
                        {/*showHKIDR1 && showHKIDR2 && CheckPgmAccess("T0023") && <MenuItem icon={imgDocument} text="Gen Er ref in share transfer" onClick={() => { setRecordPgmName("Gen Er ref in share transfer") }} href="#/ShareTransGenEr" /> */}
           
                        { addMenuItem("T0011", { icon:imgDocument, text:"342 Stock Deposit / Withdrawal Transaction Check List", onClick:() => { setRecordPgmName("342 StkDepWithTranCheckList") }, href:"#/StkDepWithTranCheckList" }) }
                        { addMenuItem("T0012", { icon:imgDocument, text:"34L Stock Deposit / Withdrawal Transaction Audit Log", onClick:() => { setRecordPgmName("34L StkDepWithTranLog") }, href:"#/StkDepWithTranLog" }) }
                        { CheckPgmAccess2("T0010") && addMenuItem("T0010", { icon:imgAccount, text:"34C Clear Stock Deposit / Withdrawal Transaction", onClick:() => { setRecordPgmName("34C Clear StkDepWithTran") }, href:"#/StkDepWithClear" }) }
                        <MenuDivider />
                        { addMenuItem("T0013", { icon:imgDocument, text:"344 Global Withdrawal / Transfer of a Stock", onClick:() => { setRecordPgmName("344 Stk Global Withdrawal") }, href:"#/StkGlobalWithdrawal" }) }
                    </MenuItem>
                }
                { showClientTranSettlementEntry &&
                    <MenuItem icon={imgAccount} text="Settlement Entry">
                        { addMenuItem("T0017", { icon:imgAccount, text:"351 Client Transaction Settlement Entry", onClick:() => { setRecordPgmName("351 Settlement Entry") }, href:"#/ClientTranSettlementEntry" }) }
                        { addMenuItem("T0020", { icon:imgDocument, text:"353 Client Transaction Settlement Check List", onClick:() => { setRecordPgmName("353 Settlement Check List") }, href:"#/ClientTranSettlementCheckList" }) }
                        { addMenuItem("T0021", { icon:imgDocument, text:"35L Client Transaction Settlement Audit Log", onClick:() => { setRecordPgmName("35L Settlement Check ListAudit Log") }, href:"#/ClientTranSettlementLog"  }) }
                    </MenuItem>
                }
                { ( CheckPgmAccess("T0014") || ShowDisableItem ) &&
                    <MenuItem icon={isMatch == 2 ? imgtick_circle : imgDocument} text="Trial Match & Report">
                        { addMenuItem("T0014", { icon:(isMatch == 2 ? imgtick_circle : imgDocument), text:"36 Start Matching", onClick:() => { setRecordPgmName("36 Start Matching") }, href:"#/Matching" }) }
                        { addMenuItem("T0014", { icon:imgDocument, text:"362 Matching Report", onClick:() => { setRecordPgmName("362 Matching Report") }, href:"#/MatchingReport" }) }
                    </MenuItem>
                }
                { ( CheckPgmAccess("T0022") || ShowDisableItem ) &&
                    <MenuItem icon={imgDocument} text="Trade Cancel & Correct">
                        { addMenuItem("T0022", { icon:imgDocument, text:"3F1 Cancel Previous Day Trade", onClick:() => { setRecordPgmName("3F1 Cancel Previous Day Trade") }, href:"#/CancelPrevTrade" }) }
                        { addMenuItem("T0022", { icon:imgDocument, text:"3F2 Input Previous Day Trade", onClick:() => { setRecordPgmName("3F2 Input Previous Day Trade") }, href:"#/CorrectTrade" }) }
                        { addMenuItem("T0022", { icon:imgDocument, text:"3F5 Cancel and Correct Trade Register", onClick:() => { setRecordPgmName("3F5 Cancel and Correct Trade Register") }, href:"#/CancelCorrectTradeRegister" }) }
                        { addMenuItem("T0022", { icon:imgDocument, text:"3FL Cancel and Correct Trade Audit Log", onClick:() => { setRecordPgmName("3FL Cancel and Correct Trade Audit Log") }, href:"#/CancelCorrectTradeLog" }) }
                    </MenuItem>
                }
                {/* 20230330 */}
                <MenuDivider />
                {  CheckPgmAccess("T0019") && showStockAllocationEntry &&
                    <MenuItem icon={imgAccount} text="Stock Allocation Entry">
                        { addMenuItem("T0019", { icon:imgAccount, text:"791 Stock Allocation Entry", onClick:() => { setRecordPgmName("791 Stock Allocation Entry") }, href:"#/StockAllocationEntry" }) }
                        { addMenuItem("T0019", { icon:imgDocument, text:"792 Stock Allocation Status Report", onClick:() => { setRecordPgmName("792 Stock Allocation Status Report") }, href:"#/StockAllocationStatusRpt" }) }
                    </MenuItem>
                }
                <MenuDivider />
                {showSASReport &&
                    <MenuItem icon={imgDocument} text="SAS/SZMK Market Report">
                        { addMenuItem("SA001", { icon:imgDocument, text:"3S1 SAS/SZMK Daily Transaction Resister", onClick:() => { setRecordPgmName("3S1 SAS/SZMK Daily Transaction Resister") }, href:"#/Sas_Rpt1" }) }
                        { addMenuItem("SA002", { icon:imgDocument, text:"3S2 Generate ATI File for SAS/SZMK", onClick:() => { setRecordPgmName("3S2 Generate ATI File for SAS/SZMK") }, href:"#/Sas_Rpt2" }) }
                        { addMenuItem("SA003", { icon:imgDocument, text:"3S3 Monthly Expense for SAS/SZMK", onClick:() => { setRecordPgmName("3S3 Monthly Expense for SAS/SZMK") }, href:"#/Sas_Rpt3" }) }
                        { addMenuItem("SA004", { icon:imgDocument, text:"3S4 Monthly Portfolio Fee for SAS/SZMK", onClick:() => { setRecordPgmName("3S4 Monthly Portfolio Fee for SAS/SZMK") }, href:"#/Sas_Rpt4" }) }
                        { addMenuItem("SA005", { icon:imgDocument, text:"3S5 Generate Monthly Portfolio Fee for SAS/SZMK", onClick:() => { setRecordPgmName("3S5 Generate Monthly Portfolio Fee for SAS/SZMK") }, href:"#/Sas_Rpt5" }) }
                    </MenuItem>
                }
                {showSASReport && <MenuDivider />}

                {ATI_USER &&
                    <MenuItem icon={imgDocument} text="ATI">
                        { addMenuItem("AT001", { icon:imgDocument, text:"ATI Setup", onClick:() => { setRecordPgmName("ATI Setup") }, href:"#/Ati_Rpt1" }) }
                        { addMenuItem("AT002", { icon:imgDocument, text:"Generate ATI Upload Text File, HK", onClick:() => { setRecordPgmName("Generate ATI Text File, HK") }, href:"#/Ati_Rpt2" }) }
                        { addMenuItem("AT003", { icon:imgDocument, text:"Segregated A/C Setup", onClick:() => { setRecordPgmName("Segregated A/C Setup") }, href:"#/Ati_Rpt3" }) }
                        { addMenuItem("AT004", { icon:imgDocument, text:"Segregated A/C List", onClick:() => { setRecordPgmName("Segregated A/C List") }, href:"#/Ati_Rpt4" }) }
                        { addMenuItem("AT005", { icon:imgDocument, text:"ATI Output File Adjustment", onClick:() => { setRecordPgmName("ATI File Adj") }, href:"#/Ati_Adj1" }) }
                    </MenuItem>
                }

                {EPS_USER &&
                    <MenuItem icon={imgDocument} text="EPS">
                        { addMenuItem("EP001", { icon:imgDocument, text:"EPS Setup", onClick:() => { setRecordPgmName("EPS Setup") }, href:"#/Eps_Rpt1" }) }
                        { addMenuItem("EP002", { icon:imgDocument, text:"EPS Start Checking", onClick:() => { setRecordPgmName("EPS Start Checking") }, href:"#/Eps_Rpt2" }) }
                    </MenuItem>
                }
                {(ATI_USER || EPS_USER) && <MenuDivider />}


                {SL_USER &&
                    <MenuItem icon={imgDocument} text="SL User">
                        { addMenuItem("SL001", { icon:imgDocument, text:"SL Setup", onClick:() => { setRecordPgmName("SL Setup") }, href:"#/SLSetup" }) }
                        { addMenuItem("M0007", { icon:imgAccount, text:"23 Stock Master", onClick:() => { setRecordPgmName("23 SmMast") }, href:"#/SmMast" }) }
                        { addMenuItem("SL002", { icon:imgDocument, text:"Stock Location Entry", onClick:() => { setRecordPgmName("Stock Location Entry") }, href:"#/SLMast" }) }
                        { addMenuItem("SL003", { icon:imgDocument, text:"Stock Location Audit Log", onClick:() => { setRecordPgmName("Stock Location Audit Log") }, href:"#/SLMastLog" }) }
                        { addMenuItem("SL004", { icon:imgDocument, text:"Stock Location Transaction Entry", onClick:() => { setRecordPgmName("Stock Location Transaction") }, href:"#/SLTran" }) }
                        { addMenuItem("SL005", { icon:imgDocument, text:"Stock Location Transaction Check List", onClick:() => { setRecordPgmName("Stock Location Transaction Check List") }, href:"#/SLTranList" }) }
                        { addMenuItem("SL006", { icon:imgDocument, text:"Stock Location Transaction Audit Log", onClick:() => { setRecordPgmName("Stock Location Transaction Audit Log") }, href:"#/SLTranLog" }) }
                    </MenuItem>
                }
                {(SL_USER) && <MenuDivider />}

                { CheckPgmAccess("T0016") && ( ! showDayEndOneProcess || userKey == "DEMO" ) &&
                    <MenuItem icon={imgDocument} text="Daily Processing with 43 Client Cheque">
                        { addMenuItem("T0016", { icon:(isPreDayEnd == 2 ? imgtick_circle : imgDocument), text:"Before Print Client Cheque Processing", onClick:() => { setRecordPgmName("Before Print Cheque Processing") }, href:"#/PreDayEndProc" }) }
                        {/* <MenuItem text="Reminder of Print Client Cheque at GSB 43" /> */}
                        { addMenuItem("T0016", { icon:(isPrn43Chq == 2 ? imgtick_circle : imgDocument), text:"43 Cheque To Client", onClick:() => { setRecordPgmName("43 Cheque To Client") }, href:"#/Cheque2Client" }) }
                        {/* <MenuItem text="Please run 7C1 Day End Processing (SBBatch.TXT)" /> */}
                        { addMenuItem("T0016", { icon:(isSysEnd == 2 ? imgtick_circle : imgDocument), text:"Day End Processing", onClick:() => { setRecordPgmName("Day End Processing 1") }, href:"#/DayEndProc" }) }
                    </MenuItem> 
                }
                { CheckPgmAccess("T0016") && showDayEndOneProcess &&
                    <MenuItem icon={imgDocument} text="Daily Processing without 43 Client Cheque">
                        { addMenuItem("T0016", { icon:(isSysEnd == 2 ? imgtick_circle : imgDocument), disabled:(GsbFlag.user_key == "WINGHANG"), text:"Day End Processing", onClick:() => { setRecordPgmName("Day End Processing 2") }, href:"#/DayEndProc2" }) }
                    </MenuItem> 
                }

            </Menu>
        }>
            <Button minimal icon={imgTransaction} text="Transaction" />
        </Popover>
         
        const menuIPO =
        <Popover minimal position={Position.BOTTOM_LEFT} content={
            <Menu>

                { addMenuItem("I0001", { icon:imgAccount, text:"IPO Master", onClick:() => { setRecordPgmName("IPO Master") }, href:"#/IPOMast" }) }
                <MenuDivider />
                { addMenuItem("I0002", { icon:imgAccount, text:"IPO Entry", onClick:() => { setRecordPgmName("IPO Entry") }, href:"#/IPOEntry" }) }
                { addMenuItem("I0003", { icon:imgDocument, text:"IPO Application Report", onClick:() => { setRecordPgmName("IPO Application Report") }, href:"#/IPOApplicationRpt" }) }               
                { addMenuItem("I0004", { icon:imgDocument, text:"IPO Entry Audit log", onClick:() => { setRecordPgmName("IPO log") }, href:"#/IPOLog" }) }
                { addMenuItem("I0005", { icon:imgDocument, text:"Export Application File for FINI", onClick:() => { setRecordPgmName("Export FINI report file for FINI") }, href:"#/IPOExportFINI" }) }
                { addMenuItem("I0006", { icon:imgDocument, text:"Export Application File for Bond", onClick:() => { setRecordPgmName("Export Bond report file for CCASS") }, href:"#/IPOExportIBOND" }) }
                { addMenuItem("I0007", { icon:imgDocument, text:"Import FINI Authorised File", onClick:() => { setRecordPgmName("Import FINI Authorised File") }, href:"#/IPOFINIAuthorisedFile" }) }          
                { addMenuItem("I0008", { icon:imgDocument, text:"Generate IPO Application Pre-Payment", onClick:() => { setRecordPgmName("Generate IPO Application Pre-Payment") }, href:"#/IPOPrePayment" }) }
                <MenuDivider />
                { addMenuItem("I0009", { icon:imgDocument, text:"Import FINI Allotment Result", onClick:() => { setRecordPgmName("Fini EIPO Allotment Csv Report File") }, href:"#/IPOImportAllotment" }) }
                { addMenuItem("I0011", { icon:imgDocument, text:"Print Refund Cheque", onClick:() => { setRecordPgmName("Print IPO Refund Cheque") }, href:"#/IPORefundChq" }) }
                { addMenuItem("I0012", { icon:imgDocument, text:"IPO Listing Report", onClick:() => { setRecordPgmName("IPO List Report") }, href:"#/IPOListingRpt" }) }
                { addMenuItem("I0013", { icon:imgDocument, text:"Generate Stock Transaction", onClick:() => { setRecordPgmName("Generate Stock Transactions") }, href:"#/IPIPOStkTransactions" }) }
                { addMenuItem("I0014", { icon:imgDocument, text:"Generate Cash & Chq Transcation", onClick:() => { setRecordPgmName("Generate Cash & Chq Transactions") }, href:"#/IPOStkCashChq" }) }
                {addMenuItem("I0015", { icon:imgAccount, text:"IPO Purge Out of Date IPO", onClick:() => { setRecordPgmName("IPO Purge Out of Date IPO") }, href:"#/IPOPurge" }) }

                {/* addMenuItem("I0015", { icon:imgAccount, text:"IPO Purge Out of Date IPO", onClick:() => { setRecordPgmName("IPO Purge Out of Date IPO") }, href:"#/IPOPurge" }) */}
                {/*CheckPgmAccess("H0012") &&<MenuItem icon={imgDocument} text="IPO Reset" onClick={() => { setRecordPgmName("IPO Reset") }} href="#/ExportEIPOReset" />*/}
            </Menu>
        }>
            {/* remark */}
            <Button minimal icon={imgDocument} text="IPO" />
        </Popover>
        const menuReport =
        <Popover minimal position={Position.BOTTOM_LEFT} content={
            <Menu>
                <MenuItem icon={imgDocument} text="Daily Report">
                    { addMenuItem("R0004", { icon:imgDocument, text:"25B Account Balance List", onClick:() => { setRecordPgmName("25B Ac Bal List") }, href:"#/AcBalList" }) }
                    { ( userKey == "CHEERFUL") && addMenuItem("R0034", { icon:imgDocument, text:"25X Output Client Balance to XLS", onClick:() => { setRecordPgmName("25X Output Client Balance to XLS") }, href:"#/ClACBalXls" }) }
                    { addMenuItem("R0001", {icon:imgDocument, text:"73 Stock Overdrawn Report", onClick:() => { setRecordPgmName("73 StkOverdrawnRpt") }, href:"#/StkOverdrawnRpt" }) }
                    {/* CheckPgmAccess("R0002") && <MenuItem icon={imgDocument} text="74 Stock Holder List" onClick={() => { setRecordPgmName("74 StkHoldList") }} href="#/StkHoldList" /> */}
                    { addMenuItem("R0002", { icon:imgDocument, text:"74 Stock Holder List", onClick:() => { setRecordPgmName("74 StkHoldList") }, href:"#/StkHoldList" }) }
                    { addMenuItem("R0003", { icon:imgDocument, text:"751 Portfolio Evaluation", onClick:() => { setRecordPgmName("751 Portfolio Evaluation") }, href:"#/PortfolioEvaluation" }) }
                    { addMenuItem("R0015", { icon:imgDocument, text:"752 Stock Asset Evaluation", onClick:() => { setRecordPgmName("752 Stock Asset Evaluation") },  href:"#/PortfolioEvaluation2" }) }
                    { addMenuItem("R0016", { icon:imgDocument, text:"754 Client Position Enquiry", onClick:() => { setRecordPgmName("754 Client Post Enquiry") }, href:"#/ClientPosEnquiry" }) }
                    { addMenuItem("R0005", { icon:imgDocument, text:"72 Margin Position Report", onClick:() => { setRecordPgmName("72 Mgn Position") }, href:"#/MgnPosition" }) }
                </MenuItem>

                <MenuItem icon={imgDocument} text="Monthly Report">
                    { addMenuItem("R0007", { icon:imgDocument, text:"84 Monthly Rebate Report", onClick:() => { setRecordPgmName("84 Monthly Rebate Report") }, href:"#/MthRebateRpt" }) }
                    { addMenuItem("R0011", { icon:imgDocument, text:"851 Contact Stamp", onClick:() => { setRecordPgmName("851 Contract Stamp") }, href:"#/MthContractStmpRpt" }) }
                    { addMenuItem("R0011", { icon:imgDocument, text:"852 Monthly Stamp Return", onClick:() => { setRecordPgmName("852 Monthly Stamp Return") }, href:"#/MthStmpReturnRpt" }) }
                    { addMenuItem("R0012", { icon:imgDocument, text:"86 Monthly Interest Report", onClick:() => { setRecordPgmName("86 Monthly Interest Report") }, href:"#/MthInterestRpt" }) }
                    { addMenuItem("R0013", { icon:imgDocument, text:"87 Monthly Levy and CCASS Fee Report", onClick:() => { setRecordPgmName("87 Monthly Levy and CCASS Fee Report") }, href:"#/MthLevyCCassFeeRpt" }) }
                    { addMenuItem("R0014", { icon:imgDocument, text:"88 Monthly Summary Report", onClick:() => { setRecordPgmName("88 Monthly Summary Report") }, href:"#/MthSummaryRpt" }) }
                    { addMenuItem("R0019", { icon:imgDocument, text:"89 Monthly CCASS Custody Fee Report", onClick:() => { setRecordPgmName("89 Monthly CCASS Custody Fee Report") }, href:"#/MthCCassCustodyFeeRpt" }) }
                    { addMenuItem("R0026", { icon:imgDocument, text:"8A Client Turnover Report", onClick:() => { setRecordPgmName("8A Client Turnover Report") }, href:"#/ClientTurnOverRpt" }) }
                </MenuItem>

                <MenuItem icon={imgDocument} text="Statement">
                    { showStatement && addMenuItem("R0009", { icon:imgFinancialreport, text:"542 Daily Statement", onClick:() => { setRecordPgmName("542 Daily Statement") }, href:"#/Dstatement" }) }
                    { showStatement && addMenuItem("R0009", { icon:imgFinancialreport, text:"542 Daily Statement Pre-Printed Form", onClick:() => { setRecordPgmName("542 Daily Statement Pre-Printed Form") }, href:"#/DstatementPrePrint" }) }
                    { showStatement && addMenuItem("R0010", { icon:imgFinancialreport, text:"831 Monthly Statement", onClick:() => { setRecordPgmName("831 Monthly Statement") }, href:"#/Mstatement" }) }
                    { showStatement && (stmtEncode === "Y") && addMenuItem("R0031", { icon:imgFinancialreport, text:"832 Monthly Statement (NO Address)", onClick:() => { setRecordPgmName("832 Monthly Statement (NO Address)") }, href:"#/Mstatement2" }) }
                    { addMenuItem("R0008", { icon:imgDocument, text:"Batch Processing 3 (Save Statement(s))", onClick:() => { setRecordPgmName("Batch 3 Processing") }, href:"#/SBBatch3" }) }
                    { showStatement && addMenuItem("R0009", { icon:imgFinancialreport, text:"Print Statement Group By Runner", onClick:() => { setRecordPgmName("Print Statement Group by Runner") }, href:"#/StatementAE" }) }
                    { showStatement && showSentEmailStatement && addMenuItem("R0017", { icon:imgFinancialreport, text:"Send Email Statement(s)", onClick:() => { setRecordPgmName("Send Email Statement(s)") }, href:"#/SentStatement" }) }
                    { showStatement && addMenuItem("R0025", { icon:imgFinancialreport, text:"Export Webstmt Statement", onClick:() => { setRecordPgmName("Export Webstmt Statement") }, href:"#/ExportWebStmt" }) }
                    { addMenuItem("R0050", {icon:imgFinancialreport, text:"Send Broadcast Document to Client via E-mail", onClick:() => { setRecordPgmName("Send Broadcast Document to Client via E-mail") }, href:"#/SendBroadcastEmail" }) }
                </MenuItem>

                <MenuItem icon={imgDocument} text="FRR">
                    { addMenuItem("R0033", { icon:imgDocument, text:"76 Approved Stock Assets Report", onClick:() => { setRecordPgmName("76 Approved Stock Assets Report") }, href:"#/ApprovedStockAssetsReport" }) }
                    { addMenuItem("R0045", { icon:imgDocument, text:"78 Trading Limit Report", onClick:() => { setRecordPgmName("78 Trading Limit Rpt") }, href:"#/TradingLimitRpt" }) }
                    { addMenuItem("R0032", { icon:imgDocument, text:"A1 Topmost Balance Client List", onClick:() => { setRecordPgmName("A1 Topmost Balance List") }, href:"#/TopmostBalanceList" }) }
                    { addMenuItem("R0038", { icon:imgDocument, text:"AA Cash Client Aging Analysis Report", onClick:() => { setRecordPgmName("AA Cash Client Aging Report") }, href:"#/CashAgingAnalysis" }) }
                    { addMenuItem("R0039", { icon:imgDocument, text:"AB Unsettled Tran Accepted Value Report",  onClick:() => { setRecordPgmName("AB Unsettled Transaction Accepted Value Report") }, href:"#/UnsettleTranAcceptValue" }) }
                    { addMenuItem("R0047", { icon:imgDocument, text:"AC Cash Client Contra Figure Summary Report", onClick:() => { setRecordPgmName("AC Cash Client Contra Figure Summary Report") }, href:"#/CashContraSummary" }) }
                    { addMenuItem("R0035", { icon:imgDocument, text:"AL Rolling Balance Client Analysis Report", onClick:() => { setRecordPgmName("AL Rolling Balance Client Analysis Report") }, href:"#/RollingBalanceReport" }) }       
                    { addMenuItem("R0051", { icon:imgDocument, text:"AR Related Client Bank Guarantee Report", onClick:() => { setRecordPgmName("AR Related Client Bank Guarantee Report") }, href:"#/RelatedClBankGuarRpt" }) }     
                    { addMenuItem("M0038", { icon:imgAccount, text:"71I Import HKEX Month-End Closing Statistics (for FRR)", onClick:() => { setRecordPgmName("71I Import HKEX Month-End Closing Statistics (for FRR)") }, href:"#/ImportStkMcd_mb" }) }
                </MenuItem>

                <MenuItem icon={imgDocument} text="SFC">
                    { addMenuItem("M0003", { icon:imgDocument, text:"Client List for SFC", onClick:() => { setRecordPgmName("ClACListSfc") }, href:"#/ClACListSfc" }) }                      
                    { addMenuItem("R0020", { icon:imgDocument, text:"744 Stock Holder for SFC", onClick:() => { setRecordPgmName("744 StkHoldListSfc") }, href:"#/StkHoldListSfc" }) }
                    { addMenuItem("R0020", { icon:imgDocument, text:"744 Stock Holder for SFC from folder GsbxRpt", onClick:() => { setRecordPgmName("744 StkHoldListSfc2") }, href:"#/StkHoldListSfc2" }) }
                    { addMenuItem("R0006", { icon:imgDocument, text:"294 Client Trading History XLS for SFC", onClick:() => { setRecordPgmName("294 Client Trading History XLS for SFC") }, href:"#/ClHistorySfc" }) }
                </MenuItem>

                { ( CheckPgmAccess("R0006") ) && <MenuItem icon={imgDocument} text="29 Client Trading History">
                    { addMenuItem("R0006", { icon:imgDocument, text:"29 Client History Report", onClick:() => { setRecordPgmName("29 Client History") }, href:"#/ClHistory" }) }
                    { (GsbFlag.user_key != "CHEERFUL") && addMenuItem("R0006", { icon:imgDocument, text:"29 Client History Report from Folder History", onClick:() => { setRecordPgmName("29 Client History from Folder history") }, href:"#/ClHistory2" }) }
                </MenuItem> }
                <MenuDivider />
                
                { SFC_EXCEL && <MenuItem icon={imgDocument} text="Securities Margin Financing Activities Report">
                    { addMenuItem("R0046", { icon:imgDocument, text:"2332 Stock Market Value Stress Test", onClick:() => { setRecordPgmName("Stock Market Value Stress Test") }, href:"#/MktValueStressTest" }) }
                    {/* // 20231124 74X Stock Holder to XLS, StkHoldList.PRG */}
                    { (userKey == "CHEERFUL") && addMenuItem("R0036", { icon:imgDocument, text:"74X Export Stock Holder to XLS", onClick:() => { setRecordPgmName("74X Export Stock Holder to XLS") }, href:"#/StkHoldXls" }) }
                    {/* // 20231128 74Y Export Stock Haircuts for Re-pledges Margin Client, StkHoldList.PRG */}
                    { (userKey == "CHEERFUL") && addMenuItem("R0037", {icon:imgDocument, text:"74Y Export Stock Haircuts for Re-pledges Margin Client", onClick:() => { setRecordPgmName("74Y Export Stock Haircuts for Re-pledges Margin Client")}, href:"#/StkHaircutXls" }) }
                    { addMenuItem("R0032", { icon:imgDocument, text:"A1 Topmost Balance Client List (StressTest)", onClick:() => { setRecordPgmName("A1 Topmost Balance List Stress Test") }, href:"#/TopmostBalanceList_StressTest" }) }
                    { addMenuItem("R0040", { icon:imgDocument, text:"A14 Export Topmost Balance Client List to XLS", onClick:() => { setRecordPgmName("A14 Topmost Balance List to XLS") }, href:"#/TopmostBalanceList2" }) }
                    { addMenuItem("R0005", { icon:imgDocument, text:"72 Margin Position Report (StressTest)", onClick:() => { setRecordPgmName("72 Mgn Position Stress Test") }, href:"#/MgnPosition_StressTest" }) }
                    { addMenuItem("R0033", { icon:imgDocument, text:"76 Approved Stock Assets Report (StressTest)", onClick:() => { setRecordPgmName("76 Approved Stock Assets Report") }, href:"#/ApprovedStockAssetsReport_StressTest" }) }
                    { addMenuItem("R0041", { icon:imgDocument, text:"72L Long-Outstanding Margin Call Report", onClick:() => { setRecordPgmName("72L LongOutstand Margin Call Rpt") }, href:"#/MarginCallRpt1" }) }
                    { addMenuItem("R0042", { icon:imgDocument, text:"72M Record Settle Margin Call Entry", onClick:() => { setRecordPgmName("72M Record Settle Margin Call Entry") }, href:"#/MarginCallRpt2" }) }
                    { addMenuItem("R0042", { icon:imgDocument, text:"72ML Record Settle Margin Call Audit Log", onClick:() => { setRecordPgmName("72ML Record Settle Margin Call Audit Log") }, href:"#/MarginCallRpt2Log"  }) }
                    { addMenuItem("R0043", { icon:imgDocument, text:"72N Poor History of Settling Margin Call Report", onClick:() => { setRecordPgmName("72N Poor History of Settling Margin Call Report") }, href:"#/MarginCallRpt3" }) }
                    { addMenuItem("R0044", { icon:imgDocument, text:"72R Age of Margin Call Report For FRR", onClick:() => { setRecordPgmName("72R Age of Margin Call Report For FRR") }, href:"#/MarginCallRpt4" }) }
                    { addMenuItem("R0002", { icon:imgDocument, text:"74 Stock Holder List (StressTest)", onClick:() => { setRecordPgmName("74 StkHoldList Stress Test") }, href:"#/StkHoldList_StressTest" }) }
                </MenuItem> }


                {CheckPgmAccess("R0018") && <MenuItem icon={imgDocument} text="AD DVIEW">   
      
                { (stmtEncode === "Y") && addMenuItem("R0021", { icon:imgFinancialreport, text:"AD1 DVIEW Statement", onClick:() => { setRecordPgmName("AD1 DVIEW Statement")}, href:"#/Dv1Stmt" }) }
                { (stmtEncode === "Y") && addMenuItem("R0022", { icon:imgFinancialreport, text:"AD2 DVIEW Statement (NO Address)", onClick:() => { setRecordPgmName("AD2 DVIEW Statement (NO Address") }, href:"#/Dv2Stmt" }) }
                { (stmtEncode === "Y") && addMenuItem("R0023", { icon:imgFinancialreport, text:"AD3 DVIEW Statement (Today)", onClick:() => { setRecordPgmName("AD3 DVIEW Statement (Today)") }, href:"#/DvTransDate" }) }
                
                { (stmtEncode === "N") && addMenuItem("R0021", { icon:imgFinancialreport, text:"AD1 DVIEW Statement", onClick:() => { setRecordPgmName("AD1 DVIEW Statement")}, href:"#/Dv1Stmt" }) }
                { (stmtEncode === "N") && addMenuItem("R0023", { icon:imgFinancialreport, text:"AD3 DVIEW Statement (Today)", onClick:() => { setRecordPgmName("AD3 DVIEW Statement (Today)") }, href:"#/DvTransDate" }) }
                
                { (userKey == "CHEERFUL") && addMenuItem("R0024", { icon:imgFinancialreport, text:"AD4 Import CSV DVIEW Report to search files", onClick:() => { setRecordPgmName("AD4 Import CSV DVIEW Report to search files") }, href:"#/DvsDowntatement" }) }
                <MenuDivider />
                { addMenuItem("R0027", { icon:imgDocument, text:"AD5 DVIEW Stock Holder Report (pdf) from GsbxRpt", onClick:() => { setRecordPgmName("AD5 DVIEW Stock Holder Report (pdf) from GsbxRpt") }, href:"#/DvStkHolderList" }) }
                { addMenuItem("R0028", { icon:imgDocument, text:"AD6 DVIEW Stock Holder Report (pop) from GsbxRpt", onClick:() => { setRecordPgmName("AD6 DVIEW Stock Holder Report (pop) from GsbxRpt") }, href:"#/DvStkHolderList2"  }) }
                { addMenuItem("R0029", { icon:imgDocument, text:"AD7 DVIEW Dividend Report from GsbxDivRpt", onClick:() => { setRecordPgmName("AD7 DVIEW Dividend Report from GsbxDivRpt") }, href:"#/DvDividend" }) }
                { addMenuItem("R0030", { icon:imgDocument, text:"AD8 DVIEW Allocation Status Report from GsbxRpt", onClick:() => { setRecordPgmName("AD8 DVIEW Allocation Status Report from GsbxRpt") }, href:"#/DvStkAllocStatus"  }) }

                </MenuItem> }                
             
                {( CheckPgmAccess("R0048") || CheckPgmAccess("R0049") ) && <MenuDivider/> }
                {( CheckPgmAccess("R0048") || CheckPgmAccess("R0049") ) && <MenuItem icon={imgDocument} text="Rap Viewer">     
                    { addMenuItem("R0048", { icon:imgImport, text:" CCASS Import", onClick:() => { setRecordPgmName("CCASS Import")}, href:"#/ImportCCASSxRpt" }) }
                    { addMenuItem("R0049", { icon:imgDocument, text:" CCASS Report", onClick:() => { setRecordPgmName("CCASS Report")}, href:"#/CCASSRpt" }) }
                </MenuItem>}
            

                {/* for FBSx user */}
                {/* FBSx_USER && <MenuItem icon={imgDocument} text="FBS Menu (Testing)">   
                    { CheckPgmAccess("FM0010") && <MenuItem icon={imgAccount} text="Account Information" onClick={() => { setRecordPgmName("Account Information") }} href="#/fbs/ClMast" /> }
                    { CheckPgmAccess("FR0003") && <MenuItem icon={imgDocument} text="Daily Trading Report" onClick={() => { setRecordPgmName("FBSx Daily Trading Report") }} href="#/fbs/DailyTradingRpt" /> }
                    { CheckPgmAccess("FR0011") && <MenuItem icon={imgDocument} text="Account Summary Report" onClick={() => { setRecordPgmName("Account Summary Report") }} href="#/fbs/AcctSumRpt" /> }
                    <MenuDivider />
                    { CheckPgmAccess("FR0001") && <MenuItem icon={imgFinancialreport} text="Daily Statement" onClick={() => { setRecordPgmName("FBSx Daily Statement") }} href="#/fbs/Dstatement" /> }
                    { CheckPgmAccess("FR0002") && <MenuItem icon={imgFinancialreport} text="Monthly Statement" onClick={() => { setRecordPgmName("FBSx Monthly Statement") }} href="#/fbs/Mstatement" /> }
                    <MenuDivider />
                    { CheckPgmAccess("FM0039") && <MenuItem icon={imgAccount} text="Standing Instruction Code Setup" onClick={() => { setRecordPgmName("FBSx Standing Instruction Code Setup") }} href="#/StdInstSetup?syscode=Fbsx" /> }
                    { CheckPgmAccess("FM0040") && <MenuItem icon={imgAccount} text="Standing Instruction Entry" onClick={() => { setRecordPgmName("FBSx Standing Instruction Entry") }} href="#/StdMast?syscode=Fbsx" /> }
                </MenuItem> */}

                {/* for SL user */}
                { SL_USER && <MenuItem icon={imgDocument} text="SL Menu (Testing)">   
                    { CheckPgmAccess("SL010") && <MenuItem icon={imgDocument} text="Stock Status Report" onClick={() => { setRecordPgmName("SL Stock Status Report") }} href="#/SLStkStatusReport" /> }
                </MenuItem> }

            </Menu>
        }>
            {/* remark */}
            <Button minimal icon={imgDocument} text="Report" />
        </Popover>

        const menuSysMain =
        <Popover minimal position={Position.BOTTOM_LEFT} content={
            <Menu>
                { addMenuItem("S0001", { icon:imgDocument, text:"GSBx Configuration", onClick:() => { setRecordPgmName("Gsbx Config") }, href:"#/GsbxConfig" }) }
                { addMenuItem("S0015", { icon:imgDocument, text:"GL Configuration", onClick:() => { setRecordPgmName("GL Config") }, href:"#/GLConfig" }) }
                { SI_USER && addMenuItem("S0017", { icon:imgDocument, text:"SI Configuration", onClick:() => { setRecordPgmName("SI Config") }, href:"#/SiConfig" }) }
                { addMenuItem("S0003", { icon:imgsort_asc, text:"Data Upgrade, Reindex", onClick:() => { setRecordPgmName("System Upgrade, Reindex") }, href:"#/SBReindex" }) }
                { addMenuItem("S0012", { icon:imgsort_asc, text:"7R Re-update Current Day Transactions", onClick:() => { setRecordPgmName("Re-update Transactions") }, href:"#/ReUpdateTrn" }) }
                { addMenuItem("S0014", { icon:imgsort_asc, text:"1A Data Integrity Check", onClick:() => { setRecordPgmName("Data Integrity Check") }, href:"#/DataIntegrityCheck" }) }
                <MenuDivider />
                { addMenuItem("S0004", { icon:imgDocument, text:"Backup 3B1/3B2, Restore Processing", onClick:() => { setRecordPgmName("Backup/Restore Processing") }, href:"#/SBBackup" }) }
                { CheckPgmAccess("R0008") && <MenuItem icon={imgDocument} text="Batch Processing" >
                    { addMenuItem("R0008", { icon:imgDocument, text:"Batch Processing 1 (Save Daily Report(s))", onClick:() => { setRecordPgmName("Batch 1 Processing") }, href:"#/SBBatch" }) }
                    { addMenuItem("R0008", { icon:imgDocument, text:"Batch Processing 2 (Save Monthly Report(s))", onClick:() => { setRecordPgmName("Batch 2 Processing") }, href:"#/SBBatch2" }) }
                    { addMenuItem("R0008", { icon:imgDocument, text:"Batch Processing 3 (Save Statement(s))", onClick:() => { setRecordPgmName("Batch 3 Processing") }, href:"#/SBBatch3" }) }
                    { addMenuItem("R0008", { icon:imgDocument, text:"Batch Processing 4 (AD3 DVIEW Statement, Today)", onClick:() => { setRecordPgmName("Batch 4 Processing") }, href:"#/SBBatch4" }) }
                    { addMenuItem("R0008", { icon:imgDocument, text:"All Batch Processing", onClick:() => { setRecordPgmName("All Batch Processing") }, href:"#/SBBatch10" }) }
                    { addMenuItem("R0008", { icon:imgDocument, text:"Batch Processing 5 (Save Special Report(s))", onClick:() => { setRecordPgmName("Batch 5 Processing") }, href:"#/SBBatch5" }) }
                    { FRR_TO_XLS && addMenuItem("R0008", { icon:imgDocument, text:"FRR Processing", onClick:() => { setRecordPgmName("FRR Processing") }, href:"#/SBBatch11" }) }
                    { SFC_EXCEL && addMenuItem("R0008", { icon:imgDocument, text:"SMF Processing", onClick:() => { setRecordPgmName("SMF Processing") }, href:"#/SBBatch12" }) }
                </MenuItem> }
                { addMenuItem("S0005", { icon:imgDocument, text:"Login Log", onClick:() => { setRecordPgmName("LoginLog") }, href:"#/LoginLog" }) }
                { addMenuItem("S0010", { icon:imgDocument, text:"Reset Process", onClick:() => { setRecordPgmName("Resetprocess") }, href:"#/Resetprocess" }) }
                {/* addMenuItem("S0006", { icon:imgDocument, text:"GSB Status", onClick:() => { setRecordPgmName("SB Status") }, href:"#/SBstatus" }) */}
                <MenuItem icon={imgDocument} text="GSB System Module" onClick={() => { setRecordPgmName("GSB System Module") }} href="#/SBModule"/>
                { (CheckPgmAccess("S0007") || CheckPgmAccess("S0008") ) &&
                    <MenuItem icon={imgAccount} text="User Master / Access">
                        { addMenuItem("S0007", { icon:imgDocument, text:"User Master", onClick:() => { setRecordPgmName("User Master Setup") }, href:"#/UserMast" }) }
                        { addMenuItem("S0007", { icon:imgDocument, text:"User List", onClick:() => { setRecordPgmName("User List") }, href:"#/UserMastList" }) }
                        { addMenuItem("S0007", { icon:imgDocument, text:"User Audit Log", onClick:() => { setRecordPgmName("User Audit Log") }, href:"#/UserMastLog" }) }
                        { addMenuItem("S0007", { icon:imgDocument, text:"Reset User Password", onClick:() => { setRecordPgmName("Reset User Password") }, href:"#/UserchgPasswd2" }) }
                        { CheckPgmAccess("S0007") && <MenuDivider /> }

                        { addMenuItem("S0008", { icon:imgDocument, text:"Group Access", onClick:() => { setRecordPgmName("Group Access") }, href:"#/GroupAccess" }) }
                        { addMenuItem("S0008", { icon:imgDocument, text:"Group Access List", onClick:() => { setRecordPgmName("Group Access List") }, href:"#/GroupAccessList" }) }
                        { addMenuItem("S0008", { icon:imgDocument, text:"Group Access Audit Log", onClick:() => { setRecordPgmName("Group Access Audit Log") }, href:"#/GroupAccessLog" }) }
                        
                        <MenuDivider />
                        { addMenuItem("S0008", { icon:imgDocument, text:"User Pgm Access", onClick:() => { setRecordPgmName("User Pgm Access") }, href:"#/UserPgmAccess" }) }
                        { addMenuItem("S0008", { icon:imgDocument, text:"User Pgm Access List", onClick:() => { setRecordPgmName("User Pgm Access List") }, href:"#/UserPgmAccessList" }) }
                        { addMenuItem("S0008", { icon:imgDocument, text:"User Pgm Access Audit Log", onClick:() => { setRecordPgmName("User Pgm Access Audit Log") }, href:"#/UserPgmAccessLog" }) }
                    </MenuItem> 
                }
                { <MenuItem icon={imgDocument} text="Change User Password" onClick={() => { setRecordPgmName("Change User Password") ; history.push("/UserchgPasswd") }} /> }
                { addMenuItem("M0017", { icon:imgDocument, text:"Authorizations", onClick:() => { setRecordPgmName("Authorizations") }, href:"#/ReqAuthList" }) }
                { addMenuItem("S0009", { icon:imgDocument, intent:(warnAbout ? Intent.WARNING : "none"), text:"About", onClick:() => { setRecordPgmName("About") }, href:"#/About" }) }
                { (GsbFlag.user_key != "CHEERFUL") && addMenuItem("S0011", { icon:imgDocument, text:"Temp Change Field Length", onClick:() => { setRecordPgmName("Temp Change Field Length") }, href:"#/TempChgField" }) }
                { addMenuItem("S0016", { icon:imgbuild, text:"Purge Out-Dated Data", onClick:() => { setRecordPgmName("Purge Out-Dated Data") }, href:"#/PurgeOutDatedData" }) }
                <MenuItem icon={imgDocument} text="Log Out" onClick={() => { setRecordPgmName("Log Out") }} href="#/login" />
            </Menu>

        }>
            <Button minimal icon={imgbuild } intent={warnSysMain ? Intent.WARNING : "none"} text="System Maintenance" />
        </Popover>

    let showuserId = <>
        User ID: { userId }
    </>

    const changeUserLanguage = (lng: string) => {
        (async () => {
            try {
                if (isLoggedIn) {
                    //await svc.post('/userupdatecurrent', {currentLang: lng});
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }

    let lngList = [
        {lngName: "English", lng: "en"},
        {lngName: "繁體中文", lng: "zh-HK"},
        {lngName: "简体中文", lng: "zh-CN"},
    ]


    return (
        <>
            <Navbar className="No-Print" fixedToTop>
                <Navbar.Group align={Alignment.LEFT}>
                    <Navbar.Heading><AnchorButton minimal icon={imgLogo} text="GSBx" href="#/"/></Navbar.Heading>
                    <Navbar.Divider />
                    {isLoggedIn ? menuMaster : null}
                    {/* {isLoggedIn && showHKIDR1 && showHKIDR2 ? menuHKIDR : null} */}
                    {/* {isLoggedIn && GSBXHKCRS ? menuHKCRS : null } */}
                    {isLoggedIn ? menuTransaction : null}
                    {isLoggedIn && showDividendProcess ? menuDividendProcess : null}
                    {/*{isLoggedIn && CCOMM_UPL ? menuCCR : null } */}
                    {isLoggedIn && CM2K_USER ? menuIPO : null } 
                    {isLoggedIn ? menuReport : null}
                    {isLoggedIn ? menuSysMain : null}
                    {isLoggedIn && <>
                    <Navbar.Divider />
                    <MenuSuggest
                        selectedItem={selectedItem}
                        items={items}
                        onItemSelect={(item) => { window.location.assign(item.href || "") }}
                    />
                    </>}
                </Navbar.Group>
                <Navbar.Group align={Alignment.RIGHT}>
                    {/*
                    <BPSwitch style={{marginTop: '8px'}} checked={isDark} label="Dark mode" onChange={() => {
                        let newMode = !isDark
                        let body = document.getElementById("body")
                        if (newMode) {
                            body?.classList.add("bp4-dark")
                        } else {
                            body?.classList.remove("bp4-dark")
                        }
                        setIsDark(newMode)
                    }} />
                    <Navbar.Divider />
                    */}
                    
                    <div><b>GSBx</b> {Sys_VerNo}</div>
                    <Navbar.Divider />
                    {isLoggedIn && <div > {showuserId} </div>} 
                    <MenuDivider />
                    {/*
                    <Popover minimal position={Position.BOTTOM_LEFT} content={
                        <Menu>
                            {lngList.map((lng) => <MenuItem key={lng.lng} icon="translate" text={lng.lngName} onClick={() => {i18n.changeLanguage(lng.lng); changeUserLanguage(lng.lng)}} />)}
                        </Menu>
                    }>
                        <Button className="MenuEnv" minimal icon="translate" text="Language/語言" />
                    </Popover>
                    */}
                    {isLoggedIn && <Tooltip content="Toggle system status window"><Button minimal icon={imgChecklist} onClick={onSystemStatusClick} /></Tooltip>}
                    {isLoggedIn && <Link target="_blank" to="/tasks"><Tooltip content="Tasks"><Button minimal icon={imgTask} /></Tooltip></Link>}
                    {isLoggedIn && <Link to="/login"><Tooltip content="Logout"><Button minimal icon={imgUser} /></Tooltip></Link>}
                </Navbar.Group>
            </Navbar>
        </>
    )
}

interface MenuBarProps {
    isLoggedIn?: boolean
    onSystemStatusClick?: () => void
}


function MenuBar_ce({ isLoggedIn = false } : MenuBar_ceProps) {
    const [showClMast, setshowClMast] = useState(true)
    const [showClHistory, setshowClHistory] = useState(true)

    const [warnSysMain, setwarnSysMain] = useState(false)
    const [warnAbout, setwarnAbout] = useState(false)

    const [Sys_VerNo, setSys_VerNo] = useState("")
    const [userKey, setuserKey] = useState("DEMO")
    const [userId, setuserId] = useState("")
    const [RecordPgmName, setRecordPgmName] = useState("")
    const [IPAddr, setIPAddr] = useState("")

    const [isDark, setIsDark] = useState(document.getElementById("body")?.classList.contains("bp4-dark"))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    const [MULTI_MKT, setMULTI_MKT] = useState(false)
    const [SING_CURR, setSING_CURR] = useState(false)

    document.title = 'POP-GSBce'

    useEffect(() => {
        if ( isLoggedIn ) {
            (async () => {
                try {
                    // get GsbFlag from SB.XBS
                    const res = await gsb.post('/GsbFlag');
                    //console.log("MenuBar_ce disp user_key: ", res.data.Flag.user_key)
                    GsbFlag = res.data.Flag;
                    //console.log("MenuBar_ce disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                    setSys_VerNo("v"+GsbFlag.Sys_VerNo) 
                    setuserKey(GsbFlag.user_key)
                    setuserId( GsbFlag.UserID)
                    if ( GsbFlag.isProduction == "Y" ) {
                        setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                    } else {
                        setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                    }

                    setMULTI_MKT(GsbFlag.MULTI_MKT)
                    setSING_CURR(GsbFlag.SING_CURR)

                } catch (error) {
                    utils.showError(error)
                }
            })()
        } else {
            (async () => {
                try {
                    const res = await gsb.post('/GsbFlag0');
                    setSys_VerNo("v"+res.data.Flag.Sys_VerNo)
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, isLoggedIn])


    useEffect(() => {
        setwarnSysMain(false)
        setwarnAbout(false)

        ;
        if ( isLoggedIn ) {
            (async () => {
            try {
                const res = await gsb.post('/SysMaint',
                    {   sb_data: {
                        //
                    },
                    cPgmId: "GetIconWarnInfo",
                });
                if ( res.data.ok ) {
                    //console.log("GetIconWarnInfo res.data.data", res.data.data)
                    setwarnSysMain(res.data.data[0].warnAbout) 
                    setwarnAbout(res.data.data[0].warnAbout) 
          

                }
            } catch (error) {
                utils.showError(error)
            }
        })()


        }
    }, [gsb, isLoggedIn, userId, GsbFlag, Sys_VerNo])
    

    useEffect(() => {
        //console.log("MenuBar cardOpen01", cardOpen01)        
        if ( cardOpen01.substr(0,17) === "cardOpen01-Theme8" ) {
            document.getElementById("body")?.classList.add("bp4-dark")
            setIsDark(true)
        } else {
            document.getElementById("body")?.classList.remove("bp4-dark")
            setIsDark(false)
        }
    
    
    }, [gsb, isLoggedIn, userId, GsbFlag, cardOpen01])
    

    useEffect(() => {
        if ( isLoggedIn && RecordPgmName.length > 0 ) {
            (async () => {
                try {
                    // get GsbFlag from SB.XBS
                    const res = await gsb.post('/PgmEntry', {
                        cPgmName: RecordPgmName,
                        cIPAddr: IPAddr,
                    });
                    setRecordPgmName("")
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, RecordPgmName, isLoggedIn])
    

    const imgLogo = <img className="AppLogo" src={svgLogo} alt="Logo" />
    const imgAccount = <img className="MenuIcon" src={svgAccount} alt="Account" />
    const imgMaster = <img className="MenuIcon" src={svgMaster} alt="Master" />
    const imgDocument = <img className="MenuIcon" src={svgDocument} alt="Document" />
    const imgzipDocument = <img className="MenuIcon" src={svgZip} alt="Zipdocument" />
    const imgTransaction = <img className="MenuIcon" src={svgInput} alt="Transaction" />
    const imgImport = <img className="MenuIcon" src={svgImport} alt="Import" />
    const imgUser = <img className="MenuIcon" src={svgUser} alt="Login" />
    const imgTask = <img className="MenuIcon" src={svgTask} alt="Task" />
    const imgbuild = <img className="MenuIcon" src={svgbuild} alt="Utility" />
    const imgsort_asc = <img className="MenuIcon" src={svgsort_asc} alt="sort" />
    const history = useHistory()

        const menuMaster =
        <Popover minimal position={Position.BOTTOM_LEFT} content={
            <Menu>
                { showClMast &&
                    <MenuItem icon={imgAccount} text="Client Master">
                        { userKey == "COMPSHARE" && <MenuItem icon={imgDocument} text="25 Client Master List" onClick={() => { setRecordPgmName("25 ClACList") }} href="#/ClACList" /> }
                        <MenuItem icon={imgDocument} text="Client List for SFC" onClick={() => { setRecordPgmName("ClACListSfc") }} href="#/ClACListSfc" />
                    </MenuItem>
                }
            </Menu>
        }>
            <Button minimal icon={imgMaster} text="Master" />
        </Popover>

        const menuReport =
        <Popover minimal position={Position.BOTTOM_LEFT} content={
            <Menu>
                { userKey == "COMPSHARE" && <MenuItem icon={imgDocument} text="312 Client Transaction Check List" onClick={() => { setRecordPgmName("312 ClientTranCheckList") }} href="#/ClientTranCheckList" /> }
                { userKey == "COMPSHARE" && <MenuItem icon={imgDocument} text="74 Stock Holder List" onClick={() => { setRecordPgmName("74 StkHoldList") }} href="#/StkHoldList" /> }
                { showClHistory && userKey !== "COMPSHARE" &&
                    <MenuItem icon={imgDocument} text="29 Client History Report" onClick={() => { setRecordPgmName("29 Client History") }} href="#/ClHistory" />
                }
            </Menu>
        }>
            {/* remark */}
            <Button minimal icon={imgDocument} text="Report" />
        </Popover>


        const menuSysMain =
        <Popover minimal position={Position.BOTTOM_LEFT} content={
            <Menu>
                {/* */}
                { userKey == "COMPSHARE" && <MenuItem icon={imgDocument} text="GSB Configuration" onClick={() => { setRecordPgmName("GsbxConfig") }} href="#/GsbxConfig" /> }
                { userKey == "COMPSHARE" && <MenuItem disabled={false} icon={imgsort_asc  } text="Reindex (Not All Index)" onClick={() => { setRecordPgmName("Reindex") }} href="#/SBReindex" /> }
                { userKey == "COMPSHARE" && <MenuDivider /> }
                { userKey == "COMPSHARE" && <MenuItem icon={imgDocument} text="Login Log" onClick={() => { setRecordPgmName("LoginLog") }} href="#/LoginLog" /> }
                <MenuItem icon={imgDocument} text="Reset Process" onClick={() => { setRecordPgmName("Resetprocess") }} href="#/Resetprocess" />
                <MenuItem icon={imgDocument} text="GSB Status" onClick={() => { setRecordPgmName("SB Status") }} href="#/SBstatus" />
                <MenuItem icon={imgDocument} text="GSB System Module" onClick={() => { setRecordPgmName("GSB System Module") }} href="#/SBModule" />
                <MenuDivider />
                <MenuItem icon={imgDocument} intent={warnAbout ? Intent.WARNING : "none"} text="About" onClick={() => { setRecordPgmName("About") }} href="#/About" />
                { userKey == "COMPSHARE" && <MenuItem icon={imgDocument} text="Temp Change Field Length" onClick={() => { setRecordPgmName("Temp Change Field Length") }} href="#/TempChgField" />  }
                <MenuItem icon={imgDocument} text="Log Out" onClick={() => { setRecordPgmName("Log Out") }} href="#/login" />
            </Menu>

        }>
            <Button minimal icon={imgbuild } intent={warnSysMain ? Intent.WARNING : "none"} text="System Maintenance" />
        </Popover>
        

    let showuserId = <>
        User ID: { userId }
    </>

    const changeUserLanguage = (lng: string) => {
        (async () => {
            try {
                if (isLoggedIn) {
                    //await svc.post('/userupdatecurrent', {currentLang: lng});
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }

    let lngList = [
        {lngName: "Eng", lng: "en"},
        {lngName: "繁體", lng: "zh-HK"},
        {lngName: "简体", lng: "zh-CN"},
    ]

    return (
        <>
            <Navbar className="No-Print" fixedToTop>
                <Navbar.Group align={Alignment.LEFT}>
                    <Navbar.Heading><Link to="/"><Button minimal icon={imgLogo} text="GSBce" /></Link></Navbar.Heading>
                    <Navbar.Divider />
                    {isLoggedIn ? menuMaster : null}
                    {isLoggedIn ? menuReport : null}
                    {isLoggedIn ? menuSysMain : null}
                </Navbar.Group>
                <Navbar.Group align={Alignment.RIGHT}>

                    <Navbar.Divider />
                    <div><b>GSBce</b> {Sys_VerNo}</div>      
                    <Navbar.Divider />
                    {isLoggedIn && <div > {showuserId} </div>} 
                    <MenuDivider />
                    {/*
                    <Popover minimal position={Position.BOTTOM_LEFT} content={
                        <Menu>
                            {lngList.map((lng) => <MenuItem key={lng.lng} icon="translate" text={lng.lngName} onClick={() => {i18n.changeLanguage(lng.lng); changeUserLanguage(lng.lng)}} />)}
                        </Menu>
                    }>
                        <Button className="MenuEnv" minimal icon="translate" text="Language/語言" />
                    </Popover>
                    */}
                    {isLoggedIn && <Link target="_blank" to="/tasks"><Tooltip content="Tasks"><Button minimal icon={imgTask} /></Tooltip></Link>}
                    {isLoggedIn && <Link to="/login"><Tooltip content="Logout"><Button minimal icon={imgUser} /></Tooltip></Link>}
                </Navbar.Group>
            </Navbar>
        </>
    )
}

interface MenuBar_ceProps {
    isLoggedIn?: boolean
}


function MenuBar_HKIDR({ isLoggedIn = false } : MenuBar_HKIDRProps) {

    const [showSysAdmin, setshowSysAdmin] = useState(false)
    const [showHKIDRUser, setshowHKIDRUser] = useState(false)
 //  const [showra, setshowHKIDRUser] = useState(false)
//
    const [RAP_VIEWER_USER, setRAP_VIEWER_USER] = useState(false)

    const [isDark, setIsDark] = useState(document.getElementById("body")?.classList.contains("bp4-dark"))

    const [warnSysMain, setwarnSysMain] = useState(false)
    const [warnAbout, setwarnAbout] = useState(false)
    const [warnGSBchgLog, setwarnGSBchgLog] = useState(false)

    const [showEtTradeList, setshowEtTradeList] = useState(false)
    const [showeBrokerList, setshoweBrokerList] = useState(false)
    const [showAyersList, setshowAyersList] = useState(false)

    const [showInfocastTradeList, setshowInfocastTradeList] = useState(false)
    const [showFINI,setshowFINI] = useState(false)
    const [Sys_VerNo, setSys_VerNo] = useState("")
    const [userKey, setuserKey] = useState("DEMO")
    const [userId, setuserId] = useState("")
    const [RecordPgmName, setRecordPgmName] = useState("")
    const [IPAddr, setIPAddr] = useState("")

    const [MULTI_MKT, setMULTI_MKT] = useState(false)
    const [SING_CURR, setSING_CURR] = useState(false)

    const [showUserSetup, setshowUserSetup] = useState(false)  
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")
    const [CM2K_USER, setCM2K_USER] = useState(false)
    const [IMP_CL_Mast1, setIMP_CL_Mast1] = useState(false)
    const [IMP_HKIDR_Mast1, setIMP_HKIDR_Mast1] = useState(false)       
    const [GSBXHKCRS,setGSBXHKCRS] = useState(false)
    const [CNBCAN,setCNBCAN] = useState(false)
    const [ATI_USER2, setATI_USER2] = useState(true)
    
    const [SkipCCASSRpt,setSkipCCASSRpt] = useState(false)
    document.title = 'POP-HKIDR'

    useEffect(() => {
        if ( isLoggedIn ) {
            (async () => {
                try {
                    // get GsbFlag from SB.XBS
                    const res = await gsb.post('/GsbFlag');
                    //console.log("MenuBar_HKIDR disp user_key: ", res.data.Flag.user_key)
                    GsbFlag = res.data.Flag;
                    //console.log("MenuBar_HKIDR disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                    setSys_VerNo("v"+GsbFlag.Sys_VerNo)
                    setuserKey(GsbFlag.user_key)
                    setuserId( GsbFlag.UserID)
                    setMULTI_MKT(GsbFlag.MULTI_MKT)
                    setSING_CURR(GsbFlag.SING_CURR)
                    setCNBCAN(GsbFlag.CNBCAN)                    
                    setCM2K_USER( GsbFlag.CM2K_USER)
                    setshowUserSetup(! GsbFlag.MU_FLAG)

                    //Rap viewer
                    setRAP_VIEWER_USER(GsbFlag.RAP_VIEWER_USER)
                   // console.log("setRAP_VIEWER_USER=>",RAP_VIEWER_USER)
					setIMP_HKIDR_Mast1(GsbFlag.IMP_HKIDR_Mast1)
                    if ( GsbFlag.isProduction == "Y" ) {
                        setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                    } else {
                        setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                    }
 
                } catch (error) {
                    utils.showError(error)
                }
            })()
        } else {
            (async () => {
                try {
                    const res = await gsb.post('/GsbFlag0');
                    setSys_VerNo("v"+res.data.Flag.Sys_VerNo)
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, isLoggedIn])


    useEffect(() => {
        setshowSysAdmin(false)
        setshowHKIDRUser(false)

        ;
        if ( isLoggedIn ) {
            
            (async () => {
                try {
                    // get UserAccessGroupInfo
                    const res = await gsb.post('/Master',
                    {   sb_data: {
                            cUserid2: userId,
                        },
                        cPgmId: "UserAccessGroup",
                        cAction: "GetUserAccessGroupInfo",
                        cUserid2: userId,
                    });
                    //console.log("GetUserAccessGroupInfo res.data.data", res.data.data)
                    if ( res.data.count > 0 ) {
                        setshowSysAdmin( res.data.data[0].d_User_Group1=="Y")
                        setshowHKIDRUser( res.data.data[0].d_User_Group2=="Y")
                    }


                } catch (error) {
                    utils.showError(error)
                }
            })()


            //setshowSysAdmin(true)
            //setshowHKIDRUser(true)

        }
    }, [gsb, isLoggedIn, userId, GsbFlag])


    useEffect(() => {
        setwarnSysMain(false)
        setwarnAbout(false)
        setwarnGSBchgLog(false)

        ;
        if ( isLoggedIn ) {
            (async () => {
            try {
                const res = await gsb.post('/SysMaint',
                    {   sb_data: {
                        //
                    },
                    cPgmId: "GetIconWarnInfo",
                });
                if ( res.data.ok ) {
                    //console.log("GetIconWarnInfo res.data.data", res.data.data)
                    setwarnSysMain(res.data.data[0].warnAbout) 
                    setwarnAbout(res.data.data[0].warnAbout) 
                    //setwarnGSBchgLog(res.data.data[0].warnGSBchgLog) 
          

                }
            } catch (error) {
                utils.showError(error)
            }
        })()


        }
    }, [gsb, isLoggedIn, userId, GsbFlag, Sys_VerNo])


    useEffect(() => {
        //console.log("MenuBar cardOpen01", cardOpen01)        
        if ( cardOpen01.substr(0,17) === "cardOpen01-Theme8" ) {
            document.getElementById("body")?.classList.add("bp4-dark")
            setIsDark(true)
        } else {
            document.getElementById("body")?.classList.remove("bp4-dark")
            setIsDark(false)
        }


    }, [gsb, isLoggedIn, userId, GsbFlag, cardOpen01])


    useEffect(() => {
        setshowEtTradeList(false)
        setshoweBrokerList(false)
        setshowAyersList(false)
        setshowInfocastTradeList(false)
        if ( isLoggedIn ) {
            if ( userKey === "DEMO" || userKey ==="TUNLIN" || userKey === "YFSEC" || userKey === "TAIFUNG" || userKey === "PASAY" || userKey === "FREDDY" || userKey === "SOOPC"  || userKey === "SUNCAPIT" || userKey ==="AGINCOURT" || userKey ==="GRANDFT" || userKey ==="HENYEP" || userKey === "BERICH" ) {
                setshowEtTradeList(true)
            }
          
            //console.log("MenuBar_HKIDR disp 2 userKey: ", userKey)
            //console.log("MenuBar_HKIDR disp showEtTradeList: ", showEtTradeList)
        }

        if ( isLoggedIn ) {
            if ( userKey === "DEMO" || userKey === "BERICH" || userKey === "HEADNS" || userKey ==="TUNGTAI" ) {
                setshoweBrokerList(true)
            }
            //console.log("MenuBar_HKIDR disp 2 userKey: ", userKey)
            //console.log("MenuBar_HKIDR disp setshoweBrokerList: ", setshoweBrokerList)
        }

        if ( isLoggedIn ) {
            if ( userKey === "DEMO" || userKey === "MINGFUNG"  || userKey=== "TAITACK" || userKey ==="TAITAK") {
                setshowAyersList(true)
            }
        }
        if ( isLoggedIn ) {
            if ( userKey === "DEMO" || userKey === "TARZAN" || userKey ==="PROMISING" || userKey ==="HANGTAI"  || userKey === "NEWREGION") {
                setshowInfocastTradeList(true)
            }
        }
        if ( isLoggedIn ) {
            if (CM2K_USER== true){
                setshowFINI(true)
            }
        }


        if ( isLoggedIn ) {
            if ( userKey === "DEMO" || userKey === "MINGFUNG" ) {
                setIMP_CL_Mast1(true)
            }
            else
            {
                setIMP_CL_Mast1(false)
            }

        }
        // disable CView Report 
        if ( isLoggedIn ) {
            if (  userKey === "MINGFUNG" || userKey === "TUNGTAI" || userKey === "TARZAN") {
                setSkipCCASSRpt(true)
            }
            else
            {
               setSkipCCASSRpt(false)
            }

        }

      

        if ( isLoggedIn ) {
            if ( userKey === "DEMO" ) {
                setGSBXHKCRS(true)
                setCNBCAN(true)
            }
            else
            {
                setGSBXHKCRS(false)
                setCNBCAN(false)
            }
        }


    }, [gsb, isLoggedIn, userKey, GsbFlag])


    useEffect(() => {
        if ( isLoggedIn && RecordPgmName.length > 0 ) {
            (async () => {
                try {
                    // get GsbFlag from SB.XBS
                    const res = await gsb.post('/PgmEntry', {
                        cPgmName: RecordPgmName,
                        cIPAddr: IPAddr,
                    });
                    setRecordPgmName("")
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, RecordPgmName, isLoggedIn])
    

    const imgLogo = <img className="AppLogo" src={svgLogo} alt="Logo" />
    const imgAccount = <img className="MenuIcon" src={svgAccount} alt="Account" />
    const imgMaster = <img className="MenuIcon" src={svgMaster} alt="Master" />
    const imgDocument = <img className="MenuIcon" src={svgDocument} alt="Document" />
    const imgzipDocument = <img className="MenuIcon" src={svgZip} alt="Zipdocument" />
    const imgTransaction = <img className="MenuIcon" src={svgInput} alt="Transaction" />
    const imgImport = <img className="MenuIcon" src={svgImport} alt="Import" />
    const imgUser = <img className="MenuIcon" src={svgUser} alt="Login" />
    const imgTask = <img className="MenuIcon" src={svgTask} alt="Task" />
    const imgbuild = <img className="MenuIcon" src={svgbuild} alt="Utility" />
    const imgsort_asc = <img className="MenuIcon" src={svgsort_asc} alt="Sort" />
    const history = useHistory()

        const menuMaster =
        <Popover minimal position={Position.BOTTOM_LEFT} content={
            <Menu>
                { showHKIDRUser &&
                    <MenuItem icon={imgAccount} text="HKIDR Master">
                        <MenuItem icon={imgAccount} text="Import Client from GSB (New Client)" onClick={() => { setRecordPgmName("Import Client from GSB (New Client)") }} href="#/HkidrImpAccount" />
                        {( IMP_HKIDR_Mast1 ) && <MenuItem icon={imgImport} text="Import HKIDR TAB from Text File" onClick={() => { setRecordPgmName("Import HKIDR TAB from Text File") }} href="#/ImportHKIDRMast1" />  }  
                       <MenuDivider />

                        { ( IMP_CL_Mast1 ) && <MenuItem icon={imgImport} text="Import Client TAB from Text File" onClick={() => { setRecordPgmName("Import Client TAB from Text File") }} href="#/ImportClMast1" />  }
                       
                        <MenuItem icon={imgAccount} text="HKIDR Master" onClick={() => { setRecordPgmName("HKIDR Master") }} href="#/HkidrMast" />
                        {/*
                        <MenuItem icon={imgAccount} text="Replicate Account Holder (Join Account)" onClick={() => { setRecordPgmName("Replicate HKIDR Account") }} href="#/WIP" />
                        <MenuItem icon={imgAccount} text="Delete Account Holder" onClick={() => { setRecordPgmName("Delete HKIDR Account") }} href="#/WIP" />
                        */}
                        <MenuItem icon={imgDocument} text="HKIDR Master List" onClick={() => { setRecordPgmName("HKIDR Master List") }} href="#/HkidrMastList" />
                        <MenuItem icon={imgDocument} text="HKIDR Master Audit Log" onClick={() => { setRecordPgmName("HKIDR Audit Log")}} href="#/HkidrLog" />
                        <MenuItem icon={imgDocument} intent={warnGSBchgLog ? Intent.WARNING : "none"} text="GSB Client Name Change Log" onClick={() => { setRecordPgmName("GSB Client Name Change Log") }} href="#/GsbNameChangeLog" />
                        <MenuDivider />
                        <MenuItem icon={imgAccount} text="Import HK Consent Status (CSV)" onClick={() => { setRecordPgmName("Import HK Consent Status") }} href="#/importHkconsentCSV" />
 
                        <MenuDivider />
                        {/*
                        <MenuItem icon={imgAccount} text="Generate CNBcan" onClick={() => { setRecordPgmName("Generate CNBcan") }} href="#/CNBcanGen" />
                        */}
                       {/* <MenuItem icon={imgAccount} text="Export Hk Consent Status for Mail Merge (CSV)" onClick={() => { setRecordPgmName("Export Hk Consent Status") }} href="#/ExportHkConsent" />*/}
                    </MenuItem>
                }
                { ATI_USER2 && 
                    <MenuItem icon={imgAccount} text="ATI">
                        <MenuItem icon={imgAccount} text="ATI Output File Adjustment" onClick={() => { setRecordPgmName("ATI File Adj") }} href="#/Ati_Adj1" />
                    </MenuItem>
                }
            </Menu>
        }>
            <Button minimal icon={imgMaster} text="Master" />
        </Popover>
        
        const menuReport =
        <Popover minimal position={Position.BOTTOM_LEFT} content={
            <Menu>
                { showHKIDRUser &&
                    <MenuItem icon={imgDocument} text="Print HK Consent" onClick={() => { setRecordPgmName("Print HK RConsent") ; history.push("/HkidrHkConsent") }} href="#/HkidrHkConsent" />
                }
                { showHKIDRUser &&
                    <MenuItem icon={imgAccount} text="Export HK Consent Status for Mail Merge (CSV)" onClick={() => { setRecordPgmName("Export HK Consent Status") ; history.push("/ExportHkConsent") }} href="#/ExportHkConsent" />
                }
               {/*<MenuDivider />
               <MenuItem icon={imgDocument} text="Print China Consent" onClick={() => { setRecordPgmName("Print HK RConsent") }} href="#/WIP" />
               <MenuItem icon={imgAccount} text="Export china Consent Status for Mail Merge (CSV)" onClick={() => { setRecordPgmName("Export Hk Consent Status") }} href="#/WIP" />
				*/}
                {/* test print statement at HKIRD
                { userKey === "NEWREGION" &&
                    <MenuItem icon={imgAccount} text="542 Daily Statement" onClick={() => { setRecordPgmName("542 Daily Statement") ; history.push("/Dstatement") }} href="#/Dstatement" />
                }
                { userKey === "NEWREGION" &&
                    <MenuItem icon={imgAccount} text="831 Monthly Statement" onClick={() => { setRecordPgmName("831 Monthly Statement") ; history.push("/Mstatement") }} href="#/Mstatement" />
                }
                */}
            </Menu>
        }>
            {/* remark */}
            <Button minimal icon={imgDocument} text="Print / export consent" />
        </Popover>

        const menuBCANExportResult =
        <Popover minimal position={Position.BOTTOM_LEFT} content={
            <Menu>
                { showHKIDRUser &&
                    <MenuItem icon={imgDocument} text="HKBCAN-CID">
                        <MenuItem icon={imgDocument} text="Export HKBCAN-CID Mapping File" onClick={() => { setRecordPgmName("Export HKBCAN Mapping File") }} href="#/HkidrBcanMapping" />
                        <MenuDivider />
                        <MenuItem icon={imgDocument} text="Read HKBCAN-CID Response File" onClick={() => { setRecordPgmName("Read HKBCAN Response File") }} href="#/HkidrResponseFile" />
                        <MenuItem icon={imgDocument} text="Read HKBCAN-CID Process Result File" onClick={() => { setRecordPgmName("Read HKBCAN Result File") }} href="#/HkidrProcessResultFile" />
                        <MenuItem icon={imgDocument} text="Read HKBCAN-CID BCAN Full Image Reconcile File" onClick={() => { setRecordPgmName("Read HKBCAN Full Image File") }} href="#/HkidrFullImageFile" />
        
                        {/*
                        <MenuItem icon={imgDocument} text="HKBCAN-CID Aggregated Transaction">
                        <MenuItem icon={imgDocument} text="Read Response File" onClick={() => { setRecordPgmName("Read HKBCAN Aggregated Response File") ; history.push("/WIP") }} />
                        <MenuItem icon={imgDocument} text="Read Result File" onClick={() => { setRecordPgmName("Read HKBCAN Aggregated Result File") ; history.push("/WIP") }} />        
                        </MenuItem>

                        <MenuItem icon={imgDocument} text="HKBCAN-CID Change">
                        <MenuItem icon={imgDocument} text="Read Response File" onClick={() => { setRecordPgmName("Read HKBCAN Change Response File") ; history.push("/WIP") }} />
                        <MenuItem icon={imgDocument} text="Read Result File" onClick={() => { setRecordPgmName("Read HKBCAN Change  Result File") ; history.push("/WIP") }} />
                        </MenuItem>

                
                        <MenuItem icon={imgDocument} text="HKBCAN-CID Error">
                        <MenuItem icon={imgDocument} text="Read Response File" onClick={() => { setRecordPgmName("Read HKBCAN Error Response Fie") ; history.push("/WIP") }} />
                        <MenuItem icon={imgDocument} text="Read Result File" onClick={() => { setRecordPgmName("Read HKBCAN Error Result Fie") ; history.push("/WIP") }} />                    
                        </MenuItem>             
                        <MenuItem icon={imgDocument} text="HKBCAN-CID Off-exchange ">

                        <MenuItem icon={imgDocument} text="Read Trade BCAN (Buy-side) Report Response File" onClick={() => { setRecordPgmName("Read HKBCAN Off-exchange Trade BCAN (Buy-side) Report Response File") ; history.push("/WIP") }} />
                        <MenuItem icon={imgDocument} text="Read Trade BCAN (Buy-side) Report Result File" onClick={() => { setRecordPgmName("Read HKBCAN Off-exchange Trade BCAN (Buy-side) Report Result File") ; history.push("/WIP") }} />
                        </MenuItem>
                        */}
                        { ( showEtTradeList || showeBrokerList || showInfocastTradeList) &&
                            <MenuDivider />
                        }
                        { showEtTradeList &&
                            <MenuItem icon={imgDocument} text="Export HKIDR List for ET Trade" onClick={() => { setRecordPgmName("Export HKIDR List for ETTrade") }} href="#/HkidrETTradeList" />
                        }
                        { showeBrokerList &&
                            <MenuItem icon={imgDocument} text="Export HKIDR List for eBroker" onClick={() => { setRecordPgmName("Export HKIDR List for eBroker") }} href="#/HkidreBrokerList" />
                        }
                        { showAyersList &&
                            <MenuItem icon={imgDocument} text="Export HKIDR List for Ayers" onClick={() => { setRecordPgmName("Export HKIDR List for eBroker") }} href="#/HkidrAyersList" />
                        }
                        { showInfocastTradeList &&
                            <MenuItem icon={imgDocument} text="Export HKIDR List for Infocast" onClick={() => { setRecordPgmName("Export HKIDR List for Infocast") }} href="#/HkidrInfocastList" />
                        }                        
                    </MenuItem>
                }
                {CNBCAN && <MenuDivider />}
                {CNBCAN  &&  <MenuItem icon={imgDocument} text="CNBCAN-CID">
                    <MenuItem icon={imgDocument} text="Export CNBCAN-CID Mapping File" onClick={() => { setRecordPgmName("Export CNBCAN-CID Mapping File") }} href="#/CNBcanMapping" />                    
                    {/*<MenuItem icon={imgDocument} text="Export CNBCAN-CID Authorised TTEP Firm List" onClick={() => { setRecordPgmName("Export CNBCAN-CID Authorised TTEP Firm List") }} href="#/CNBcanAuFM" /> */}
                    <MenuDivider />
                    <MenuItem icon={imgDocument} text="Read CNBCAN-CID Response File" onClick={() => { setRecordPgmName("Read CNBCAN-CID Response File") }} href="#/CNBcanResponseFile" />
                    <MenuItem icon={imgDocument} text="Read CNBCAN-CID Authorised TTEP List Response File" onClick={() => { setRecordPgmName("Read CNBCAN-CID Authorised TTEP List Response File") }}href="#/CNBcanAurpResponseFile"  />
                    <MenuItem icon={imgDocument} text="Read CNBCAN-CID validation result File" onClick={() => { setRecordPgmName("Read CNBCAN-CID validation result File") }} href="#/CNBcanRsltResultFile" />
                    <MenuItem icon={imgDocument} text="Read CNBCAN-CID  Full Image Reconcile File" onClick={() => { setRecordPgmName("Read CNBCAN-CID Full Image File") }} href="#/CNBcanFimgFile" />
                </MenuItem>
                }

            </Menu>
        }>
            {/* remark */}
            <Button minimal icon={imgDocument} text="BCAN-CID Mapping/Result File" />
        </Popover>



        const menuOtcrExportResult =
        <Popover minimal position={Position.BOTTOM_LEFT} content={
            <Menu>  
                <MenuItem icon={imgDocument} text="Export OTCR Report File (D/W)" onClick={() => { setRecordPgmName("Export OTCR Report File (D/W)") }} href="#/HkidrOtcr" >
                </MenuItem>
                <MenuItem icon={imgDocument} text="Export OTCR Report File (D/W)in History" onClick={() => { setRecordPgmName("Export OTCR Report File (D/W)in History") }} href="#/HkidrOtcr2" >
                </MenuItem>
       
                {/*
                <MenuItem icon={imgDocument} text="Read CNBCAN-CID Response File" onClick={() => { setRecordPgmName("Read HKBCAN Response File") ; history.push("/WIP") }} />
                <MenuItem icon={imgDocument} text="Read CNBCAN-CID Process Result File" onClick={() => { setRecordPgmName("Read HKBCAN Result File") ; history.push("/WIP") }} />
                <MenuItem icon={imgDocument} text="Read CNBCAN-CID BCAN Full Image Reconcile File" onClick={() => { setRecordPgmName("Read HKBCAN Full Image File") ; history.push("/WIP") }} />
                */}
            </Menu>
        }>
            {/* remark */}
            <Button minimal icon={imgDocument} text="OTCR" />
        </Popover>
        const menuRapReport =
        <Popover minimal position={Position.BOTTOM_LEFT} content={
            <Menu>
                <MenuItem icon={imgImport} text=" CCASS Import" onClick={() => { setRecordPgmName("CCASS Import")}} href="#/ImportCCASSxRpt" />
                <MenuItem icon={imgDocument} text=" CCASS Report" disabled={SkipCCASSRpt} onClick={() => { setRecordPgmName("CCASS Report")}} href="#/CCASSRpt" />
            </Menu>
            }>
            {/* remark */}
            <Button minimal icon={imgDocument} text="RAP Viewer" />
        </Popover>

        const menuFiniExportResult =
        <Popover minimal position={Position.BOTTOM_LEFT} content={
            <Menu> 
                <MenuItem icon={imgDocument} text="Export Application File for FINI" onClick={() => { setRecordPgmName("Export Application File for FINI") }} href="#/IPOExportFINI" >
                </MenuItem> 
                <MenuItem icon={imgDocument} text="Export Application File for Bond" onClick={() => { setRecordPgmName("Export Application File for Bond") }} href="#/IPOExportIBOND" >
                </MenuItem> 
                <MenuItem icon={imgDocument} text="Import FINI Authorised File" onClick={() => { setRecordPgmName("Import FINI Authorised File") }} href="#/IPOFINIAuthorisedFile" >
                </MenuItem> 
                <MenuItem icon={imgDocument} text="Import FINI Allotment Result" onClick={() => { setRecordPgmName("Import FINI Allotment Result") }} href="#/IPOImportAllotment" >
                </MenuItem> 

           
     
                {/*<MenuItem icon={imgDocument} text="FINI Reset EIPO" onClick={() => { setRecordPgmName("FINI Reset EIPO") }} href="#/ExportEIPOReset" >
                </MenuItem>*/} 

                
                {/*
                <MenuItem icon={imgDocument} text="Read CNBCAN-CID Response File" onClick={() => { setRecordPgmName("Read HKBCAN Response File") ; history.push("/WIP") }} />
                <MenuItem icon={imgDocument} text="Read CNBCAN-CID Process Result File" onClick={() => { setRecordPgmName("Read HKBCAN Result File") ; history.push("/WIP") }} />
                <MenuItem icon={imgDocument} text="Read CNBCAN-CID BCAN Full Image Reconcile File" onClick={() => { setRecordPgmName("Read HKBCAN Full Image File") ; history.push("/WIP") }} />
                */}
            </Menu>
        }>
            {/* remark */}
            <Button minimal icon={imgDocument} text="FINI" />
        </Popover>

        const menuSysMain =
        <Popover minimal position={Position.BOTTOM_LEFT} content={
            <Menu>
                {/* */}
                {/* CheckPgmAccess("S0003") && <MenuItem disabled={false} icon={imgsort_asc  } text="System Upgrade, Reindex" onClick={() => { setRecordPgmName("System Upgrade, Reindex") }} href="#/SBReindex" /> */}
                <MenuDivider />
                { showSysAdmin &&
                    <MenuItem icon={imgDocument} text="BCAN Configuration" onClick={() => { setRecordPgmName("BcanConfig") }} href="#/BcanConfig" />
                }
                { showSysAdmin &&
                    <MenuDivider />
                }
                <MenuItem icon={imgDocument} text="Reset Process" onClick={() => { setRecordPgmName("Resetprocess") }} href="#/Resetprocess" />
                <MenuItem icon={imgDocument} text="GSB Status" onClick={() => { setRecordPgmName("SB Status") }} href="#/SBstatus" />
                { showSysAdmin && showUserSetup &&
                    <MenuItem icon={imgAccount} text="User Master">
                        <MenuItem icon={imgDocument} text="User Master Setup" onClick={() => { setRecordPgmName("User Master Setup") }} href="#/UserMast" />
                        <MenuItem icon={imgDocument} text="User List" onClick={() => { setRecordPgmName("User List") }} href="#/UserMastList" />
                        <MenuItem icon={imgDocument} text="User Audit Log" onClick={() => { setRecordPgmName("User Audit Log") }} href="#/UserMastLog" />
                        <MenuItem icon={imgDocument} text="Reset User Password" onClick={() => { setRecordPgmName("Reset User Password") }} href="#/UserchgPasswd2" />
                        <MenuItem icon={imgDocument} text="User Access Group" onClick={() => { setRecordPgmName("User Access Group") }} href="#/UserAccessGroup" />
                </MenuItem> }
                { showSysAdmin && ! showUserSetup &&
                    <MenuItem icon={imgDocument} text="User Access Group" onClick={() => { setRecordPgmName("User Access Group") }} href="#/UserAccessGroup" />
                }
                { showUserSetup &&
                    <MenuItem icon={imgDocument} text="Change User Password" onClick={() => { setRecordPgmName("Change User Password") }} href="#/UserchgPasswd" />
                }
                <MenuItem icon={imgDocument} intent={warnAbout ? Intent.WARNING : "none"} text="About" onClick={() => { setRecordPgmName("About") }} href="#/About" />
                { showSysAdmin && <MenuItem icon={imgDocument} text="Temp Change Field Length" onClick={() => { setRecordPgmName("Temp Change Field Length") }} href="#/TempChgField" />  }
                <MenuItem icon={imgDocument} text="Log Out" onClick={() => { setRecordPgmName("Log Out") }} href="#/login" />
            </Menu>

        }>
            <Button minimal icon={imgbuild } intent={warnSysMain ? Intent.WARNING : "none"} text="System Maintenance" />
        </Popover>

    let showuserId = <>
        User ID: { userId }
    </>

    const changeUserLanguage = (lng: string) => {
        (async () => {
            try {
                if (isLoggedIn) {
                    //await svc.post('/userupdatecurrent', {currentLang: lng});
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }

    let lngList = [
        {lngName: "Eng", lng: "en"},
        {lngName: "繁體", lng: "zh-HK"},
        {lngName: "简体", lng: "zh-CN"},
    ]

    return (
        <>
            <Navbar className="No-Print" fixedToTop>
                <Navbar.Group align={Alignment.LEFT}>
                    <Navbar.Heading><Link to="/"><Button minimal icon={imgLogo} text="HKIDR" /></Link></Navbar.Heading>
                    <Navbar.Divider />
                    {isLoggedIn && showHKIDRUser ? menuMaster : null}
                    {isLoggedIn && showHKIDRUser ? menuReport : null}
                    {isLoggedIn && showHKIDRUser ? menuBCANExportResult : null}
                    { isLoggedIn && showHKIDRUser ? menuOtcrExportResult : null}
                    { isLoggedIn && RAP_VIEWER_USER ? menuRapReport : null}                                      
                    { isLoggedIn && showHKIDRUser && CM2K_USER && GsbFlag.user_key !== "WINGHANG" ? menuFiniExportResult : null}  
                    {isLoggedIn ? menuSysMain : null}
                </Navbar.Group>

                
                <Navbar.Group align={Alignment.RIGHT}>
                    
                    <div><b>HKIDR</b> {Sys_VerNo}</div>      
                    <Navbar.Divider />
                    {isLoggedIn && <div > {showuserId} </div>} 
                    <MenuDivider />
                    {/*
                    <Popover minimal position={Position.BOTTOM_LEFT} content={
                        <Menu>
                            {lngList.map((lng) => <MenuItem key={lng.lng} icon="translate" text={lng.lngName} onClick={() => {i18n.changeLanguage(lng.lng); changeUserLanguage(lng.lng)}} />)}
                        </Menu>
                    }>
                        <Button className="MenuEnv" minimal icon="translate" text="Language/語言" />
                    </Popover>
                    */}
                    {isLoggedIn && <Link to="/login"><Button minimal icon={imgUser} /></Link>}
                </Navbar.Group>
            </Navbar>
        </>
    )
}

interface MenuBar_HKIDRProps {
    isLoggedIn?: boolean
}


function MenuBar_FBS({ isLoggedIn = false, onSystemStatusClick = ()=>{} } : MenuBar_FBSProps) {
 
    const [PgmLists, setPgmLists] = useState([] as PgmAccessList[])
    const [ShowDisableItem, setShowDisableItem] = useState(true)

    const imgFinancialreport = <img className="MenuIcon" src={svgFinancialreport} alt="Financialreport" />
    const imgChecklist = <img className="MenuIcon" src={svgChecklist} alt="Checklist" />
    
    const [stmtEncode, setstmtEncode] = useState("N")
    const [showSentEmailStatement, setshowSentEmailStatement] = useState(false)

    const [warnSysMain, setwarnSysMain] = useState(false)
    const [warnAbout, setwarnAbout] = useState(false)

    const [Sys_VerNo, setSys_VerNo] = useState("")
    const [userKey, setuserKey] = useState("DEMO")
    const [userId, setuserId] = useState("")
    const [RecordPgmName, setRecordPgmName] = useState("")
    const [IPAddr, setIPAddr] = useState("")

    const [isDark, setIsDark] = useState(document.getElementById("body")?.classList.contains("bp4-dark"))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    const [OBx_USER, setOBx_USER] = useState(false)


    const [PgmListsLoaded, setPgmListsLoaded] = useState(false) 
   	const [items, setItems] = useState([] as MenuItemProps[])
    const [selectedItem, setSelectedItem] = useState({} as MenuItemProps)

    let allMenuItems = [] as MenuItemProps[]

    const addMenuItem = (PgmName: string, item: MenuItemProps): JSX.Element => {
//console.log("addMenuItem PgmLists", PgmLists)
//console.log("addMenuItem PgmName", PgmName, item)
        // check can show
        if ( CheckPgmAccess3(PgmName) ) {
            // setItems([...items, item])
            // check can access, disable
            if ( ! CheckPgmAccess(PgmName) ) {
                if ( ShowDisableItem ) {
                    item.disabled=true
                } else {
                    return <></>
                }
            }

            allMenuItems.push(item)
            // console.log("addMenuItem", item.text, allMenuItems.length)
            return <MenuItem {...item}></MenuItem>
        }
        return <></>
    }

    document.title = 'POP-FBSx' 

    useEffect(() => {
        //console.log("MenuBar_FBS useEffect() [gsb, isLoggedIn]", allMenuItems.length)
        if ( isLoggedIn ) {
            (async () => {
                try {
                    // get GsbFlag from SB.XBS
                    const res = await gsb.post('/GsbFlag');
                    //console.log("MenuBar_ce disp user_key: ", res.data.Flag.user_key)
                    GsbFlag = res.data.Flag;
                    //console.log("MenuBar_ce disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                    setSys_VerNo("v"+GsbFlag.Sys_VerNo) 
                    setuserKey(GsbFlag.user_key)
                    setuserId( GsbFlag.UserID)
                    if ( GsbFlag.isProduction == "Y" ) {
                        setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                    } else {
                        setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                    }

                    setstmtEncode(GsbFlag.stmtEncode)
                    setOBx_USER(GsbFlag.OBx_USER);

                    setPgmLists(res.data.UserPgmListData)
                    //console.log("MenuBar_FBS PgmLists", PgmLists)

                    if ( GsbFlag.Show_Disabled_Menu_Item == "N" ) {
                        setShowDisableItem(false)
                    } else  {
                        setShowDisableItem(true)
                    }
                    i18next.changeLanguage("en") ;

                } catch (error) {
                    utils.showError(error)
                }
            })()
        } else {
            (async () => {
                try {
                    const res = await gsb.post('/GsbFlag0');
                    setSys_VerNo("v"+res.data.Flag.Sys_VerNo)
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, isLoggedIn])


    useEffect(() => {
        //console.log("MenuBar_FBS useEffect() [PgmListsLoaded]", allMenuItems.length, PgmListsLoaded)
        setItems(allMenuItems)
    }, [PgmListsLoaded, ShowDisableItem])


    useEffect(() => {
        if (PgmLists.length > 0) {
            setPgmListsLoaded(true)
        }
    }, [gsb, isLoggedIn, userId, GsbFlag, PgmLists])


    useEffect(() => {
        //console.log("MenuBar_FBS useEffect() [userId, GsbFlag, Sys_VerNo]", allMenuItems.length)
        setwarnSysMain(false)
        setwarnAbout(false)

        ;
        if ( isLoggedIn ) {
            (async () => {
            try {
                const res = await gsb.post('/SysMaint',
                    {   sb_data: {
                        //
                    },
                    cPgmId: "GetIconWarnInfo",
                });
                if ( res.data.ok ) {
                    //console.log("GetIconWarnInfo res.data.data", res.data.data)
                    setwarnSysMain(res.data.data[0].warnAbout) 
                    setwarnAbout(res.data.data[0].warnAbout) 

                }
            } catch (error) {
                utils.showError(error)
            }
        })()


        }
    }, [gsb, isLoggedIn, userId, GsbFlag, Sys_VerNo])
    

    useEffect(() => {
        //console.log("MenuBar_FBS useEffect() [userId, GsbFlag, cardOpen01]", allMenuItems.length)
        //console.log("MenuBar cardOpen01", cardOpen01)        
        if ( cardOpen01.substr(0,17) === "cardOpen01-Theme8" ) {
            document.getElementById("body")?.classList.add("bp4-dark")
            setIsDark(true)
        } else {
            document.getElementById("body")?.classList.remove("bp4-dark")
            setIsDark(false)
        }
    
    
    }, [gsb, isLoggedIn, userId, GsbFlag, cardOpen01])
    

    useEffect(() => {
        if ( isLoggedIn && RecordPgmName.length > 0 ) {
            (async () => {
                try {
                    // get GsbFlag from SB.XBS
                    const res = await gsb.post('/PgmEntry', {
                        cPgmName: RecordPgmName,
                        cIPAddr: IPAddr,
                    });
                    setRecordPgmName("")
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, RecordPgmName, isLoggedIn])
    
    // User can Access Pgm or disable
    function CheckPgmAccess(PgmName: string): boolean{
        var canAccess = false;

        //if (PgmName[0] == "F") return true; // TODO - for development purpose, remove when program code list is done

        for (let i = 0; i < PgmLists.length; i++) {
            //console.log("func CheckPgmAccess PgmLists", PgmName, PgmLists[i].d_PgmCode, PgmLists[i].d_PgmAccess)
            if (PgmLists[i].d_PgmCode === PgmName ) {
                //console.log("func CheckPgmAccess PgmLists", PgmName, PgmLists[i].d_PgmCode, PgmLists[i].d_PgmAccess)
                if (PgmLists[i].d_PgmAccess === "Y" ) {
                    canAccess = true;
                }
                break ;
            }
        }
        return canAccess;
    }

    //is isReadOnly
    function CheckPgmAccess2(PgmName: string): boolean{
        var canAccess = true;

        for (let i = 0; i < PgmLists.length; i++) {
            //console.log("func CheckPgmAccess PgmLists", PgmName, PgmLists[i].d_PgmCode, PgmLists[i].d_PgmAccess)
            if (PgmLists[i].d_PgmCode === PgmName ) {
                //console.log("func CheckPgmAccess PgmLists", PgmName, PgmLists[i].d_PgmCode, PgmLists[i].d_PgmAccess)
                if (PgmLists[i].d_PgmAction === "R" ) {
                    canAccess = false;
                }
                break ;
            }
        }
        return canAccess;
    }

    // User can Executive Pgm, paid module , buy ?
    function CheckPgmAccess3(PgmName: string): boolean{
        var canShow = true;

        for (let i = 0; i < PgmLists.length; i++) {
            //console.log("func CheckPgmAccess PgmLists", PgmName, PgmLists[i].d_PgmCode, PgmLists[i].d_PgmAccess)
            if (PgmLists[i].d_PgmCode === PgmName ) {
                //console.log("func CheckPgmAccess PgmLists", PgmName, PgmLists[i].d_PgmCode, PgmLists[i].d_PgmAccess)
                if  ( ! (PgmLists[i].d_PgmCanExec === "Y") ) {
                    canShow = false;
                }
                break ;
            }
        }
        return canShow;
    }

    const imgLogo = <img className="AppLogo" src={svgLogo} alt="Logo" />
    const imgAccount = <img className="MenuIcon" src={svgAccount} alt="Account" />
    const imgMaster = <img className="MenuIcon" src={svgMaster} alt="Master" />
    const imgDocument = <img className="MenuIcon" src={svgDocument} alt="Document" />
    const imgFileBox = <img className="MenuIcon" src={svgFileBox} alt="File" />
    const imgMoney = <img className="MenuIcon" src={svgMoney} alt="Money" />
    const imgzipDocument = <img className="MenuIcon" src={svgZip} alt="Zipdocument" />
    const imgTransaction = <img className="MenuIcon" src={svgInput} alt="Transaction" />
    const imgImport = <img className="MenuIcon" src={svgImport} alt="Import" />
    const imgUser = <img className="MenuIcon" src={svgUser} alt="Login" />
    const imgTask = <img className="MenuIcon" src={svgTask} alt="Task" />
    const imgbuild = <img className="MenuIcon" src={svgbuild} alt="Utility" />
    const imgsort_asc = <img className="MenuIcon" src={svgsort_asc} alt="sort" />
    const imgStart = <img className="MenuIcon" src={svgStart} alt="Start" />
    const imgFilingOK = <img className="MenuIcon" src={svgFilingOK} alt="Filing OK" />
    const imgCalculating = <img className="MenuIcon" src={svgCalculating} alt="Calculating" />
    const history = useHistory()

        const menuMaster =
        <Popover minimal position={Position.BOTTOM_LEFT} content={
            <Menu>
                {/* { CheckPgmAccess("FM0001") &&  <MenuItem icon={imgFileBox} text="Exchange Information" onClick={() => { setRecordPgmName("Exchange Information") }} href="#/fbs/MarketMast" /> } */}
                {/* CheckPgmAccess("FM0001") && addMenuItem("FM0001", { icon:imgFileBox, disabled:(! CheckPgmAccess("FM0001")), text:"A1 Exchange Information", onClick:() => { setRecordPgmName("Exchange Information") }, href:"#/fbs/MarketMast" }) */}
                { addMenuItem("FM0001", { icon:imgFileBox, text:"A1 Exchange Information", onClick:() => { setRecordPgmName("Exchange Information") }, href:"#/fbs/MarketMast" }) }
                <MenuItem icon={imgAccount} text="Commodity Information">
                    { addMenuItem("FM0004", { icon:imgFileBox, text:"A2 Commodity Information", onClick:() => { setRecordPgmName("Commodity Information") }, href:"#/fbs/ComdyMast" }) }
                    { addMenuItem("FM0005", { icon:imgFileBox, text:"Commodify Information List", onClick:() => { setRecordPgmName("Commodify Information List") }, href:"#/fbs/ComdyList" }) }
                </MenuItem>
                { addMenuItem("FM0007", { icon:imgFileBox, text:"A3 Futures Month & Expiry Date", onClick:() => { setRecordPgmName("Futures Month & Expiry Date") }, href:"#/fbs/ExpiryMast" }) }
                { OBx_USER && <MenuDivider /> }
                { OBx_USER && addMenuItem("OM0001", { icon:imgFileBox, text:"Stock Option Master", onClick:() => { setRecordPgmName("Stock Option Master") }, href:"#/fbs/SmMast" }) }
                <MenuDivider />
                {<>
                    <MenuItem icon={imgAccount} text="Account Information">
                        {/* CheckPgmAccess("FM0010") && <MenuItem icon={imgAccount} text="Account Information" onClick={() => { setRecordPgmName("FBSx Account Information") }} href="#/fbs/ClMast" /> */}
                        {/* CheckPgmAccess("FM0010") && addMenuItem("FM0010", { icon:imgAccount, disabled:(! CheckPgmAccess("FM0010")), text:"A4 Account Information", onClick:() => { setRecordPgmName("FBSx Account Information") }, href:"#/fbs/ClMast" }) */}
                        { addMenuItem("FM0010", { icon:imgAccount, disabled:(false), text:"A4 Account Information", onClick:() => { setRecordPgmName("FBSx Account Information") }, href:"#/fbs/ClMast" }) }
                        { addMenuItem("FM0011", { icon:imgDocument, text:"Account Information List", onClick:() => { setRecordPgmName("FBSx Account Information List") }, href:"#/fbs/ClList" }) }
                        { addMenuItem("FM0012", { icon:imgDocument, text:"Account Information Audit Log", onClick:() => { setRecordPgmName("FBSx Account Information Audit Log") }, href:"#/fbs/ClLog" }) }
                    </MenuItem> 
                    { addMenuItem("FM0013", { icon:imgAccount, text:"A5 Account Balance", onClick:() => { setRecordPgmName("Account Balance") }, href:"#/fbs/CbMast" }) }
                    { addMenuItem("FM0014", { icon:imgAccount, text:"A6 Clearing Agent Balance", onClick:() => { setRecordPgmName("Clearing Agent Balance") }, href:"#/fbs/CbMastB" }) }
                    { addMenuItem("FM0015", { icon:imgFileBox, text:"AE Position Enquiry", onClick:() => { setRecordPgmName("Position Enquiry") }, href:"#/fbs/OpenPos" }) }
                </>}
                <MenuDivider />
                <MenuItem icon={imgAccount} text="Tables Setting">
                    { addMenuItem("FM0016", { icon:imgAccount, text:"Currency Table", onClick:() => { setRecordPgmName("FBSx Currency Table") }, href:"#/fbs/CurrencyMast" }) }
                    {/* addMenuItem("FM0019", { icon:imgAccount, disabled:(true), text:"Holiday Table", onClick:() => { setRecordPgmName("InteHolidayrest Table") }, href:"#/fbs/HolidayMast"  }) */}
                    {/* addMenuItem("FM0021", { icon:imgAccount, disabled:(true), text:"Interest Table", onClick:() => { setRecordPgmName("Interest Table") }, href:"#/fbs/IntMast" }) */}
                    <MenuItem icon={imgAccount} text="Commission Class">
                        { addMenuItem("FM0024", { icon:imgAccount, text:"Commission Class", onClick:() => { setRecordPgmName("FBSx Commission Class") }, href:"#/fbs/CommMast" }) }
                        { addMenuItem("FM0025", { icon:imgFileBox, text:"Commission & Rebate List", onClick:() => { setRecordPgmName("FBSx Commission & Rebate List") }, href:"#/fbs/CommList" }) }
                        { addMenuItem("FM0026", { icon:imgFileBox, text:"Commission & Rebate Audit Log", onClick:() => { setRecordPgmName("FBSx Commission & Rebate Audit Log") }, href:"#/fbs/CommLog" }) }
                    </MenuItem>
                    { OBx_USER && <MenuItem icon={imgAccount} text="Market Master">
                        { addMenuItem("OM0013", { icon:imgAccount, text:"23M Market Master", onClick:() => { setRecordPgmName("23M MktMast") }, href:"#/MktMast?syscode=Fbsx" }) }
                        { addMenuItem("OM0014", { icon:imgDocument, text:"23ML Market Master Audit Log", onClick:() => { setRecordPgmName("23ML MktLog") }, href:"#/MktLog?syscode=Fbsx" }) }
                    </MenuItem> }
                    { OBx_USER && <MenuItem icon={imgAccount} text="Market Fee Master">
                        { addMenuItem("OM0015", { icon:imgAccount, text:"23F Market Fee Master", onClick:() => { setRecordPgmName("23F MktFeeMast") }, href:"#/MktFeeMast?syscode=Fbsx" }) }
                        { addMenuItem("OM0016", { icon:imgDocument, text:"23FL Market Fee Master Audit Log", onClick:() => { setRecordPgmName("23FL MktFeeLog") }, href:"#/MktFeeLog?syscode=Fbsx" }) }
                    </MenuItem> }
                </MenuItem>
 
                { GsbFlag.STD_INST && <MenuItem icon={imgAccount} text="Standing Instruction"> 
                    { addMenuItem("FM0039", { icon:imgAccount, text:"Standing Instruction Code Setup", onClick:() => { setRecordPgmName("FBSx Standing Instruction Code Setup") }, href:"#/StdInstSetup?syscode=Fbsx" }) }
                    { addMenuItem("FM0040", { icon:imgAccount, text:"Standing Instruction Entry", onClick:() => { setRecordPgmName("FBSx Standing Instruction Entry") }, href:"#/StdMast?syscode=Fbsx" }) }
                    { addMenuItem("FM0041", { icon:imgAccount, text:"Standing Instruction Entry List", onClick:() => { setRecordPgmName("FBSx Standing Instruction Entry List") }, href:"#/StdMastList?syscode=Fbsx" }) }
                    { addMenuItem("FM0042", { icon:imgAccount, text:"Standing Instruction Entry Audit Log", onClick:() => { setRecordPgmName("FBSx Instruction Entry Audit Log") }, href:"#/StdMastLog?syscode=Fbsx" }) }
                    { addMenuItem("FM0043", { icon:imgAccount, text:"Confirmation of Renew Standing Instruction Report", onClick:() => { setRecordPgmName("FBSx Confirmation of Renew Std Inst Report") }, href:"#/ConfirmRenewStdInst?syscode=Fbsx" }) }
                </MenuItem> }
            </Menu>
        }>
            <Button minimal icon={imgMaster} text="Master" />
        </Popover>

        const menuTransaction =
        <Popover minimal position={Position.BOTTOM_LEFT} content={
            <Menu>
                { addMenuItem("FT0001", { icon:imgStart, text:"BS System Start", onClick:() => { setRecordPgmName("System Start") }, href:"#/fbs/SystemStart" }) }
                { addMenuItem("FT0002", { icon:imgFileBox, text:"BX Exchange Rate & Prime Rate", onClick:() => { setRecordPgmName("Exchange Rate & Prime Rate") }, href:"#/fbs/CurrencyParamUpdate" }) }
                <MenuDivider />

                { addMenuItem("FT0003", { icon:imgImport, text:"Import File", onClick:() => { setRecordPgmName("Import file") }, href:"#/import" }) }

                { <MenuItem icon={imgMoney} text="Fund Movement">
                    { addMenuItem("FT0004", { icon:imgMoney, text:"B1 Fund Movement Entry", onClick:() => { setRecordPgmName("Fund Movement Entry") }, href:"#/fbs/FundMoveTranEntry" }) }
                    { addMenuItem("FT0005", { icon:imgDocument, text:"B12 Fund Movement Check List", onClick:() => { setRecordPgmName("Fund Movement Check List") }, href:"#/fbs/FundMoveTranCheckList" }) }
                    { addMenuItem("FT0006", { icon:imgDocument, text:"Fund Movement Audit Log", onClick:() => { setRecordPgmName("Fund Movement Audit Log") }, href:"#/fbs/FundMoveTranLog" }) }
                </MenuItem>
                }
                { <MenuItem icon={imgAccount} text="Trade Entry">
                        { addMenuItem("FT0007", { icon:imgAccount, text:"B2 Trade Entry", onClick:() => { setRecordPgmName("Trade Entry") }, href:"#/fbs/ClientTranEntry" }) }
                        { addMenuItem("FT0008", { icon:imgDocument, text:"B22 Trade Check List", onClick:() => { setRecordPgmName("Trade Check List") }, href:"#/fbs/ClientTranCheckList" }) }
                        { addMenuItem("FT0009", { icon:imgDocument, text:"Trade Audit Log", onClick:() => { setRecordPgmName("Trade Audit Log") }, href:"#/fbs/ClientTranLog" }) }
                    </MenuItem>
                }
                {/* OBx_USER &&  <MenuDivider /> }
                { OBx_USER && <MenuItem icon={imgAccount} text="Option Trade">
                        { addMenuItem("OT0001", { icon:imgAccount, text:"31 Option Trade Entry", onClick:() => { setRecordPgmName("Option Trade Entry") }, href:"#/fbs/OptionTradeEntry" }) }
                </MenuItem> */}
                <MenuDivider />
                { addMenuItem("FT0016", { icon:imgFileBox, text:"BC Closing Price", onClick:() => { setRecordPgmName("Closing Price") }, href:"#/fbs/ClosingUpdate" }) }
                { addMenuItem("FT0017", { icon:imgCalculating, text:"Position Makeup", onClick:() => { setRecordPgmName("Position Makeup") }, href:"#/fbs/PositionMakeup" }) }
                { addMenuItem("FT0018", { icon:imgCalculating, text:"Recalculate Margins", onClick:() => { setRecordPgmName("Recalculate Margins") }, href:"#/fbs/RecalcMargin" }) }

                { addMenuItem("FT0019", { icon:imgFilingOK, text:"BE System End", onClick:() => { setRecordPgmName("System End") }, href:"#/fbs/SystemEnd" }) }

            </Menu>
        }>
            <Button minimal icon={imgTransaction} text="Transaction" />
        </Popover>


        const menuReport =
        <Popover minimal position={Position.BOTTOM_LEFT} content={
            <Menu>
                { addMenuItem("FR0003", { icon:imgDocument, text:"C1 Daily Trading Report", onClick:() => { setRecordPgmName("FBSx Daily Trading Report") }, href:"#/fbs/DailyTradingRpt" }) }
                { addMenuItem("FR0004", { icon:imgDocument, text:"C13 Cash Settlement Report", onClick:() => { setRecordPgmName("Cash Settlement Report") }, href:"#/fbs/CashSettleRpt" }) }
                { addMenuItem("FR0005", { icon:imgDocument, text:"C15 Closed Position Report", onClick:() => { setRecordPgmName("Closed Position Report") }, href:"#/fbs/ClosePositionRpt" }) }
                { addMenuItem("FR0006", { icon:imgDocument, text:"C2 Fund Movement Report", onClick:() => { setRecordPgmName("Fund Movement Report") }, href:"#/fbs/FundMoveRpt" }) }
                { addMenuItem("FR0007", { icon:imgDocument, text:"C3 Open Position Report", onClick:() => { setRecordPgmName("Open Position Report") }, href:"#/fbs/OpenPositionRpt" }) }
                <MenuItem icon={imgDocument} text="Commission">
                    { addMenuItem("FR0008", { icon:imgDocument, text:"C4 Commission & Rebate Report", onClick:() => { setRecordPgmName("FBSx Commission & Rebate Report") }, href:"#/fbs/CommRebateRpt" }) }
                    { addMenuItem("FR0008", { icon:imgDocument, text:"C42 Commission Summary Report", onClick:() => { setRecordPgmName("FBSx Commission Summary Report") }, href:"#/fbs/CommRebateRpt2" }) }
                </MenuItem>    
                { CheckPgmAccess("FR0009") && <MenuItem icon={imgDocument} text="C5 Exceptional Margin Status Report" onClick={() => { setRecordPgmName("Exceptional Margin Status Report") }} href="#/fbs/ExceptMgnRpt" /> }
                { CheckPgmAccess("FR0010") && <MenuItem icon={imgDocument} text="C6 Account Equity & Margin Status Report" onClick={() => { setRecordPgmName("Account Equity & Margin Status Report") }} href="#/fbs/AcctEqMgnRpt" /> }
                {/* { CheckPgmAccess("FR0011") && <MenuItem icon={imgDocument} text="Account Summary Report" onClick={() => { setRecordPgmName("Account Summary Report") }} href="#/fbs/AcctSumRpt" /> } */}
                {/* CheckPgmAccess("FR0011") && addMenuItem("FR0011", { icon:imgDocument,  disabled:(! CheckPgmAccess("FR0011")), text:"C7 Account Summary Report", onClick: () => { setRecordPgmName("Account Summary Report") }, href:"#/fbs/AcctSumRpt" }) */}
                { addMenuItem("FR0011", { icon:imgDocument, text:"C7 Account Summary Report", onClick: () => { setRecordPgmName("Account Summary Report") }, href:"#/fbs/AcctSumRpt" }) }
                { addMenuItem("FR0012", { icon:imgDocument, text:"C8 Margin Call Report", onClick:() => { setRecordPgmName("Margin Call Report") }, href:"#/fbs/MgnCallRpt" }) }

                <MenuDivider />
                <MenuItem icon={imgDocument} text="Statement">
                    { addMenuItem("FR0001", { icon:imgFinancialreport, text:"CS Daily Statement", onClick:() => { setRecordPgmName("FBSx Daily Statement") }, href:"#/fbs/Dstatement" }) }
                    { addMenuItem("FR0002", { icon:imgFinancialreport, text:"CM Monthly Statement", onClick:() => { setRecordPgmName("FBSx Monthly Statement") }, href:"#/fbs/Mstatement" }) }
                    {/* (stmtEncode === "Y") && addMenuItem("FR0001", { icon:imgFinancialreport, text:"Monthly Statement (NO Address)", onClick:() => { setRecordPgmName("FBSx Monthly Statement (NO Address)") }, href:"#/Mstatement2" }) */}
                    {/* addMenuItem("FR0001", { icon:imgDocument, text:"Batch Processing 3 (Save Statement(s))", onClick:() => { setRecordPgmName("Batch 3 Processing") }, href:"#/SBBatch3" }) */}
                    { addMenuItem("FR0012", { icon:imgFinancialreport, text:"Send Email Statement(s)", onClick:() => { setRecordPgmName("FBSx Send Email Statement(s)") }, href:"#/fbs/SentStatement" }) }
                    {/* addMenuItem("FR0022", { icon:imgFinancialreport, text:"Export Webstmt Statement", onClick:() => { setRecordPgmName("Export Webstmt Statement") }, href:"#/ExportWebStmt"  }) */}
                    { addMenuItem("FR0023", { icon:imgFinancialreport, text:"Send Broadcast Document to Client via E-mail", onClick:() => { setRecordPgmName("FBSx Send Broadcast Document to Client via E-mail") }, href:"#/fbs/SendBroadcastEmail" }) }
                </MenuItem>
                <MenuDivider />
                { addMenuItem("FR0014", { icon:imgDocument, text:"CMT Monthly Trading Report (Summary)", onClick:() => { setRecordPgmName("FBSx Monthly Trading Report (Summary)") }, href:"#/fbs/MthTradingRpt" }) }
                <MenuDivider />
                { addMenuItem("FR0033", { icon:imgDocument, text:"CH Settlement Summary Report", onClick: () => { setRecordPgmName("Settlement Summary Report") }, href:"#/fbs/SettleSummaryRpt" } ) }
                { addMenuItem("FR0034", { icon:imgDocument, text:"CF Form IV Entry", onClick:() => { setRecordPgmName("Form IV Entry") }, href:"#/fbs/FormIVEntry" }) }
            </Menu>
        }>
            {/* remark */}
            <Button minimal icon={imgDocument} text="Report" />
        </Popover>


        const menuSysMain =
        <Popover minimal position={Position.BOTTOM_LEFT} content={
            <Menu>
                { addMenuItem("FS0001", { icon:imgDocument, text:"FBSx Configuration", onClick:() => { setRecordPgmName("FBSx Config") }, href:"#/FbsxConfig" }) }
                { addMenuItem("FS0002", { icon:imgsort_asc, text:"Data Upgrade, Reindex", onClick:() => { setRecordPgmName("FBS System Upgrade, Reindex") }, href:"#/Reindex_Fbs" }) }
                <MenuDivider />
                { addMenuItem("FS0003", { icon:imgDocument, text:"Backup , Restore Processing", onClick:() => { setRecordPgmName("FBS Backup/Restore Processing") }, href:"#/FbsBackup" }) }
                { CheckPgmAccess("FR0035") && <MenuItem icon={imgDocument} text="Batch Processing" >
                    { addMenuItem("FR0035", { icon:imgDocument, text:"Batch Processing 51 (Save Report(s))", onClick:() => { setRecordPgmName("FBS Batch 51 Processing") }, href:"#/FBSBatch" }) }
                    { addMenuItem("FR0035", { icon:imgDocument, text:"All Batch Processing", onClick:() => { setRecordPgmName("FBS All Batch Processing") }, href:"#/FBSBatch60" }) }
                </MenuItem>  }
                { addMenuItem("FS0004", { icon:imgDocument, text:"Login Log", onClick:() => { setRecordPgmName("LoginLog") }, href:"#/LoginLog" }) }
                { addMenuItem("FS0009", { icon:imgDocument, text:"Reset Process", onClick:() => { setRecordPgmName("Resetprocess") }, href:"#/Resetprocess" }) }
                { (CheckPgmAccess("FS0006") || CheckPgmAccess("FS0007") ) &&
                    <MenuItem icon={imgAccount} text="User Master / Access">
                        { addMenuItem("FS0006", { icon:imgDocument, text:"User Master", onClick:() => { setRecordPgmName("User Master Setup") }, href:"#/UserMast" }) }
                        { addMenuItem("FS0006", { icon:imgDocument, text:"User List", onClick:() => { setRecordPgmName("User List") }, href:"#/UserMastList" }) }
                        { addMenuItem("FS0006", { icon:imgDocument, text:"User Audit Log", onClick:() => { setRecordPgmName("User Audit Log") }, href:"#/UserMastLog" }) }
                        { addMenuItem("FS0006", { icon:imgDocument, text:"Reset User Password", onClick:() => { setRecordPgmName("Reset User Password") }, href:"#/UserchgPasswd2" }) }

                        { CheckPgmAccess("FS0007") && <MenuDivider /> }
                        { addMenuItem("FS0007", { icon:imgDocument, text:"Group Access", onClick:() => { setRecordPgmName("Group Access") }, href:"#/GroupAccess" }) }
                        { addMenuItem("FS0007", { icon:imgDocument, text:"Group Access List", onClick:() => { setRecordPgmName("Group Access List") }, href:"#/GroupAccessList" }) }
                        { addMenuItem("FS0007", { icon:imgDocument, text:"Group Access Audit Log", onClick:() => { setRecordPgmName("Group Access Audit Log") }, href:"#/GroupAccessLog" }) }
                        
                        { CheckPgmAccess("FS0007") && <MenuDivider /> }
                        { addMenuItem("FS0007", { icon:imgDocument, text:"User Pgm Access", onClick:() => { setRecordPgmName("User Pgm Access") }, href:"#/UserPgmAccess" }) }
                        { addMenuItem("FS0007", { icon:imgDocument, text:"User Pgm Access List", onClick:() => { setRecordPgmName("User Pgm Access List") }, href:"#/UserPgmAccessList" }) }
                        { addMenuItem("FS0007", { icon:imgDocument, text:"User Pgm Access Audit Log", onClick:() => { setRecordPgmName("User Pgm Access Audit Log") }, href:"#/UserPgmAccessLog" }) }
                    </MenuItem> 
                }
                { <MenuItem icon={imgDocument} text="Change User Password" onClick={() => { setRecordPgmName("Change User Password") ; history.push("/UserchgPasswd") }} /> }
                { addMenuItem("FM0051", { icon:imgDocument, text:"Authorizations", onClick:() => { setRecordPgmName("FBSx Authorizations") }, href:"#/fbs/ReqAuthList" }) }
                { addMenuItem("FS0008", { icon:imgDocument, intent:(warnAbout ? Intent.WARNING : "none"), text:"About", onClick:() => { setRecordPgmName("About") }, href:"#/About" }) }
                { addMenuItem("FS0010", { icon:imgDocument, text:"Temp Change Field Length", onClick:() => { setRecordPgmName("Temp Change Field Length") }, href:"#/TempChgField" }) }
                { addMenuItem("FS0011", { icon:imgbuild, text:"Purge Out-Dated Data", onClick:() => { setRecordPgmName("FBSx Purge Out-Dated Data") }, href:"#/fbs/PurgeOutDatedData" }) }
                <MenuItem icon={imgDocument} text="Log Out" onClick={() => { setRecordPgmName("Log Out") }} href="#/login" />
            </Menu>

        }>
            <Button minimal icon={imgbuild } intent={warnSysMain ? Intent.WARNING : "none"} text="System Maintenance" />
        </Popover>
        
    // if (items.length === 0 && allMenuItems.length > 0) setItems(allMenuItems)

    // console.log("allMenuItems", allMenuItems)

    let showuserId = <>
        User ID: { userId }
    </>

    const changeUserLanguage = (lng: string) => {
        (async () => {
            try {
                if (isLoggedIn) {
                    //await svc.post('/userupdatecurrent', {currentLang: lng});
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }

    let lngList = [
        {lngName: "Eng", lng: "en"},
        {lngName: "繁體", lng: "zh-HK"},
        {lngName: "简体", lng: "zh-CN"},
    ]

    return (
        <>
            <Navbar className="No-Print" fixedToTop>
                <Navbar.Group align={Alignment.LEFT}>
                    <Navbar.Heading><Link to="/"><Button minimal icon={imgLogo} text="FBSx" /></Link></Navbar.Heading>
                    <Navbar.Divider />
                    {isLoggedIn ? menuMaster : null}
                    {isLoggedIn ? menuTransaction : null}
                    {isLoggedIn ? menuReport : null}
                    {isLoggedIn ? menuSysMain : null}
                    {isLoggedIn && <>
                    <Navbar.Divider />
                    <MenuSuggest
                        selectedItem={selectedItem}
                        items={items}
                        onItemSelect={(item) => { window.location.assign(item.href || "") }}
                    />
                    </>}
                </Navbar.Group>
                <Navbar.Group align={Alignment.RIGHT}>

                    <Navbar.Divider />
                    <div><b>FBSx</b> {Sys_VerNo}</div>      
                    <Navbar.Divider />
                    {isLoggedIn && <div > {showuserId} </div>} 
                    <MenuDivider />
                    {/*
                    <Popover minimal position={Position.BOTTOM_LEFT} content={
                        <Menu>
                            {lngList.map((lng) => <MenuItem key={lng.lng} icon="translate" text={lng.lngName} onClick={() => {i18n.changeLanguage(lng.lng); changeUserLanguage(lng.lng)}} />)}
                        </Menu>
                    }>
                        <Button className="MenuEnv" minimal icon="translate" text="Language/語言" />
                    </Popover>
                    */}
                    {isLoggedIn && <Tooltip content="Toggle system status window"><Button minimal icon={imgChecklist} onClick={onSystemStatusClick} /></Tooltip>}
                    {isLoggedIn && <Link target="_blank" to="/tasks"><Tooltip content="Tasks"><Button minimal icon={imgTask} /></Tooltip></Link>}
                    {isLoggedIn && <Link to="/login"><Tooltip content="Logout"><Button minimal icon={imgUser} /></Tooltip></Link>}
                </Navbar.Group>
            </Navbar>
        </>
    )
}

interface MenuBar_FBSProps {
    isLoggedIn?: boolean
    onSystemStatusClick?: () => void
}


function MenuBar_CCASS({ isLoggedIn = false } : MenuBar_CCASSProps) {
 
    const [warnSysMain, setwarnSysMain] = useState(false)
    const [warnAbout, setwarnAbout] = useState(false)

    const [Sys_VerNo, setSys_VerNo] = useState("")
    const [userKey, setuserKey] = useState("DEMO")
    const [userId, setuserId] = useState("")
    const [RecordPgmName, setRecordPgmName] = useState("")
    const [IPAddr, setIPAddr] = useState("")

    const [isDark, setIsDark] = useState(document.getElementById("body")?.classList.contains("bp4-dark"))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    document.title = 'POP-RAP VIEWER' 
    
    useEffect(() => {
        if ( isLoggedIn ) {
            (async () => {
                try {
                    // get GsbFlag from SB.XBS
                    const res = await gsb.post('/GsbFlag');
                    //console.log("MenuBar_ce disp user_key: ", res.data.Flag.user_key)
                    GsbFlag = res.data.Flag;
                    //console.log("MenuBar_ce disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                    setSys_VerNo("v"+GsbFlag.Sys_VerNo) 
                    setuserKey(GsbFlag.user_key)
                    setuserId( GsbFlag.UserID)
                    if ( GsbFlag.isProduction == "Y" ) {
                        setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                    } else {
                        setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                    }

                } catch (error) {
                    utils.showError(error)
                }
            })()
        } else {
            (async () => {
                try {
                    const res = await gsb.post('/GsbFlag0');
                    setSys_VerNo("v"+res.data.Flag.Sys_VerNo)
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, isLoggedIn])


    useEffect(() => {
        setwarnSysMain(false)
        setwarnAbout(false)

        ;
        if ( isLoggedIn ) {
            (async () => {
            try {
                const res = await gsb.post('/SysMaint',
                    {   sb_data: {
                        //
                    },
                    cPgmId: "GetIconWarnInfo",
                });
                if ( res.data.ok ) {
                    //console.log("GetIconWarnInfo res.data.data", res.data.data)
                    setwarnSysMain(res.data.data[0].warnAbout) 
                    setwarnAbout(res.data.data[0].warnAbout) 

                }
            } catch (error) {
                utils.showError(error)
            }
        })()


        }
    }, [gsb, isLoggedIn, userId, GsbFlag, Sys_VerNo])
    

    useEffect(() => {
        //console.log("MenuBar cardOpen01", cardOpen01)        
        if ( cardOpen01.substr(0,17) === "cardOpen01-Theme8" ) {
            document.getElementById("body")?.classList.add("bp4-dark")
            setIsDark(true)
        } else {
            document.getElementById("body")?.classList.remove("bp4-dark")
            setIsDark(false)
        }
    
    
    }, [gsb, isLoggedIn, userId, GsbFlag, cardOpen01])
    

    useEffect(() => {
        if ( isLoggedIn && RecordPgmName.length > 0 ) {
            (async () => {
                try {
                    // get GsbFlag from SB.XBS
                    const res = await gsb.post('/PgmEntry', {
                        cPgmName: RecordPgmName,
                        cIPAddr: IPAddr,
                    });
                    setRecordPgmName("")
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, RecordPgmName, isLoggedIn])
    

    const imgLogo = <img className="AppLogo" src={svgLogo} alt="Logo" />
    const imgAccount = <img className="MenuIcon" src={svgAccount} alt="Account" />
    const imgMaster = <img className="MenuIcon" src={svgMaster} alt="Master" />
    const imgDocument = <img className="MenuIcon" src={svgDocument} alt="Document" />
    const imgzipDocument = <img className="MenuIcon" src={svgZip} alt="Zipdocument" />
    const imgTransaction = <img className="MenuIcon" src={svgInput} alt="Transaction" />
    const imgImport = <img className="MenuIcon" src={svgImport} alt="Import" />
    const imgUser = <img className="MenuIcon" src={svgUser} alt="Login" />
    const imgTask = <img className="MenuIcon" src={svgTask} alt="Task" />
    const imgbuild = <img className="MenuIcon" src={svgbuild} alt="Utility" />
    const imgsort_asc = <img className="MenuIcon" src={svgsort_asc} alt="sort" />
    const history = useHistory()

        const menuReport =
        <Popover minimal position={Position.BOTTOM_LEFT} content={
            <Menu>
                <MenuItem icon={imgImport} text=" CCASS Import" onClick={() => { setRecordPgmName("CCASS Import")}} href="#/ImportCCASSxRpt" />
                <MenuItem icon={imgDocument} text=" CCASS Report" onClick={() => { setRecordPgmName("CCASS Report")}} href="#/CCASSRpt" />
            </Menu>
        }>
            {/* remark */}
            <Button minimal icon={imgDocument} text="Report" />
        </Popover>


        const menuSysMain =
        <Popover minimal position={Position.BOTTOM_LEFT} content={
            <Menu>
                <MenuItem icon={imgDocument} intent={warnAbout ? Intent.WARNING : "none"} text="About" onClick={() => { setRecordPgmName("About") }} href="#/About" />
                <MenuItem icon={imgDocument} text="Log Out" onClick={() => { setRecordPgmName("Log Out") }} href="#/login" />
            </Menu>

        }>
            <Button minimal icon={imgbuild } intent={warnSysMain ? Intent.WARNING : "none"} text="System Maintenance" />
        </Popover>
        

    let showuserId = <>
        User ID: { userId }
    </>

    const changeUserLanguage = (lng: string) => {
        (async () => {
            try {
                if (isLoggedIn) {
                    //await svc.post('/userupdatecurrent', {currentLang: lng});
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }

    let lngList = [
        {lngName: "Eng", lng: "en"},
        {lngName: "繁體", lng: "zh-HK"},
        {lngName: "简体", lng: "zh-CN"},
    ]

    return (
        <>
            <Navbar className="No-Print" fixedToTop>
                <Navbar.Group align={Alignment.LEFT}>
                    <Navbar.Heading><Link to="/"><Button minimal icon={imgLogo} text="RAP Viewer" /></Link></Navbar.Heading>
                    <Navbar.Divider />
                    {isLoggedIn ? menuReport : null}
                    {isLoggedIn ? menuSysMain : null}
                </Navbar.Group>
                <Navbar.Group align={Alignment.RIGHT}>

                    <Navbar.Divider />
                    <div><b>RAP Viewer</b> {Sys_VerNo}</div>      
                    <Navbar.Divider />
                    {isLoggedIn && <div > {showuserId} </div>} 
                    <MenuDivider />
                    {/*
                    <Popover minimal position={Position.BOTTOM_LEFT} content={
                        <Menu>
                            {lngList.map((lng) => <MenuItem key={lng.lng} icon="translate" text={lng.lngName} onClick={() => {i18n.changeLanguage(lng.lng); changeUserLanguage(lng.lng)}} />)}
                        </Menu>
                    }>
                        <Button className="MenuEnv" minimal icon="translate" text="Language/語言" />
                    </Popover>
                    */}
                    {isLoggedIn && <Link target="_blank" to="/tasks"><Tooltip content="Tasks"><Button minimal icon={imgTask} /></Tooltip></Link>}
                    {isLoggedIn && <Link to="/login"><Tooltip content="Logout"><Button minimal icon={imgUser} /></Tooltip></Link>}
                </Navbar.Group>
            </Navbar>
        </>
    )
}

interface MenuBar_CCASSProps {
    isLoggedIn?: boolean
}

export default App;
